import React, { useState, useEffect, useRef } from "react";
import {
    makeStyles,
    Theme,
    createStyles,
    withStyles,
} from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import RemoveIcon from "@mui/icons-material/Remove";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "../react-sliding-pane.css";
import "./index.sass";
import {

    Grid,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    IconButton,
    FormGroup,
} from "@material-ui/core";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Chip, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from '@mui/material/Checkbox';
import DialogContentText from "@mui/material/DialogContentText";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {
    checkGeoFenceArea,
    getPinCode,
    getPackage,
    createNewBooking,
    getCoupons,
    getLeadsNew,
    getLeadDetails,
    resetLeadDetails,
    getRedCoing,
    getCenterInfo,
    checkGeoFenchMapMyIndia,
    getMapMyIndiaAccessToken,
    addUniqueCustomer,
    getUserDetails,

} from "../../../actions/OffLineSupportActions";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { GENDER_CHOICE } from "../../constant";
import { useWindowSize } from "../../../../utils/hooks/useWindowSize";
import "./index.sass";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import EstimateTestModel from "../../../pages/EstimateTest/estimateTestNew";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "red",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "red",
    },
}));

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#924A91",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
            padding: "5px",
            textTransform: "capitalize",
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

const useStyles = makeStyles(() =>
    createStyles({
        buttonContainer: {
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        table: {
            maxWidth: "100%",
            margin: "auto",
        },
        content: {
            width: "100%",
            flexGrow: 21,
            marginTop: "70px",
        },
        content_two: {
            width: "100%",
            flexGrow: 21,
        },
        contentTable: {
            // width: "100%",
            padding: "20px 10px 10px 10px",
            background: "#ffffff",
            // margin: "10px",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        },
        packageLink: {
            color: "#ffffff",
            textDecoration: "none",
        },
        tableContainer: {
            maxWidth: "100%",
            overflowX: "auto",
        },
        dialog: {
            zIndex: 1,
        },
        customTooltip: {
            minWidth: "600px",
            width: "600px",
            backgroundColor: "white",
            padding: "10px",
            fontSize: "16px",
        },
    })
);

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: "50vh",
        },
    },
};

interface Props {
    getCampCoupons: any;
    campCoupon: any;
    getRefDoctor: any;
    refDoctor: any;
    getCenterInfo: any;
    centerInfo: any;
    getPinCode: any;
    pin_code: any;
    getPackage: any;
    packageList: any;
    couponList: any;
    getCoupons: any;
    createNewBooking: any;
    getLeadsNew: any;
    get_leads_new: any;
    getLeadDetails: any;
    lead_details: any;
    resetLeadDetails: any;
    createBooking: any;
    loading: boolean;
    checkGeoFenceArea: any;
    checkGeoFenceStatus: boolean;
    getRedCoing: any;
    redCoin: any;
    checkGeoFenchMapMyIndia: any;
    geoFencesMapMyIndia: any;
    mapmyindiaAccessToken: any;
    getMapMyIndiaAccessToken: any;
    getGeCode: any;
    getCenterGeCode: any;
    getLedgerBalance: any;
    clientLedgerBalance: any;
    packagesById: any;
    createHistopathologyBooking: any;
    createNbsBooking: any;
    userDetails: any;
    tubePackageData: any;
    getTubePackages: any;
    getTubeByBooking: any;
    getValidBarcode: any;
    validBarcode: any;
    addUniqueCustomer: Function;
    add_unique_customer: any;
    resetUniqueCustomer: Function;
    putFamilyMemberBookingForUpdate: Function;
    familyMemberUpdateData: any;
    resetFamilyMemberBooking: Function;
    createBookingNewFlow: Function;
    crete_booking_new_flow: any;
    resetCreateNewBookingFlow: Function;
    resetLeads: Function;
    MarkerFormCreate: any;
    validateCreateBooking: any;
    validateBooking: any;
    getUserDetails: Function;
    updateQuadrupleForm: Function;
    getPackageQuestion: Function;
    packageQuestion: any;
    postPackageAnswer: Function;
    getLeadSubscriptionsData: any
    leadSubscriptionsData: any
    getCheckNumberIsVipOrNot: any
    checkSubscription: any
    ValidateOfflineDuplicateBooking: any
    validationResult: any
}

const CCBookingIndexFour: React.FC<Props> = ({
    getCampCoupons,
    campCoupon,
    getRefDoctor,
    refDoctor,
    getCenterInfo,
    centerInfo,
    getPinCode,
    pin_code,
    packageList,
    getPackage,
    couponList,
    getCoupons,
    createNewBooking,
    getLeadsNew,
    get_leads_new,
    getLeadDetails,
    lead_details,
    resetLeadDetails,
    createBooking,
    checkGeoFenceArea,
    checkGeoFenceStatus,
    getRedCoing,
    redCoin,
    loading,
    checkGeoFenchMapMyIndia,
    geoFencesMapMyIndia,
    mapmyindiaAccessToken,
    getMapMyIndiaAccessToken,
    getGeCode,
    getCenterGeCode,
    getLedgerBalance,
    clientLedgerBalance,
    packagesById,
    createHistopathologyBooking,
    createNbsBooking,
    userDetails,
    tubePackageData,
    getTubePackages,
    getTubeByBooking,
    getValidBarcode,
    validBarcode,
    addUniqueCustomer,
    add_unique_customer,
    resetUniqueCustomer,
    putFamilyMemberBookingForUpdate,
    familyMemberUpdateData,
    resetFamilyMemberBooking,
    createBookingNewFlow,
    crete_booking_new_flow,
    resetCreateNewBookingFlow,
    resetLeads,
    MarkerFormCreate,
    validateCreateBooking,
    validateBooking,
    getUserDetails,
    updateQuadrupleForm,
    getPackageQuestion,
    packageQuestion,
    postPackageAnswer,
    getLeadSubscriptionsData,
    leadSubscriptionsData,
    getCheckNumberIsVipOrNot,
    checkSubscription,
    ValidateOfflineDuplicateBooking,
    validationResult,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const dataLead = location.state;
    const hotLeadstateData = location.hotLeadstate;
    const FollowUpLeadsData = location.FollowUpLeadsState;
    const FollowUpLeadsMobileNumber = location.FollowUpLeadsMobile;

;

    const [inputList, setInputList] = useState<any>([
        {
            uploadPrescription: "",
            customerId: "",
            customerDesignation: "",
            designation: "",
            customerName: "",
            customerAge: "",
            customerOldAge: "",
            customerGender: "",
            customerPackage: [],
            customerAddOnPackage: [],
            customerTest: [],
            packagePrice: 0,
            dateOfBirth: "",
            is_prescribed: "",
            bookingFor: "",
            oldBookingFor: "",
            passport: "",
            aadhar: "",
            oldNameUHID: "",
            isSelectedMember: false,
            freeGlucoseFastingTestDisabled: false,
            freeGlucoseFastingRandomTestDisabled: false,
            freeHbA1cTestDisabled: false,
            lastBookingDate: "",
            sample_volume: 0,
            previousBookedPackages: [],
            tubes: [],
            ref_doctor: "",
            isEstimateAdded: false,
            hivform: {
                ref_doctor_name: "",
                ref_doctor_phone: "",
                ref_by_doc_or_self: "doctor",
                adhaar_card: "",
                adhaar_number: "",
                counselling_date: "",
                counsellor_name: "",
                report_can_be_seen_by: [],
            },
            isValidEmail: true,
            doctorNumber: true,
            exomeForm: {
                dr_name: "",
                dr_phonenumber: "",
                dr_email: "",
                clinical_history: "",
                pre_test_counsellor: "",
            },
            allergyForm: [],
            genomicsForm: {},
            showBloodRelationText: false,
            isBloodRelation: false,
            isEnableGenomicsFormButton: false,
            isEnableBiomarker: false,
            isEnableQuadruple: false,
            quadrupleFormData: {},
            bioMarkerFormData: {},
        },
    ]);

    const [environment, setEnvironment] = useState<String>("");
    const [openGenomicsModal, setOpenGenomicsModal] = useState<any>(null)
    const [showBloodRelationError, setShowBloodRelationError] = useState<boolean>(false);
    const [centre, setCentre] = useState<any>("");
    const [centreSubType, setCentreSubType] = useState<any>("");
    const [centreCity, setCentreCity] = useState<any>("");
    const [gecode, setGecode] = useState<any>("");
    const [invalidPackages, setInvalidPackages] = useState<any>([]);
    const [agree, setAgree] = useState<boolean>(true);
    const [pincode, setPinCode] = useState<String>("");
    const [zoneName, setZoneName] = useState<String>("");
    const [bookingId, setBookingId] = useState<any>();
    const [customer_phonenumber, setCustomer_phonenumber] = useState<String>("");
    const [customer_alternatenumber, setCustomer_alternatenumber] =
        useState<String>("");
    const [customer_whatsapppnumber, setCustomer_whatsapppnumber] =
        useState<String>("");
    const [customer_address, setCustomer_address] = useState<String>("");
    const [customer_email, setCustomer_email] = useState<String>("");
    const [customer_landmark, setCustomer_landmark] = useState<string>("");
    const [customerLatitude, setCustomerLatitude] = useState<any>("");
    const [customerLongitude, setCustomerLongitude] = useState<any>("");
    const [customer_areapincode, setCustomer_areapincode] = useState<Number>(0);
    const [customer_areaname, setCustomer_areaname] = useState<String>("");
    const [customer_city, setCustomer_city] = useState<String>("");
    const [customer_aadhar, setCustomer_aadhar] = useState<String>("");
    const [customer_id, setCustomer_id] = useState<any>("");
    const [passport, setPassport] = useState<String>("");
    const [price, setPrice] = useState<any>(0);
    const [discount, setDiscount] = useState<any>(0);
    const [totalPrice, setTotalPrice] = useState<any>(0);
    const [netPrice, setNetPrice] = useState<any>(0);
    const [coupon, setCoupon] = useState<Number>(0);
    const [couponCode, setCouponCode] = useState<string>("");
    const [campCouponCode, setCampCouponCode] = useState<string>("");
    const [cityId, setCityId] = useState<any>("");
    const [is_pincode, setIsPincode] = useState<boolean>(true);
    const [packageKey, setPackageKey] = useState<any>(0);
    const [validateNbsStatus, setValidateNbsStatus] = useState<boolean | null>(
        false
    );
    const [remarks, setRemarks] = useState<string>("");
    const [openMaternalForm, setOpenMaternalForm] = useState<boolean>(false);
    const [openBioMarkerForm, setOpenBioMarkerForm] = useState<boolean>(false);
    const [validateHistoStatus, setValidateHistoStatus] = useState<boolean | null>(false);
    const [validateQuadrupleForm, setValidateQuadrupleForm] = useState<boolean>(false);
    const [openQuadrupleForm, setOpenQuadrupleForm] = useState<boolean>(false);
    const [validateBiomarkerLatestStatus, setValidateBiomarkerLatestStatus] = useState<boolean>(false);
    const [mobileValidation, setMobileValidation] = useState({
        customer_alternatenumber: true,
        customer_phonenumber: true,
        customer_whatsapppnumber: true,
    });
    const [validateMaternalStatus, setValidateMaternalStatus] = useState<
        boolean | null
    >(false);
    const [validateHivStatus, setValidateHivStatus] = useState<boolean | null>(
        false
    );
    const [openLeadModal, setOpenLeadModal] = useState<any>(false);
    const [openLeadModalFlag, setOpenLeadModalFlag] = useState<any>(false);
    const [zoneId, setZoneId] = useState<any>("");
    const [notificationData, setNotificationData] = useState<any>("");
    const timer = useRef<any>(0);
    const [addressLine2, setAddressLine2] = useState<string>("");
    const [favoritePlace, setFavoritePlace] = useState<any>("");
    const [openLocationModal, setOpenLocationModal] = useState<boolean>(false);
    const [bookingEnabled, setBookingEnabled] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    // const [bookingFor, setBookingFor] = useState<string>("");
    const [isPaneOpen, setPaneOpen] = useState<boolean>(false);
    const [singlePackage, setSinglePackage] = useState<any>({});
    const [mobError, setMobError] = React.useState<string>("");
    const [altError, setAltError] = React.useState<string>("");
    const [whatsError, setWhatsError] = React.useState<string>("");
    const [tncPerCentage, setTnPercentage] = useState<string>("");
    const [couponMessage, setCouponMessage] = useState<string>("");
    const [campCouponData, setCampCouponData] = useState<any>("");
    const [tncMessage, setTncMessage] = useState<string>("");
    const [paid, setPaid] = useState<any>(0);
    const [diagnosticFee, setDiagnosticFee] = useState<any>(0);
    const [diagnosticFeeStatus, setDiagnosticsFeeSatus] =
        useState<boolean>(false);
    const [due, setDue] = useState<any>(0);
    const [referringDoctor, setReferringDoctor] = useState<any>("");
    const [paymentInfo, setPaymentInfo] = useState<any>([]);
    const [uhidModalOpen, setUhidmodalOpen] = useState<boolean>(false);
    const [lead_customer_phonenumber, setLeadCustomer_phonenumber] =
        useState<string>();
    const [lead_customer_whatsapppnumber, setLeadCustomer_whatsapppnumber] =
        useState<string>();
    const [relevantClinicalHistory, setRelevantClinicalHistory] =
        useState<any>("");
    const [disableBooking, setDisableBooking] = useState<boolean>(false);
    const [clinicalDiagnosis, setClinicalDiagnosis] = useState<any>("");
    const [radiologyFindings, setRadiologyFindings] = useState<any>("");
    const [operativeFindings, setOperativeFindings] = useState<any>("");
    const [urgentBooking, setUrgentBooking] = useState<boolean>(false);
    const [coupleBookingTest, setCoupleBookingTest] = useState<any>([
        "MD176",
        "MD137",
        "MD144",
        "CG031",
        "MD136",
        "MD143",
    ]);
    const [disableCoupleBookingTest, setDisableCoupleBookingTest] = useState<boolean>(false);
    const [coupleBookingAlert, setCoupleBookingAlert] = useState<boolean>(false);
    const [dataNbs, setDataNbs] = useState<any>({
        birth_time: "",
        birth_time_hh: "00",
        birth_time_mm: "00",
        consanguinity: "",
        baby_weight: "",
        baby_admitted_in_nicu: "",
        blood_transfusion: "",
        transfusion_date: "",
        gestational_age_weeks: "",
        gestational_age_days: "",
        birth_order: "",
        type_of_feed: "",
        history: "",
        ch: "",
        cah: "",
        g6pd: "",
        gal: "",
        cp: "",
        pku: "",
        bio: "",
        nbs_collection_date: "",
        nbs_collection_time: "",
    });
    const [openNbsModal, setOpenNbsModal] = useState<boolean>(false);
    const [validateGutStatus, setValidateGutStatus] = useState<boolean | null>(false);
    const [perPackNbs, setPerPackNbs] = useState<any>(1);
    const [perPackArr, setPerPackArr] = useState<any>([]);
    const [sizeofbiopsy, setSizeOfBiopsy] = useState<string>("");
    const [dateOfProcedure, setDateOfProcedure] = useState<string>("");
    const [refDoctorName, setRefDoctorName] = useState<string>("");
    const [refDoctorNumber, setRefDoctorNumber] = useState<string>("");
    const [tempCode, setTempCode] = useState<string>("");
    const [biospyPackageName, setBiospyPackageName] = useState<string>("");
    const [biospyPackageCode, setBiospyPackageCode] = useState<string>("");
    const [biospySampleName, setBiospySampleName] = useState<any>("");
    const [couponDeductFrom, setCouponDeductFrom] = useState<string>("center");
    const [couponAmount, setCouponAmount] = useState<any>("");
    const [discountApplied, setDiscountApplied] = useState<boolean>(false);
    const [biospyTrueOrFalse, setBiospyTrueOrFalse] = useState<any>("");
    const [countNumberOfPatients, setCountNumberOfPatients] =
        useState<any>(false);
    const [currUser, setCurrUser] = useState<any>("");
    const [validationStatus, setValidationStatus] = useState<{
        [key: number]: {
            histoStatus: boolean, nbsStatus: boolean, maternalStatus: boolean, hivStatus: boolean, gutStatus: boolean, exomeStatus: boolean,
            bioMarkerStatus: boolean, quadMarkerStatus: boolean
        }
    }>({});

    const [centerName, setCenterName] = useState<any>("");
    const [visitID, setVisitID] = React.useState<any>();
    const [tubeData, setTubeData] = useState<any>([]);
    const [filteredData, setFilteredData] = useState<any>([]);

    const [search, setSearch] = useState<string>("");
    const [mobNumErr, setMobNumErr] = useState<string>("");
    const [deactiveInputs, setDeactivateInputs] = useState<boolean>(false);
    const [apiCustomerRes, setApiCustomerRes] = useState<string>("");
    const [indexToInsertTube, setIndexToInsertTube] = useState<number | null>(
        null
    );
    const [file1, setFile1] = React.useState<any>("");
    const [file2, setFile2] = React.useState<any>("");
    const [file3, setFile3] = React.useState<any>("");
    const [file4, setFile4] = React.useState<any>("");
    const [imgSrc, setImgSrc] = useState<any>("");
    const [imgSrc2, setImgSrc2] = useState<any>("");
    const [imgSrc3, setImgSrc3] = useState<any>("");
    const [imgSrc4, setImgSrc4] = useState<any>("");
    const [customerFirstName, setCustomerFisrtName] = useState<any>("");
    const [customerLastName, setCustomerLastName] = useState<any>("");

    const [openModalForAllergyForm, setOpenModalForAllergyForm] = useState<boolean>(false);
    const [CustomerId, setCustomerId] = useState<any>("")
    const [file, setFile] = useState<any>("");
    // const nameSplit = (type: string, customer_Name:string) => {
    //   if (customer_Name) {
    //     const splittedName = customer_Name.split(" ");
    //     if (type === "firstName") return splittedName[0];
    //     if (type === "lastName") return splittedName.splice(1).join("");
    //    }
    // };

    const [dataQuadruple, setDataQuadruple] = useState<any>({
        patient_details: {
            patient_name: inputList[0].customerName || "",
            customer_dob: "",
            customer_age: "",
            height: "",
            weight: "",
            blood_group: "",
            address: "",
            email_id: "",
            ethnicity: "",
            bmi: "",
            nature_habbit: [],
            nature_habit_other: "",
            insulin: "",
            other_habit: "",
        },

        pregnancy_history_details: {
            lmp_date: "",
            procedure_type: "",
            assisted_reproduction_egg: "",
            donor_dob: "",
            parity: "",
            extraction_egg_date: "",
            transfer_egg_date: "",
            first_trimester: "",
            second_trimester: "",
            other_test_package: "",
            previous_history: "",
            present_pregnacy: "",
            twin_type: "",
            other_history: "",
            sperm: "",
            usg_date: "",
            nature_of_conception: "",
        },

        clinical_details: {
            doctor_name: "",
            doctor_mobile: "",
            doctor_city: "",
            fmf_id: "",
            clinic_id: "",
            fmf_operator: "",
            hospital_name: "",
            operator_contact_number: "",
            operator_fmf_id: "",
            operator_email: "",
        },

        blood_group_details: {
            left_systolic_bp: "",
            left_diastolic_bp: "",
            right_systolic_bp: "",
            right_diastolic_bp: "",
        },

        ultrasound_details: {
            date_of_usg: "",
            bpdmm: "",
            bpd: "",
            Acmm1: "",
            ac: "",
            hm: "",
            hcmm1: "",
            hc: "",
            Flmm: "",
            crl: "",
            nt: "",
            intracranial_translucency: "",
            ductus_venosus: "",
            tricuspid_doppler: "",
            clinician_signature: "",
            attachment_one: "",
            attachment_two: "",
            attachment_three: "",
            nb: "",
            utpi: "",
            hcga: "",
            utpi_right: "",
        },

        twinA: {
            crl: "",
            nt: "",
            fhr: "",
            nasal_bone: "",
            bpd: "",
            ac: "",
            hc: "",
            fl: "",
            nb: "",
            uapi_left: "",
            uapi_right: "",
            intracranial_translucency: "",
            ductus_venosus: "",
            tricuspid_doppler: "",
        },
        twinB: {
            crl: "",
            nt: "",
            fhr: "",
            nasal_bone: "",
            bpd: "",
            ac: "",
            hc: "",
            fl: "",
            nb: "",
            uapi_left: "",
            uapi_right: "",
            intracranial_translucency: "",
            ductus_venosus: "",
            tricuspid_doppler: "",
        },
        Clinician_sign: {
            clinician_signature: "",
        },
    });

    const [dataMaternal, setDataMateranl] = useState<any>([{
        dob: "",
        customer_dob: "",
        height: "",
        weight: "",
        lmp_date: "",
        date_of_usg: "",
        bpdmm: "",
        bpd: "",
        Acmm1: "",
        ac: "",
        hm: "",
        hcmm1: "",
        hc: "",
        Flmm: "",
        parity: "",
        doctor_name: "",
        doctor_mobile: "",
        number_of_children: "",
        previous_history: "",
        present_pregnacy: "",
        present_pregenancy: "",
        doctor_number: "",
        prev_baby: "",
        attachment_one: "",
        attachment_two: "",
        attachment_three: "",
        procedure_type: "",
        natural: "",
        assisted: "",
        para: "",
        abortion: "",
        live: "",
        gravida: "",
        customerAge: "",
        customerOldAge: "",
        donor_dob: "",
        extraction_egg_date: "",
        transfer_egg_date: "",
        crl: "",
        nt: "",
        sself: "",
        donor: "",
        sperm: "",
        usgDetailsBody: "",
        natureOfConception: "",
        assisted_reproduction_egg: "",
        right_hand_bp: "",
        left_hand_bp: "",
        measurement_date: "",
        prescription: "",
        nb: "",
        smoking_nature: "",
        alcoholic_nature: "",
        diabetic_nature: "",
        other_nature: "",
        insulin: "",
        other_nature_description: "",
        fmf: "",
        utpi_char: "",
        hcga_char: "",
        utpi_right: "",
    }]);

    // const disbaleBooking2 = (loading || 
    //   disableBooking || 
    //   showBloodRelationError ||

    //   // Validate biopsy package name
    //   (validateHistoStatus && !biospyPackageName) ||

    //   // Validate biomarker latest status
    //   (validateBiomarkerLatestStatus && (
    //     !dataQuadruple?.patient_details?.customer_dob ||
    //     !dataQuadruple?.patient_details?.nature_of_conception ||
    //     !dataQuadruple?.patient_details?.lmp_date ||
    //     !dataQuadruple?.patient_details?.previous_history ||
    //     !dataQuadruple?.patient_details?.present_pregnacy ||
    //     !dataQuadruple?.patient_details?.other_history ||
    //     !dataQuadruple?.patient_details?.date_of_usg ||
    //     !dataQuadruple?.patient_details?.crl ||
    //     !dataQuadruple?.patient_details?.attachment_one
    //   )) ||

    //   // Validate quadruple form data
    //   (validateQuadrupleForm && (
    //     !dataMaternal?.dob ||
    //     !dataMaternal?.weight ||
    //     !dataMaternal?.lmp_date ||
    //     !dataMaternal?.nature_of_conception ||
    //     !dataMaternal?.date_of_usg ||
    //     !dataMaternal?.prev_baby ||
    //     !dataMaternal?.previous_history ||
    //     !dataMaternal?.present_pregenancy ||
    //     !dataMaternal?.crl ||
    //     !dataMaternal?.attachment_one
    //   )) ||

    //   // Validate relevant clinical history
    //   (validateHistoStatus && !relevantClinicalHistory) ||

    //   // Validate NBS status
    //   (validateNbsStatus && (perPackNbs !== perPackArr?.length)) ||

    //   // Validate due date
    //   due < 0 ||

    //   // Validate payment info
    //   !(
    //     paymentInfo.length !== 0 &&
    //     paymentInfo.some((val:any) => val.isChecked === true)
    //   ))

    const [disbaleBooking2, setDisbaleBooking2] = useState<boolean>(true)
    // useEffect(() => {

    //   const state = (loading ||
    //     disableBooking ||
    //     (validateHistoStatus && !biospyPackageName ? true : false) ||
    //     // (validateMaternalStatus === true && !dataMaternal.date_of_usg
    //     //   ? true
    //     //   : false) ||
    //     (validateHistoStatus && !relevantClinicalHistory
    //       ? true
    //       : false) ||
    //     (validateNbsStatus === true &&
    //       perPackNbs !== perPackArr?.length) ||
    //     (validateBiomarkerLatestStatus && (
    //       inputList.map((x: any) => (x.isEnableBiomarker &&
    //         !x?.bioMarkerFormData?.patient_details?.customer_dob ||
    //         !x?.bioMarkerFormData?.pregnancy_history_details?.nature_of_conception ||
    //         !x?.bioMarkerFormData?.pregnancy_history_details?.lmp_date ||
    //         !x?.bioMarkerFormData?.pregnancy_history_details?.previous_history ||
    //         !x?.bioMarkerFormData?.pregnancy_history_details?.present_pregnacy ||
    //         !x?.bioMarkerFormData?.pregnancy_history_details?.other_history ||
    //         !x?.bioMarkerFormData?.ultrasound_details?.date_of_usg ||
    //         !x?.bioMarkerFormData?.ultrasound_details?.crl ||
    //         !x?.bioMarkerFormData?.ultrasound_details?.attachment_one
    //       )))) ||
    //     (validateQuadrupleForm &&
    //       (
    //         inputList.map((x: any) => (x.isEnableQuadruple && (
    //           !x?.quadrupleFormData?.dob ||
    //           !x?.quadrupleFormData?.weight ||
    //           !x?.quadrupleFormData?.lmp_date ||
    //           !x?.quadrupleFormData?.nature_of_conception ||
    //           !x?.quadrupleFormData?.date_of_usg ||
    //           !x?.quadrupleFormData?.previous_history ||
    //           !x?.quadrupleFormData?.present_pregenancy ||
    //           !x?.quadrupleFormData?.crl ||
    //           !x?.quadrupleFormData?.attachment_one
    //         )))
    //       ) ||
    //       (validateNbsStatus === true &&
    //         perPackNbs !== perPackArr?.length) ||
    //       due < 0 ||
    //       !(
    //         paymentInfo.length !== 0 &&
    //         paymentInfo.filter((val: any) => val.isChecked === true)
    //           .length > 0
    //       ))
    //     )
    //       setDisbaleBooking2(state)

    // }, [loading, paymentInfo, validateNbsStatus, perPackNbs, validateQuadrupleForm, dataMaternal
    //   , validateBiomarkerLatestStatus, dataQuadruple, validateHistoStatus, biospyPackageName,
    //   disableBooking
    // ])


    const [checkboxChecked, setCheckboxChecked] = useState([]);
    const [openTestModal, setopenTestModal] = useState<boolean>(false);
    const handleTestClick = () => {
        setopenTestModal(true);
    };

    const handleSearch = (e: React.ChangeEvent<{ value: string }>) => {
        setSearch(e.target.value?.replace(/[^0-9]/g, "")?.slice(0, 10) as string);
    };
    const handleCheckboxChange = (checkboxType: string, index: number) => {
        const newCheckboxChecked: any = [...checkboxChecked];
        if (newCheckboxChecked[index] === checkboxType) {
            newCheckboxChecked[index] = '';
        } else {
            newCheckboxChecked[index] = checkboxType;
        }
        setCheckboxChecked(newCheckboxChecked);
    };
    // deactiveInputs

    const regex = /^[6-9]\d{9}$/;

    useEffect(() => {
        getUserDetails();
    }, []);

    //Exome/Genomics
    const [validateExomeStatus, setValidateExomeStatus] = useState<boolean | null>(
        false
    );
    const verifyEmail = (index: number) => {
        const email = inputList[index]?.exomeForm?.dr_email || '';
        const nameRegex =
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        const isValidEmail = email.length > 0 && nameRegex.test(email.toString());
        const updatedList = [...inputList];
        updatedList[index].isValidEmail = isValidEmail;
        setInputList(updatedList);
    };
    const verifyMobileNew = (index: any) => {
        const number = inputList[index]?.exomeForm?.dr_phonenumber || '';
        const mobileRegEx = /^[6-9]\d{9}$/;
        const updatedList = [...inputList];
        if (
            number &&
            !mobileRegEx.test(number.toString())
        ) {
            updatedList[index].doctorNumber = false;
            setInputList(updatedList);
        }
    };

    useEffect(() => {
        let arr: any = [];
        let arr2: any = [...inputList];
        packageQuestion?.map((data: any, index: any) => {
            if (data.is_allergy) {
                arr.push({
                    question_text: data.question,
                    question: data.id,
                    question_type: data.question_type,
                    checked: "",
                    unique_customer:
                        inputList.length > 0 ? inputList[currUser]?.customerId : "",
                    answer: "",
                });
            }
        });
        if (currUser !== "" && arr2.length > 0) {
            arr2[currUser].allergyForm = arr;
            setInputList(arr2);
        }
    }, [packageQuestion]);

    useEffect(() => {
        if (search.length) {
            if (regex.test(search)) {
                setMobNumErr("");
                setDeactivateInputs(true);
            } else {
                setMobNumErr("Please enter a valid mobile number");
                setDeactivateInputs(false);
            }
            // if(inputList.length > 0){

            // }
        } else {
            setMobNumErr("");
            setDeactivateInputs(false);
        }
    }, [search]);

    useEffect(() => {
        if (search.length === 10 && mobNumErr === "") {
            let body = {
                search_by: "call_id",
                value: search,
            };
            (async () => {
                // await getLeadsNew(body, "number=true");
                await getLeadsNew(body, `mobile=${search}`);
             
            })();
        }
    }, [search, mobNumErr]);

    
    const [isDuplicateTube, setIsDuplicateTube] = useState<boolean>(false);

    useEffect(() => {
        let tempInputList: any = [...inputList];
        if (tubeData.length > 0 && indexToInsertTube !== null) {
            let collectedTubeIds: number[] = [];
            if (
                tempInputList[indexToInsertTube].tubes &&
                tempInputList[indexToInsertTube]?.tubes?.length > 0
            ) {
                tempInputList[indexToInsertTube]?.tubes.forEach((list: any) => {
                    collectedTubeIds.push(list.id);
                });
            }
            const finTubeData =
                tubeData.length > 0 &&
                tubeData.reduce((acc: any, list: any) => {
                    if (collectedTubeIds.includes(list.id)) {
                        let tempTube = tempInputList[indexToInsertTube]?.tubes.find(
                            (t: any) => t.id === list.id
                        );
                        acc.push(tempTube);
                    } else {
                        acc.push(list);
                    }
                    return acc;
                }, []);
            tempInputList[indexToInsertTube].tubes = finTubeData;
        }

        let tempAccBarcodeZero: string[] = [];
        if (tempInputList && tempInputList.length > 0) {
            tempInputList.forEach((list: any) => {
                if (list.tubes && list.tubes.length > 0) {
                    for (const obj of list.tubes) {
                        tempAccBarcodeZero.push(obj.code);
                    }
                }
            });
        }

        let newTempInputList: Array<any> = [];
        tempInputList.forEach((main: any) => {
            let innerNewTempInputList: any = [];
            if (main.tubes && main.tubes.length > 0) {
                for (const obj of main.tubes) {
                    if (tempAccBarcodeZero.includes(obj.code)) {
                        innerNewTempInputList.push({
                            ...obj,
                        });
                    } else {
                        innerNewTempInputList.push({
                            ...obj,
                            err: "",
                        });
                    }
                }
            }

            if (innerNewTempInputList.length > 0) {
                newTempInputList.push({
                    ...main,
                    tubes: innerNewTempInputList,
                });
            } else {
                newTempInputList.push({
                    ...main,
                    tubes: innerNewTempInputList,
                });
            }
        });

        setInputList(tempInputList);
        setIsDuplicateTube(hasDuplication(tempInputList, "code"));
    }, [tubeData]);


    const fetchAllergyQn = async (ids: any, member: any) => {
        setCurrUser(member);
        if (ids.length > 0) {
            await getPackageQuestion(`package_ids=${ids}`);
        } else {
            let arr2: any = [...inputList];
            if (member !== "") {
                arr2[member].allergyForm = [];
                setInputList(arr2);
            }
        }
    };

    function hasDuplication(arr: any, key: string): boolean {
        const checkedValues = new Set<any>();
        let hasDuplicate = false;

        for (const obj of arr) {
            if (obj && obj.tubes && obj.tubes.length > 0) {
                for (const list of obj.tubes) {
                    if (checkedValues.has(list[key])) {
                        hasDuplicate = true;
                        break;
                    } else {
                        checkedValues.add(list[key]);
                    }
                }
            }
            if (hasDuplicate) {
                break;
            }
        }

        return hasDuplicate;
    }

    const convertBase641 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleUploadPrescription = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        if (e.target.files && e.target.files[0]) {
            const base64 = await convertBase641(e.target.files[0]);
            const newInputList = [...inputList];
            newInputList[index].uploadPrescription = base64;
            setInputList(newInputList);
        } else {
            console.error("No file selected");
        }
    };


    const [accbarcode, setAccBarcode] = useState<Array<any>>([]);

    useEffect(() => {
        let tempAccBarcode: string[] = [];
        if (inputList && inputList.length > 0) {
            inputList.forEach((list: any) => {
                if (list.tubes && list.tubes.length > 0) {
                    for (const obj of list.tubes) {
                        tempAccBarcode.push(obj.code);
                    }
                }
            });
        }
        setAccBarcode(tempAccBarcode);
    }, [inputList]);

    useEffect(() => {
        if (search.length > 0) {
            var regex = /^[6-9]\d{9}$/;
            var output: any = search.match(regex);
            if (output?.length > 0 && String(output[0]).length === 10) {
                setCustomer_phonenumber(String(output[0]));
            }
        }
    }, [search]);

    useEffect(() => {
        if (
            String(window.location.href) ==
            "https://partner.redcliffelabs.com/#/dashboard/os/booking"
        ) {
            setEnvironment("live");
        } else {
            setEnvironment("dev");
        }
        getMapMyIndiaAccessToken();
    }, []);

    useEffect(() => {
        if (centerInfo?.results?.length > 0) {
            setCentreSubType(centerInfo?.results[0]?.subtype || "");
            setCentre(centerInfo?.results[0]?.id);
            setCenterName(centerInfo?.results[0]?.name);
            setCentreCity(centerInfo?.results[0]?.city);
            setNotificationData({
                balance: centerInfo?.results[0]?.rcl_amount,
                minAmount: centerInfo?.results[0]?.min_amnt_for_notification,
                type: centerInfo?.results[0]?.type,
                centreType: centerInfo?.results[0]?.center_type,
                creditLimit: centerInfo?.results[0]?.credit_limit,
            });
        }
    }, [centerInfo]);

    useEffect(() => {
        if (Object.keys(lead_details).length !== 0) {
            setCustomer_address(lead_details?.address);
            setLeadCustomer_phonenumber(lead_details?.content_number);
            setLeadCustomer_whatsapppnumber(lead_details?.whatsapp_contact);
        } else {
            setCustomer_address("");
            setLeadCustomer_phonenumber("");
            setLeadCustomer_whatsapppnumber("");
        }
    }, [lead_details]);

    useEffect(() => {
        resetLeadDetails();
        getCenterInfo();
    }, []);

    

    useEffect(() => {
        if (customerLatitude && customerLongitude && zoneId) {
            checkGeoFenceArea(
                customerLatitude as string,
                customerLongitude as string,
                zoneId as string
            );
        }
    }, [customerLatitude, customerLongitude, zoneId]);

    useEffect(() => {
        setBookingEnabled(checkGeoFenceStatus);
    }, [checkGeoFenceStatus]);

    useEffect(() => {
        if (pincode && pin_code?.results?.length == 0) {
            setErrorMessage("We are not providing service on this pincode.");
            resetAddressComponent();
        }
        if (pincode && pin_code?.results?.length > 0) {
            const findPinCode = pin_code?.results.find(
                (code: any) => code.pincode == pincode
            );
            if (findPinCode) {
                setErrorMessage("");
                getArea(pincode);
                const { id, area, city, cityid } = pin_code.results.find(
                    (code: any) => code.pincode === pincode
                );
                setCityId(cityid);
                setCustomer_areapincode(id as Number);
                setCustomer_areaname(area as String);
                setCustomer_city(city as String);
                setIsPincode(false);
                setPackageKey(cityid);
            } else {
                setErrorMessage("We are not providing service on this pincode.");
            }
        }
    }, [pin_code, pincode]);

    const getArea = (pincode: String) => {
        const zone =
            pin_code?.results &&
            pin_code?.results.find((code: any) => code?.pincode === pincode);
        setZoneName(zone && (zone?.area as String));

        setZoneId(zone?.zone_data?.id);
    };

    const resetAddressComponent = () => {
        setZoneId("");
        setCityId("");
        setCustomer_areaname("");
        setIsPincode(true);
        setPackageKey(0);
        setZoneName("");
        setCustomer_city("");
    };

    useEffect(() => {
        if (totalPrice < 0) {
            setTotalPrice(0);
        }
    }, [totalPrice]);

    useEffect(() => {
        setNetPrice(totalPrice - discount + diagnosticFee);
    }, [totalPrice, discount, diagnosticFee]);

    useEffect(() => {
        if (diagnosticFee > 0) {
            setDiagnosticsFeeSatus(true);
        } else {
            setDiagnosticsFeeSatus(false);
        }
    }, [diagnosticFee]);

    const verifyMobile = (type: any) => {
        const mobileRegEx = /^[6-9]\d{9}$/;
        if (
            type === "alternate" &&
            customer_alternatenumber &&
            !mobileRegEx.test(customer_alternatenumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_alternatenumber: false,
            }));
        }
        if (
            type === "whatsapp" &&
            customer_whatsapppnumber &&
            !mobileRegEx.test(customer_whatsapppnumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_whatsapppnumber: false,
            }));
        }
        if (
            type === "mobile" &&
            customer_phonenumber &&
            !mobileRegEx.test(customer_phonenumber.toString())
        ) {
            setMobileValidation((prev: any) => ({
                ...prev,
                customer_phonenumber: false,
            }));
        }
    };

    // Histopathology
    const [openHistoryForm, SetOpenHistoryForm] = useState<boolean>(false);
    const handleHistopathologyForm = () => {
        SetOpenHistoryForm(true);
    };

    const [openMaternalMarkerForm, setOpenMaternalMarkerForm] =
        useState<boolean>(false);
    const handleMaternalMarkerForm = () => {
        setOpenMaternalMarkerForm(true);
    };
    const [oneplusOneChecker, setOneplusOneChecker] = useState<any>(false);

    useEffect(() => {
        if (inputList && inputList.length > 0) {
            let checker = false;
            inputList.forEach((data: any) => {
                if (data.customerPackage && data.customerPackage.length > 0) {
                    data.customerPackage.forEach((item: any) => {
                        if (item.no_patients === 2 && (inputList.length === 1 || inputList.length === 3)) {
                            checker = true;
                        }
                    });
                }
            });
            setOneplusOneChecker(checker);
        }
    }, [inputList]);


    const [openGutForm, setOpenGutForm] = useState<boolean>(false);
    const [dietType, setDietType] = useState<any>("");
    const [isDrinkAlcohol, setIsDrinkAlcohol] = useState<any>("");
    const [isSmoke, setIsSmoke] = useState<any>("");
    const [isWorkout, setIsWorkout] = useState<any>("");
    const [isMedicine, setIsMedicine] = useState<any>("");
    const [mealType, setMealType] = useState<any>({
        north_indian: false,
        south_indian: false,
        continental: false,
        south_east_asian: false,
    });
    const [height, setHeight] = useState<any>("");
    const [weight, setWeight] = useState<any>("");
    const [illnesses, setIllnesses] = useState({
        none: false,
        anxiety: false,
        arthritis: false,
        constipation: false,
        diabetes: false,
        depression: false,
        heart_diseases: false,
        hypertension: false,
        inflammatory_bowel_disease: false,
        irritable_bowel_syndrome: false,
        any_other_diseases: false,
    });

    const [diagnosedIllness, setDiagnosedIllness] = useState<any>();
    const [mealTypeData, setMealTypeData] = useState<any>();
    let globalIndex = 0;

    const handleCheckboxChangeForm = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        // setIllnesses((prevState: any) => ({
        //   ...prevState,
        //   [name]: checked,
        // }));
        setDiagnosedIllness(name)

    };

    const handleMealType = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        // setMealType((prevState: any) => ({
        //   ...prevState,
        //   [name]: checked,
        // }));
        setMealTypeData(name)
    };



    //Vip Discount
    const [alreadyARedPro, setAlreadyARedPro] = useState<any>(false);
    const [redProMembershipDiscount, setRedProMembershipDiscount] = useState<any>(0);
    const [openLoyaltyModal, setOpenLoyaltyModal] = useState<boolean>(false);
    const [checkedWay, setCheckedWay] = useState<any>("");
    const [redProMembershipDiscountPercentage, setRedProMembershipDiscountPercentage] = useState<any>(0);
    const [proMembershipPrice, setProMembershipPrice] = useState<any>(0);

    const TooltipContent = () => (
        <small>
            <ul style={{ paddingLeft: "15px" }}>
                <li style={{ color: "black", fontSize: "16px" }}>
                    VIP membership will get an additional 10% discount to the customer.
                </li>
                <li style={{ color: "black", fontSize: "16px" }}>
                    Red Cash and coupon/percentage can not be applied together.
                </li>
                <li style={{ color: "black", fontSize: "16px" }}>
                    Cx will get 100% Redcash as cashback on 1st booking and 5% cashback on
                    subsequent bookings.
                </li>
                <li style={{ color: "black", fontSize: "16px" }}>
                    Red Cash can be availed for up to 5% of the booking amount.
                </li>
            </ul>
        </small>
    );
    const handleAddLoyalty = () => {
        setOpenLoyaltyModal(false);
    };

    const handleCanel = () => {
        setCheckedWay("");
        setRedProMembershipDiscountPercentage(0);
        setProMembershipPrice(0);
        setOpenLoyaltyModal(false);
    };

    const submitForm = async (e: any) => {
        e.preventDefault();
        setDisableBooking(true);
        let packagesIds = new Array();
        inputList &&
            inputList[0]?.customerPackage.map((item: any) => {
                packagesIds.push(item.id);
            });

        let additionalPacakges = new Array();
        inputList &&
            inputList.length > 1 &&
            inputList.map((item: any, index: number) => {
                if (index > 0) {
                    additionalPacakges.push(item);
                }
            });
        let payment = new Array();
        paymentInfo &&
            paymentInfo.length > 1 &&
            paymentInfo.map((item: any) => {
                if (item.isChecked) {
                    payment.push({
                        amount: item.amount,
                        link_type: item.link_type,
                        paymentid: item.paymentid,
                    });
                }
            });

        const data: any = {
            genomics_form: inputList[0]?.isEnableGenomicsFormButton && inputList[0]?.genomicsForm?.id ? inputList[0]?.genomicsForm?.id : null,
            exome_form: inputList[0]?.exomeForm,
            blood_relation: inputList[0]?.isBloodRelation,
            cc_new_booking_flow: true,
            customerid: inputList[0].customerId,
            booking_date: moment().format("YYYY-MM-DD"),
            collection_date: moment().format("YYYY-MM-DD"),
            designation: inputList[0].designation,
            customer_name: inputList[0].customerName,
            customer_age: inputList[0].customerAge,
            customer_gender: inputList[0].customerGender,
            dob: inputList[0].dateOfBirth ? moment(inputList[0].dateOfBirth).format("YYYY-MM-DD") : "",
            ref_doctor: inputList[0].ref_doctor,
            ge_centre: gecode,
            diagnostic_fee_amount: diagnosticFee,
            diagnostic_fee: diagnosticFeeStatus,
            customer_email: customer_email,
            customer_phonenumber: lead_customer_phonenumber
                ? lead_customer_phonenumber
                : customer_phonenumber,
            customer_altphonenumber: lead_customer_phonenumber
                ? lead_customer_phonenumber
                : customer_alternatenumber,
            customer_whatsapppnumber: lead_customer_whatsapppnumber
                ? lead_customer_whatsapppnumber
                : customer_whatsapppnumber,
            customer_address: customer_address === "" ? null : customer_address,
            address_line2: addressLine2 === "" ? null : addressLine2,
            customer_landmark: favoritePlace === "" ? null : favoritePlace,
            customer_pincode: customer_areapincode === 0 ? null : customer_areapincode,
            customer_longitude: customerLatitude === "" ? null : customerLatitude,
            customer_latitude: customerLongitude === "" ? null : customerLongitude,
            book_for: inputList[0].bookingFor,
            customer_city: customer_city === "" ? null : customer_city,
            customer_aadhar: inputList[0].aadhar,
            prescription_file: inputList[0].uploadPrescription,
            sample_volume: inputList[0].sample_volume,
            passport_number: passport,
            subscription: checkedWay,
            packages: packagesIds,
            cityid: cityId === "" ? null : cityId,
            landmark: customer_landmark === "" ? null : customer_landmark,
            center: centre,
            coupon_amount: couponAmount,
            coupon_type: "amount",
            payment_information: payment,
            coupon_applied: coupon,
            camp_costs_to: couponDeductFrom,
            customer_id: customer_id,
            hivform: inputList[0]?.hivform,
            // tube_details: filteredData,
            coupon_file: b64file,

            //histo
            patient_name: inputList[0].customerName,
            contact_number: customer_phonenumber,
            remarks: remarks,
            address: customer_address,
            biopsy_size: sizeofbiopsy,
            procedure_date: dateOfProcedure ? dateOfProcedure : null,
            ref_doctor_name: refDoctorName,
            ref_doctor_phone: refDoctorNumber,
            center_lab_name: centerName,
            relevant_clinical_history: relevantClinicalHistory,
            clinical_diagnosis: clinicalDiagnosis,
            radiology_findings: radiologyFindings,
            operative_findings: operativeFindings,
            type_of_specimen: biospyPackageName,
            samples_acceptable: biospySampleName,
            site_specification: biospyTrueOrFalse,
            without_number: false,
            relevant_clinical_history_form: file1,
            clinical_diagnosis_form: file2,
            radiology_findings_form: file3,
            operative_findings_form: file4,
            relevant_clinical_history_file_name: imgSrc || "",
            clinical_diagnosis_file_name: imgSrc2 || "",
            radiology_findings_file_name: imgSrc3 || "",
            operative_findings_file_name: imgSrc4 || "",
            tube_details: inputList[0].tubes,
            nbs_collection_time: inputList[0].nbs_collection_time,
            nbs_collection_date: inputList[0].nbs_collection_date,
            //nbs
            birth_time: `${dataNbs.birth_time_hh}:${dataNbs.birth_time_mm}:00`,
            consanguinity: dataNbs.consanguinity,
            baby_weight: dataNbs.baby_weight,
            baby_admitted_in_nicu: dataNbs.baby_admitted_in_nicu,
            blood_transfusion: dataNbs.blood_transfusion,
            transfusion_date: dataNbs.transfusion_date,
            gestational_age_weeks: dataNbs.gestational_age_weeks,
            gestational_age_days: dataNbs.gestational_age_days,
            birth_order: dataNbs.birth_order,
            type_of_feed: dataNbs.type_of_feed,
            history: dataNbs.history,
            ch: dataNbs.ch ? true : false,
            cah: dataNbs.cah ? true : false,
            g6pd: dataNbs.g6pd ? true : false,
            gal: dataNbs.gal ? true : false,
            cp: dataNbs.cp ? true : false,
            pku: dataNbs.pku ? true : false,
            bio: dataNbs.bio ? true : false,

            // biomarker
            customer_dob: inputList[0]?.quadrupleFormData?.customer_dob ? moment(inputList[0]?.quadrupleFormData?.customer_dob).format("YYYY-MM-DD") : "",
            height: inputList[0]?.quadrupleFormData?.height,
            weight: inputList[0]?.quadrupleFormData?.weight,
            lmp_date: inputList[0]?.quadrupleFormData?.lmp_date,
            date_of_usg: inputList[0]?.quadrupleFormData?.date_of_usg,
            bpdmm: inputList[0]?.quadrupleFormData?.bpdmm,
            bpd: inputList[0]?.quadrupleFormData?.bpd,
            Acmm1: inputList[0]?.quadrupleFormData?.Acmm1,
            ac: inputList[0]?.quadrupleFormData?.ac,
            hm: inputList[0]?.quadrupleFormData?.hm,
            hcmm1: inputList[0]?.quadrupleFormData?.hcmm1,
            hc: inputList[0]?.quadrupleFormData?.hc,
            Flmm: inputList[0]?.quadrupleFormData?.Flmm,
            parity: inputList[0]?.quadrupleFormData?.parity,
            doctor_name: inputList[0]?.quadrupleFormData?.doctor_name,
            doctor_mobile: inputList[0]?.quadrupleFormData?.doctor_mobile,
            number_of_children: inputList[0]?.quadrupleFormData?.number_of_children,
            previous_history: inputList[0]?.quadrupleFormData?.previous_history,
            present_pregnacy: inputList[0]?.quadrupleFormData?.present_pregnacy,
            present_pregenancy: inputList[0]?.quadrupleFormData?.present_pregnacy,
            doctor_number: inputList[0]?.quadrupleFormData?.doctor_number,
            prev_baby: inputList[0]?.quadrupleFormData?.prev_baby ? true : false,
            attachment_one: inputList[0]?.quadrupleFormData?.attachment_one,
            attachment_two: inputList[0]?.quadrupleFormData?.attachment_two,
            attachment_three: inputList[0]?.quadrupleFormData?.attachment_three,
            procedure_type: inputList[0]?.quadrupleFormData?.procedure_type,
            natural: inputList[0]?.quadrupleFormData?.natural ? true : false,
            assisted: inputList[0]?.quadrupleFormData?.assisted ? true : false,
            para: inputList[0]?.quadrupleFormData?.para ? true : false,
            abortion: inputList[0]?.quadrupleFormData?.abortion ? true : false,
            live: inputList[0]?.quadrupleFormData?.live ? true : false,
            gravida: inputList[0]?.quadrupleFormData?.gravida ? true : false,
            customerAge: inputList[0]?.quadrupleFormData?.customerAge,
            donor_dob: inputList[0]?.quadrupleFormData?.donor_dob,
            extraction_egg_date: inputList[0]?.quadrupleFormData?.extraction_egg_date,
            transfer_egg_date: inputList[0]?.quadrupleFormData?.transfer_egg_date,
            crl: inputList[0]?.quadrupleFormData?.crl,
            nt: inputList[0]?.quadrupleFormData?.nt,
            sself: inputList[0]?.quadrupleFormData?.sself ? true : false,
            donor: inputList[0]?.quadrupleFormData?.donor ? true : false,
            sperm: inputList[0]?.quadrupleFormData?.sperm ? true : false,
            usgDetailsBody: inputList[0]?.quadrupleFormData?.usgDetailsBody,
            natureOfConception: inputList[0]?.quadrupleFormData?.natureOfConception,
            assisted_reproduction_egg: inputList[0]?.quadrupleFormData?.assisted_reproduction_egg,
            right_hand_bp: inputList[0]?.quadrupleFormData?.right_hand_bp,
            left_hand_bp: inputList[0]?.quadrupleFormData?.left_hand_bp,
            measurement_date: inputList[0]?.quadrupleFormData?.measurement_date,
            prescription: inputList[0]?.quadrupleFormData?.prescription,
            nb: inputList[0]?.quadrupleFormData?.nb,
            smoking_nature: inputList[0]?.quadrupleFormData?.smoking_nature,
            alcoholic_nature: inputList[0]?.quadrupleFormData?.alcoholic_nature,
            diabetic_nature: inputList[0]?.quadrupleFormData?.diabetic_nature,
            other_nature: inputList[0]?.quadrupleFormData?.other_nature,
            insulin: inputList[0]?.quadrupleFormData?.insulin,
            other_nature_description: inputList[0]?.quadrupleFormData?.other_nature_description,
            fmf: inputList[0]?.quadrupleFormData?.fmf,
            utpi_char: inputList[0]?.quadrupleFormData?.utpi_char,
            hcga_char: inputList[0]?.quadrupleFormData?.hcga_char,
            utpi_right: inputList[0]?.quadrupleFormData?.utpi_right,

            gut_microbiome_form: {}
        };
        const DuplocateDataCheck: any = {
            name: inputList[0].customerName,
            gender: inputList[0].customerGender,
            age: inputList[0].customerAge,
            packages: packagesIds,
            center: centre,
        }


        const gutMicrobiomeData: any = {
            diet_type: dietType,
            drink_alcohol: isDrinkAlcohol,
            smoke: isSmoke,
            work_out: isWorkout,
            diagnosed_illness: diagnosedIllness,
            medicines_or_drugs: isMedicine,
            meal_type: mealTypeData,
            height: height,
            weight: weight,
            center: centre,
        }
        if (gutMicrobiomeData.diet_type === "") {
            delete gutMicrobiomeData.diet_type
        }

        if (gutMicrobiomeData.drink_alcohol === "") {
            delete gutMicrobiomeData.drink_alcohol
        }
        if (gutMicrobiomeData.smoke === "") {
            delete gutMicrobiomeData.smoke
        }
        if (gutMicrobiomeData.work_out === "") {
            delete gutMicrobiomeData.work_out
        }
        if (gutMicrobiomeData.diagnosed_illness === "") {
            delete gutMicrobiomeData.diagnosed_illness
        }
        if (gutMicrobiomeData.medicines_or_drugs === "") {
            delete gutMicrobiomeData.medicines_or_drugs
        }
        if (gutMicrobiomeData.meal_type === "") {
            delete gutMicrobiomeData.meal_type
        }
        if (gutMicrobiomeData.height === "") {
            delete gutMicrobiomeData.height
        }
        if (gutMicrobiomeData.weight === "") {
            delete gutMicrobiomeData.weight
        }

        // nbs keys

        if (data["birth_time"] === "") {
            delete data["birth_time"];
        }

        if (data["baby_weight"] === "") {
            delete data["baby_weight"];
        }

        if (data["gestational_age_weeks"] === "") {
            delete data["gestational_age_weeks"];
        }
        if (data["relevant_clinical_history_form"] === "") {
            delete data["relevant_clinical_history_form"];
        }

        if (data["clinical_diagnosis_form"] === "") {
            delete data["clinical_diagnosis_form"];
        }
        if (checkedWay === "") {
            delete data.subscription;
        }

        if (data["radiology_findings_form"] === "") {
            delete data["radiology_findings_form"];
        }

        if (data["operative_findings_form"] === "") {
            delete data["operative_findings_form"];
        }

        if (data["relevant_clinical_history_file_name"] === "") {
            delete data["relevant_clinical_history_file_name"];
        }

        if (data["clinical_diagnosis_file_name"] === "") {
            delete data["clinical_diagnosis_file_name"];
        }

        if (data["radiology_findings_file_name"] === "") {
            delete data["radiology_findings_file_name"];
        }

        if (data["operative_findings_file_name"] === "") {
            delete data["operative_findings_file_name"];
        }

        if (
            Array.isArray(data["clinical_diagnosis_form"]) &&
            data["clinical_diagnosis_form"].length === 0
        ) {
            delete data["clinical_diagnosis_form"];
        }
        if (
            Array.isArray(data["relevant_clinical_history_file_name"]) &&
            data["relevant_clinical_history_file_name"].length === 0
        ) {
            delete data["relevant_clinical_history_file_name"];
        }
        if (
            Array.isArray(data["radiology_findings_form"]) &&
            data["radiology_findings_form"].length === 0
        ) {
            delete data["radiology_findings_form"];
        }
        if (
            Array.isArray(data["relevant_clinical_history_form"]) &&
            data["relevant_clinical_history_form"].length === 0
        ) {
            delete data["relevant_clinical_history_form"];
        }
        if (
            Array.isArray(data["operative_findings_form"]) &&
            data["operative_findings_form"].length === 0
        ) {
            delete data["operative_findings_form"];
        }



        if (data["right_hand_bp"] === "") {
            delete data["right_hand_bp"];
        }

        if (data["left_hand_bp"] === "") {
            delete data["left_hand_bp"];
        }

        if (data["measurement_date"] === "") {
            delete data["measurement_date"];
        }


        if (data["prescription"] === "") {
            delete data["prescription"];
        }


        if (data["customer_dob"] === "") {
            delete data["customer_dob"];
        }
        if (data["date_of_usg"] === "") {
            delete data["date_of_usg"];
        }
        if (data["lmp_date"] === "") {
            delete data["lmp_date"];
        }
        if (data["present_pregnacy"] === "") {
            delete data["present_pregnacy"];
        }

        if (data["height"] === "") {
            delete data["height"];
        }
        if (data["weight"] === "") {
            delete data["weight"];
        }

        if (!(couponAmount && discount)) {
            delete data.coupon_amount;
            delete data.coupon_type;
            delete data.camp_costs_to;
        }
        if (tubeData.length === 0) {
            delete data.tube_details;
        }
        if (dataNbs.transfusion_date === "") {
            delete data.transfusion_date;
        }
        if (b64file === "") {
            delete data.coupon_file;
        }
        if (sizeofbiopsy === "") {
            delete data.biopsy_size;
        }
        if (notificationData.centreType === "direct_client") {
            delete data.payment_information;
        }
        if (notificationData.centreType === "GE Lab") {
            delete data.payment_information;
        }

        if (data["history"] === "") {
            delete data["history"];
        }
        if (data["dob"] === "") {
            delete data["dob"];
        }
        if (data["customer_address"] === null) {
            delete data["customer_address"];
        }
        if (data["address_line2"] === null) {
            delete data["address_line2"];
        }
        if (data["customer_landmark"] === null) {
            delete data["customer_landmark"];
        }
        if (data["customer_areapincode"] === null) {
            delete data["customer_areapincode"];
        }
        if (data["customer_longitude"] === null) {
            delete data["customer_longitude"];
        }
        if (data["customer_latitude"] === null) {
            delete data["customer_latitude"];
        }
        if (data["customer_city"] === null) {
            delete data["customer_city"];
        }
        if (data["cityid"] === null) {
            delete data["cityid"];
        }
        if (data["customer_landmark"] === null) {
            delete data["customer_landmark"];
        }

        if (data["coupon_applied"] === 0) {
            delete data["coupon_applied"];
        }
        if (data["customer_email"] === "") {
            delete data["customer_email"];
        }
        if (data["customer_id"] === "") {
            delete data["customer_id"];
        }
        if (data["donor_dob"] === "") {
            delete data["donor_dob"];
        }
        if (data["extraction_egg_date"] === "") {
            delete data.extraction_egg_date;
        }
        if (data["transfer_egg_date"] === "") {
            delete data["transfer_egg_date"];
        }
        if (data["attachment_one"] === "") {
            delete data["attachment_one"];
        }
        if (data.attachment_two === "") {
            delete data["attachment_two"];
        }
        if (data["attachment_three"] === "") {
            delete data["attachment_three"];
        }
        if (data["baby_admitted_in_nicu"] === "") {
            delete data["baby_admitted_in_nicu"];
        }
        if (data["blood_transfusion"] === "") {
            delete data["blood_transfusion"];
        }
        if (data["history"] === "") {
            delete data["history"];
        }
        if (data["consanguinity"] === "") {
            delete data["consanguinity"];
        }

        if (data["gestational_age_weeks"] === "") {
            delete data["gestational_age_weeks"];
        }

        if (data["gestational_age_days"] === "") {
            delete data["gestational_age_days"];
        }

        if (data["right_hand_bp"] === "") {
            delete data["right_hand_bp"];
        }

        if (data["left_hand_bp"] === "") {
            delete data["left_hand_bp"];
        }

        if (data["measurement_date"] === "") {
            delete data["measurement_date"];
        }


        if (data["prescription"] === "") {
            delete data["prescription"];
        }
        if (data["right_hand_bp"] === "") {
            delete data["right_hand_bp"];
        }

        if (data["left_hand_bp"] === "") {
            delete data["left_hand_bp"];
        }

        if (data["measurement_date"] === "") {
            delete data["measurement_date"];
        }
        if (data["prescription"] === "") {
            delete data["prescription"];
        }
        if (data["number_of_children"] === "") {
            delete data["number_of_children"];
        }

        if (data["fmf"] === "") {
            delete data["fmf"];
        }

        if (data["insulin"] === "") {
            delete data["insulin"];
        }

        if (data["smoking_nature"] === "") {
            delete data["smoking_nature"];
        }

        if (data["alcoholic_nature"] === "") {
            delete data["alcoholic_nature"];
        }
        if (data["diabetic_nature"] === "") {
            delete data["diabetic_nature"];
        }
        if (data["other_nature"] === "") {
            delete data["other_nature"];
        }
        if (data["other_nature_description"] === "") {
            delete data["other_nature_description"];
        }
        if (data["utpi_char"] === "") {
            delete data["utpi_char"];
        }
        if
            (data["utpi_right"] === "") {
            delete data["utpi_right"];
        }
        if
            (data["hcga_char"] === "") {
            delete data["hcga_char"];
        }
        if (
            mobileValidation.customer_alternatenumber &&
            mobileValidation.customer_phonenumber &&
            mobileValidation.customer_whatsapppnumber
        ) {
            if (validateHistoStatus && biospyPackageName) {
                delete data.birth_time;
                delete data.consanguinity;
                delete data.baby_weight;
                delete data.baby_admitted_in_nicu;
                delete data.blood_transfusion;
                delete data.transfusion_date;
                delete data.gestational_age_weeks;
                delete data.gestational_age_days;
                delete data.birth_order;
                delete data.type_of_feed;
                delete data.history;
                delete data.ch;
                delete data.cah;
                delete data.g6pd;
                delete data.gal;
                delete data.cp;
                delete data.pku;
                delete data.bio;
                delete data.hivform;
                await createHistopathologyBooking(data);
            } else if (validateNbsStatus) {
                delete data.patient_name;
                delete data.contact_number;
                delete data.address;
                delete data.biopsy_size;
                delete data.procedure_date;
                delete data.ref_doctor_name;
                delete data.ref_doctor_phone;
                delete data.center_lab_name;
                delete data.relevant_clinical_history;
                delete data.clinical_diagnosis;
                delete data.radiology_findings;
                delete data.operative_findings;
                delete data.type_of_specimen;
                delete data.samples_acceptable;
                delete data.site_specification;
                delete data.relevant_clinical_history_form;
                delete data.clinical_diagnosis_form;
                delete data.radiology_findings_form;
                delete data.operative_findings_form;
                delete data.relevant_clinical_history_file_name;
                delete data.clinical_diagnosis_file_name;
                delete data.radiology_findings_file_name;
                delete data.operative_findings_file_name;
                delete data.hivform;
                await createNbsBooking(data);
            }
            if (validateGutStatus) {
                data.gut_microbiome_form = gutMicrobiomeData
            }

            let additionalMember: Array<any> = [];
            inputList.length > 0 &&
                inputList.map((list: any, index: number) => {
                    if (index > 0) {
                        let tempCustomerPackage: any = [];
                        if (list?.customerPackage?.length > 0) {
                            list?.customerPackage?.map((list2: any) => {
                                tempCustomerPackage.push({
                                    id: list2?.id,
                                });
                            });
                        }

                        let tempTubes: any = [];
                        if (list?.tubes?.length > 0) {
                            list?.tubes?.map((list2: any) => {
                                tempTubes.push(list2);
                            });
                        }
                        additionalMember.push({
                            genomics_form: list?.isEnableGenomicsFormButton && list?.genomicsForm?.id ? list?.genomicsForm?.id : null,
                            exome_form: list?.exomeForm,
                            customerDesignation: list?.designation,
                            customerName: list?.customerName,
                            blood_relation: list?.isBloodRelation,
                            customerAge: list?.customerAge,
                            customerGender: list?.customerGender,
                            customerPackage: tempCustomerPackage,
                            tubes: tempTubes,
                            dateOfBirth: list?.dateOfBirth,
                            center: centre,
                            // is_prescribed
                            bookingFor: list?.bookingFor, //1
                            ref_doctor: list?.ref_doctor, //1
                            // passport
                            aadhar: list?.aadhar,
                            prescription_file: list?.uploadPrescription,
                            sample_volume: list.sample_volume,
                            designation: list?.designation,
                            customerid: list?.customerId,
                            birth_time: `${list.birth_time_hh}:${list.birth_time_mm}:00`,
                            consanguinity: list.consanguinity,
                            baby_weight: list.baby_weight,
                            baby_admitted_in_nicu: list.baby_admitted_in_nicu,
                            blood_transfusion: list.blood_transfusion,
                            transfusion_date: list.transfusion_date,
                            gestational_age_weeks: list.gestational_age_weeks,
                            gestational_age_days: list.gestational_age_days,
                            birth_order: list.birth_order,
                            type_of_feed: list.type_of_feed,
                            history: list.history,
                            ch: list.ch ? true : false,
                            cah: list.cah ? true : false,
                            g6pd: list.g6pd ? true : false,
                            gal: list.gal ? true : false,
                            cp: list.cp ? true : false,
                            pku: list.pku ? true : false,
                            bio: list.bio ? true : false,
                            nbs_collection_time: list?.nbs_collection_time,
                            nbs_collection_date: list?.nbs_collection_date,

                            customer_dob: list?.quadrupleFormData?.customer_dob ? moment(list?.quadrupleFormData?.customer_dob).format("YYYY-MM-DD") : "",
                            height: list.quadrupleFormData?.height,
                            weight: list?.quadrupleFormData?.weight,
                            lmp_date: list?.quadrupleFormData?.lmp_date,
                            date_of_usg: list?.quadrupleFormData?.date_of_usg,
                            bpdmm: list?.quadrupleFormData?.bpdmm,
                            bpd: list?.quadrupleFormData?.bpd,
                            Acmm1: list?.quadrupleFormData?.Acmm1,
                            ac: list?.quadrupleFormData?.ac,
                            hm: list?.quadrupleFormData?.hm,
                            hcmm1: list?.quadrupleFormData?.hcmm1,
                            hc: list?.quadrupleFormData?.hc,
                            Flmm: list?.quadrupleFormData?.Flmm,
                            parity: list?.quadrupleFormData?.parity,
                            doctor_name: list?.quadrupleFormData?.doctor_name,
                            doctor_mobile: list?.quadrupleFormData?.doctor_mobile,
                            number_of_children: list?.quadrupleFormData?.number_of_children,
                            previous_history: list?.quadrupleFormData?.previous_history,
                            present_pregnacy: list?.quadrupleFormData?.present_pregnacy,
                            present_pregenancy: list?.quadrupleFormData?.present_pregnacy,
                            doctor_number: list?.quadrupleFormData?.doctor_number,
                            prev_baby: list?.quadrupleFormData?.prev_baby ? true : false,
                            attachment_one: list?.quadrupleFormData?.attachment_one,
                            attachment_two: list?.quadrupleFormData?.attachment_two,
                            attachment_three: list?.quadrupleFormData?.attachment_three,
                            procedure_type: list?.quadrupleFormData?.procedure_type,
                            natural: list?.quadrupleFormData?.natural ? true : false,
                            assisted: list?.quadrupleFormData?.assisted ? true : false,
                            para: list?.quadrupleFormData?.para ? true : false,
                            abortion: list?.quadrupleFormData?.abortion ? true : false,
                            live: list?.quadrupleFormData?.live ? true : false,
                            gravida: list?.quadrupleFormData?.gravida ? true : false,
                            donor_dob: list?.quadrupleFormData?.donor_dob,
                            extraction_egg_date: list?.quadrupleFormData?.extraction_egg_date,
                            transfer_egg_date: list?.quadrupleFormData?.transfer_egg_date,
                            crl: list?.quadrupleFormData?.crl,
                            nt: list?.quadrupleFormData?.nt,
                            sself: list?.quadrupleFormData?.sself ? true : false,
                            donor: list?.quadrupleFormData?.donor ? true : false,
                            sperm: list?.quadrupleFormData?.sperm ? true : false,
                            usgDetailsBody: list?.quadrupleFormData?.usgDetailsBody,
                            natureOfConception: list?.quadrupleFormData?.natureOfConception,
                            assisted_reproduction_egg: list?.quadrupleFormData?.assisted_reproduction_egg,
                            right_hand_bp: list?.quadrupleFormData?.right_hand_bp,
                            left_hand_bp: list?.quadrupleFormData?.left_hand_bp,
                            measurement_date: list?.quadrupleFormData?.measurement_date,
                            prescription: list?.quadrupleFormData?.prescription,
                            nb: list?.quadrupleFormData?.nb,
                            smoking_nature: list?.quadrupleFormData?.smoking_nature,
                            alcoholic_nature: list?.quadrupleFormData?.alcoholic_nature,
                            diabetic_nature: list?.quadrupleFormData?.diabetic_nature,
                            other_nature: list?.quadrupleFormData?.other_nature,
                            insulin: list?.quadrupleFormData?.insulin,
                            other_nature_description: list?.quadrupleFormData?.other_nature_description,
                            fmf: list?.quadrupleFormData?.fmf,
                            utpi_char: list?.quadrupleFormData?.utpi_char,
                            hcga_char: list?.quadrupleFormData?.hcga_char,
                            utpi_right: list?.quadrupleFormData?.utpi_right,
                        });
                    }
                });
            data.additional_member = additionalMember;

            if (oneplusOneChecker) {
                alert(
                    "This is a one plus one booking. You have to select atleast two or four members."
                );
            } else {
                const result = await ValidateOfflineDuplicateBooking(DuplocateDataCheck);

                if (result.status === "success") {
                    if (validateQuadrupleForm) {
                        await MarkerFormCreate(data);
                    } else {
                        await createBookingNewFlow(data);
                    }
                }

            }
        } else {
            if (customer_phonenumber.length !== 10) {
                setMobError("Mobile Number Must be 10 Digit");
            } else if (customer_alternatenumber.length !== 10) {
                setAltError("Alternate Number must be 10 Digit");
            } else if (customer_whatsapppnumber.length !== 10) {
                setWhatsError("Whatsapppnumber must be 10 Digit");
            }
        }
    };

    useEffect(() => {
        if (disableBooking) {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setDisableBooking(false);
            }, 15000);
        }
    }, [disableBooking]);


    // useEffect(() => {
    //   if (crete_booking_new_flow?.id) {
    //     const obj = {
    //       "booking": crete_booking_new_flow.id,
    //       "form_data": dataQuadruple,
    //       "form_type": "biomarker_form"

    //     }
    //     if (crete_booking_new_flow.id && validateBiomarkerLatestStatus) { updateQuadrupleForm(obj) }
    //   }
    // }, [crete_booking_new_flow]);

    useEffect(() => {
        if (crete_booking_new_flow?.id && crete_booking_new_flow?.pk) {
            if (inputList.length > 0) {
                inputList.forEach((val1: any) => {
                    if (val1?.allergyForm?.length > 0) {
                        const arr: any[] = [];
                        val1?.allergyForm.forEach((val: any) => {
                            arr.push({
                                question_text: val.question_text,
                                question: val.question,
                                unique_customer: val1?.customerId ? val1?.customerId : null,
                                booking_id: crete_booking_new_flow.id,
                                answer: val.checked === "no" ? "no" : val.answer,
                            });
                        });
                        postPackageAnswer(arr);
                    }
                });
            }
        }
    }, [crete_booking_new_flow]);


    useEffect(() => {
        if (crete_booking_new_flow?.id) {
            inputList && inputList.length > 0 &&
                inputList.map((formData: any) => {
                    const obj = {
                        "booking": crete_booking_new_flow.id,
                        "form_data": formData.bioMarkerFormData,
                        "form_type": "biomarker_form"

                    }
                    if (crete_booking_new_flow.id &&
                        validateBiomarkerLatestStatus &&
                        formData?.bioMarkerFormData
                    ) { updateQuadrupleForm(obj) }
                })
        }
    }, [crete_booking_new_flow]);

    const nameFormat = (name: string) => {
        const str = name;

        const arr = str.split(" ");

        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        const str2 = arr.join(" ");

        return str2.trimStart();
    };

    const handleInputChange = (e: any, index: number) => {
        const { name, value } = e.target;
        const list = [...inputList];
        const [objectKey, propertyName] = name?.split(".") ?? [];
        list[index][name] = value;
        if (objectKey === "hivform") {
            if (
                propertyName === "counsellor_name" ||
                propertyName === "ref_doctor_name"
            ) {
                list[index][objectKey][propertyName] = value
                    .trimStart()
                    .replace(/[^a-zA-Z ]/g, "");
            } else {
                list[index][objectKey][propertyName] = value;
            }
        }
        if (objectKey === "exomeForm") {
            list[index][objectKey][propertyName] = value;
        }
        if (e.target.name === "bookingFor") {
            list[index][name] = value;
        }
        if (e.target.name === "aadhar") {
            list[index][name] = value;
        }
        if (e.target.name === "sample_volume") {
            list[index][name] = value;
        }
        if (e.target.name === "customerName") {
            list[index][name] = nameFormat(value);
        }
        if (e.target.name === "isBloodRelation") {
            list[index][name] = value === "true" ? true : false;
        }
        if (e.target.name == "designation") {
            const findGender = GENDER_CHOICE.filter(
                (el: any) => el.display_name == e.target.value
            );
            list[index]["customerGender"] = findGender[0]?.gender;
            list[index]["customerDesignation"] = findGender[0]?.db_name;
        }
        if (name === "decrementAge") {
            let updatedAge = Number(list[index]["customerAge"]) - 1;
            list[index]["customerAge"] = updatedAge.toString();
            setInputList(list);
        }

        if (name === "incrementAge") {
            let updatedAge = Number(list[index]["customerAge"]) + 1;
            list[index]["customerAge"] = updatedAge.toString();
            setInputList(list);
        }
        if (e.target.name == "dateOfBirth") {
            // handleDOBForAge(e.target.value);

            const a: any = moment();
            const b: any = moment(e.target.value);
            var years = a.diff(b, "year");
            b.add(years, "years");
            var months = a.diff(b, "months");
            b.add(months, "months");
            var days = a.diff(b, "days");
            inputList[index].customerAgeMonths = months;
            inputList[index].customerAgeDays = days;

            let today = new Date();
            let birthDate = new Date(e.target.value);
            let age = today.getUTCFullYear() - birthDate.getUTCFullYear();
            var m = today.getUTCMonth() - birthDate.getUTCMonth();
            if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
                age--;
            }

            list[index]["customerAge"] = age;
        }
        setInputList(list);
    };

    const [bioMarkerPackageCode, setBioMarkerPackageCode] = useState<any>([]);
    const targetCodes = ["BC482", "BC070", "BC461", "BC463", "BC482A", "BC415A", "BC488"];
    const targetCodes2 = ["BC248",];
    const [customerPackages, setCustomerPackages] = useState<any>([]);
    // useEffect(() => {
    //   if (customerPackages && customerPackages.length > 0) {
    //     const packageCodes = customerPackages.map((item: any) => item?.code);
    //     setBioMarkerPackageCode(packageCodes);
    //   } else {
    //     setBioMarkerPackageCode([]);
    //   }
    // }, [customerPackages]);


    const [validatingData, setValidatingData] = useState<any>([]);

    const [bioQuadIndex, setBioQuadIndex] = useState<any>(0);
    const [dataObj, setDataObj] = useState<any>({});
    const handlePackage = (
        index: number,
        customerPackages: any,
        action?: string
    ) => {
        const list = [...inputList];
        const packagesId =
            customerPackages &&
            customerPackages?.length > 0 &&
            customerPackages?.map((item: any) => {
                return item?.id;
            });

        const packageCode =
            customerPackages &&
            customerPackages?.length > 0 &&
            customerPackages?.map((item: any) => {

                return item?.code;
            });
        if (packagesId?.length > 0) {
            let pkg: any = [];
            packagesId.map((val: any) => {
                if (val) {
                    pkg.push(val);
                }
            });
            getTubePackages(String(pkg));
        }

        let accumulatedPrice: any = 0;
        let validPackages: any = [];
        let invalidPackage: any = [];
        if (customerPackages && customerPackages.length > 0) {
            customerPackages.map((item: any) => {
                if (item?.package_lab_prices !== null) {
                    accumulatedPrice = accumulatedPrice + item.package_lab_prices;
                    validPackages.push(item);
                } else if (item?.package_lab_prices === null) {
                    invalidPackage.push(item);
                }
                if (item?.no_patients === 2) {
                    setCountNumberOfPatients(true);
                }
            });
        }
        if (customerPackages && customerPackages?.length > 0) {
            const urineCondition = customerPackages.some((item: any) => item.urine_volume_required);
            setUrineVolume((prev: any) => ({
                ...prev,
                [index]: urineCondition
            }))
        }

        list[index]["customerPackage"] = validPackages;
        list[index]["packagePrice"] = accumulatedPrice;
        const hasBloodRelationRequired = customerPackages.some(
            (item: any) => item.blood_relation_question_needed === true
        );
        list[index]["showBloodRelationText"] = hasBloodRelationRequired;
        if (!hasBloodRelationRequired) {
            delete list[index]["isBloodRelation"];
        }
        const isGenomicsForm = customerPackages.some(
            (item: any) => item.is_genomics_package === true
        );
        list[index]["isEnableGenomicsFormButton"] = isGenomicsForm;

        const isBiomarkerForm = customerPackages.some(
            (item: any) => item.bio_marker_form_latest === true
        );
        list[index]["isEnableBiomarker"] = isBiomarkerForm;
        const isQUadrupleForm = customerPackages.some(
            (item: any) => item.quadruple_marker_form_required === true
        );
        list[index]["isEnableQuadruple"] = isQUadrupleForm;

        setInvalidPackages(invalidPackage);
        setInputList(list);
        let allPackagePrice = 0;
        inputList &&
            inputList.map((rowItem: any) => {
                allPackagePrice = allPackagePrice + rowItem?.packagePrice;
            });
        const listCopy = [...list];
        let differentPackCounts: any = {};
        listCopy?.map((listItem: any, index: any) => {
            let accumulatedPrice: any = 0;
            listItem?.customerPackage?.filter((item: any) => {
                if (Number(item?.no_patients) > 1) {
                    if (differentPackCounts[item?.id]) {
                        differentPackCounts[item?.id].count += 1;
                    } else {
                        differentPackCounts[item?.id] = {
                            count: 1,
                            no_patients: item?.no_patients,
                            price:
                                item?.package_lab_prices === null
                                    ? item?.offer_price
                                    : item?.package_lab_prices,
                        };
                    }
                }
            });
        });
        let sumOfDifferentPackCounts = 0;

        Object.entries(differentPackCounts).forEach(([id, item]: [string, any]) => {
            const { price, count, no_patients } = item;
            sumOfDifferentPackCounts += price * Math.floor(count / no_patients);
        });

        setPrice(Math.floor(allPackagePrice) - sumOfDifferentPackCounts);

        setTotalPrice(Math.floor(allPackagePrice) - sumOfDifferentPackCounts);
        let storeData: any = [];
        let storeData2: any = [];
        let perPack: any = 1;

        list?.map((list: any, index: number) => {
            let custId = list?.customerId;
            let custData: any = {};
            list?.customerPackage?.map((list2: any) => {
                custData = {
                    id: list2?.id,
                    name: list2?.name,
                    checkHistoStatus: list2?.histopathology_history_form_needed,
                    checkNbsStatus: list2?.babyscreen_form_needed,
                    checkMaternalStatus: list2?.bio_marker_screen_form_needed,
                    checkHivStatus: list2?.hiv_form_needed,
                    checkGutStatus: list2.gut_microbiome_form_needed,
                    checkexomeStatus: list2.consent_form_required,
                    checkBiomarkerStatus: list2?.bio_marker_form_latest, //biomarker form has quadrupke package
                    checkQuadMarkerStatus: list2?.quadruple_marker_form_required
                }
                storeData.push(custData);
                if (list2?.babyscreen_form_needed) {
                    perPack =
                        list2?.name.match(/\d+/g) !== null &&
                            Number(list2?.name.match(/\d+/g)[0]) > perPack
                            ? list2?.name.match(/\d+/g)[0]
                            : perPack;
                }
            });
        });


        // setValidatingData(()=>storeData2)
        storeData?.length > 0 &&
            storeData?.map((val: any) => {
                if (val.checkHistoStatus) {
                    setBiospyPackageName(val?.name);
                }
            });
        if (action) {
            list[index].isEstimateAdded = true;
        }
        let btnStatus: boolean = storeData?.some(
            (list: any) => list.checkHistoStatus
        );
        let nbsStatus: boolean = storeData?.some(
            (list: any) => list.checkNbsStatus
        );
        let mtlStatus: boolean = storeData?.some(
            (list: any) => list.checkMaternalStatus
        );
        let hivStatus: boolean = storeData?.some(
            (list: any) => list.checkHivStatus
        );
        let gutStatus: boolean = storeData?.some(
            (list: any) => list?.checkGutStatus);

        let exomeStatus: boolean = storeData?.some((list: any) => list.checkexomeStatus);
        let quadMarkerStatus: boolean = storeData?.some((list: any) => list.checkQuadMarkerStatus); //for latest biomarker form
        let bioMarkerStatus: boolean = storeData?.some((list: any) => list.checkBiomarkerStatus); //its is for quadruple form


        const validationStatus = {
            histoStatus: storeData.some((list: any) => list.checkHistoStatus),
            nbsStatus: storeData.some((list: any) => list.checkNbsStatus),
            maternalStatus: storeData.some((list: any) => list.checkMaternalStatus),
            hivStatus: storeData.some((list: any) => list.checkHivStatus),
            gutStatus: storeData.some((list: any) => list.checkGutStatus),
            exomeStatus: storeData.some((list: any) => list.checkexomeStatus),
            bioMarkerStatus: storeData.some((list: any) => list.checkBiomarkerStatus),
            quadMarkerStatus: storeData.some((list: any) => list.checkQuadMarkerStatus),
        };

        setValidationStatus(prev => ({
            ...prev,
            [index]: validationStatus
        }));
        setValidateHistoStatus(btnStatus);
        setValidateNbsStatus(nbsStatus);
        setValidateMaternalStatus(mtlStatus);
        setValidateHivStatus(hivStatus);
        setValidateGutStatus(gutStatus);
        setPerPackNbs(Number(perPack));
        setInputList(list);
        removeCoupon();
        setValidateExomeStatus(exomeStatus);
        setValidateQuadrupleForm(quadMarkerStatus)
        setValidateBiomarkerLatestStatus(bioMarkerStatus)
    };
    const handleDoctor = (index: number, data: any) => {
        const list = [...inputList];
        const doctorId = data && data.id ? data.id : null;

        if (doctorId) {
            list[index]["ref_doctor"] = doctorId;
        } else {
            list[index]["ref_doctor"] = null;
        }
        setInputList(list);
    };


    useEffect(() => {
        if (inputList?.length) {
            const showError = inputList.some(
                (item: any) =>
                    item.showBloodRelationText &&
                    (item.isBloodRelation === undefined || item.isBloodRelation === null)
            );
            setShowBloodRelationError(showError);
        }
    }, [inputList]);

    useEffect(() => {
        if (dataLead && dataLead.name) {
            inputList[0].customerName = dataLead.name;

            if (dataLead.packages && dataLead.packages.length > 0 && centre) {
                getPackage(
                    centre,
                    "",
                    userDetails?.profile?.username,
                    dataLead.packages.map((val: any) => val.id)
                );
            }
        }
        if (dataLead && dataLead.mobile) {
            setCustomer_phonenumber(dataLead.mobile);
        }
       
    }, [dataLead, centre]);

    useEffect(() => {
        if (hotLeadstateData && hotLeadstateData.name) {
            inputList[0].customerName = hotLeadstateData.name;

            if (
                hotLeadstateData.packages &&
                hotLeadstateData.packages.length > 0 &&
                centre
            ) {
                getPackage(
                    centre,
                    "",
                    userDetails?.profile?.username,
                    hotLeadstateData.packages.map((val: any) => val.id)
                );
            }
        }
        if (hotLeadstateData && hotLeadstateData.mobile) {
            setCustomer_phonenumber(hotLeadstateData.mobile);
            setSearch(hotLeadstateData.mobile);
        }
    }, [hotLeadstateData]);
    useEffect(() => {
        if (
            FollowUpLeadsData &&
            FollowUpLeadsData.name &&
            FollowUpLeadsMobileNumber &&
            FollowUpLeadsMobileNumber?.number
        ) {
            inputList[0].customerName = FollowUpLeadsData.name;

            if (
                FollowUpLeadsData.Last_Package &&
                FollowUpLeadsData.Last_Package.length > 0 &&
                centre
            ) {
                getPackage(
                    centre,
                    "",
                    userDetails?.profile?.username,
                    FollowUpLeadsData.Last_Package.map((val: any) => val.id)
                );
            }
        }
        if (FollowUpLeadsData && FollowUpLeadsMobileNumber?.number) {
            setCustomer_phonenumber(FollowUpLeadsMobileNumber?.number);
            setSearch(FollowUpLeadsMobileNumber?.number);
        }
    }, [FollowUpLeadsMobileNumber, FollowUpLeadsData]);
    useEffect(() => {
        if (
            packagesById &&
            packagesById.results &&
            packagesById.results.length > 0 &&
            dataLead?.packages
        ) {
            handlePackage(0, packagesById.results);
        }
    }, [packagesById, dataLead]);

  
    useEffect(() => {
        if (campCoupon && campCoupon.results && campCoupon.results.length !== 0) {
            setCampCouponData(campCoupon.results[0]);
        }
    }, [campCoupon]);

    useEffect(() => {
        let dis = 0;

        if (campCouponData !== "" && inputList[0].customerPackage.length > 0) {
            campCouponData.packages.map((val: any) => {
                inputList[0].customerPackage.map((dat: any) => {
                    if (
                        dat.id === val.id &&
                        campCouponData.to_age >= Number(inputList[0].customerAge) &&
                        Number(inputList[0].customerAge) >= campCouponData.from_age
                    ) {
                        if (
                            inputList[0].customerGender === campCouponData.gender ||
                            campCouponData.gender === "both"
                        ) {
                            dis =
                                dis + (dat.package_lab_prices * campCouponData.discount) / 100;

                            setCoupon(campCouponData.id as Number);
                            setCampCouponCode(campCouponData.code as string);
                        }
                    } else {
                        if (dis === 0) {
                            setCampCouponCode("");
                            setCoupon(0);
                        }
                    }
                });
            });
            setDiscount(dis);
        }
    }, [campCouponData, inputList]);

    useEffect(() => {
        const list = [...inputList];
        const pkgs = [...list[0].customerPackage];
        const rchg = {
            id: environment === "live" ? 7567 : 12421,
            name: "Registration Charges",
            code: "RC10",
            offer_price: 10,
            package_price: 10,
            package_lab_prices: 10,
        };
        if (campCouponCode !== "") {
            pkgs.map((dat: any, index: any) => {
                campCouponData.packages.map((val: any) => {
                    if (dat.id !== rchg.id && dat.id === val.id) {
                        pkgs.push(rchg);

                        handlePackage(0, pkgs);
                    }
                });
            });
        } else {
            pkgs.map((dat: any, index: any) => {
                if (dat.id === rchg.id) {
                    pkgs.splice(index, 1);

                    handlePackage(0, pkgs);
                }
            });
        }
    }, [campCouponCode]);

    //doc modal
    const [openDocModal, setOpenDocModal] = useState<any>(false);
    const handleAddDoctor = () => {
        setOpenDocModal(true);
    };

    const [openCollectionModal, setOpenCollectionModal] = useState<any>(false);



    useEffect(() => {

        const updateForm = async () => {
            if (crete_booking_new_flow?.id && crete_booking_new_flow?.pk) {
                if (crete_booking_new_flow.id && validateBiomarkerLatestStatus) {
                    const obj = {
                        "booking": crete_booking_new_flow?.id,
                        "form_data": dataQuadruple,
                        "form_type": "biomarker_form"
                    };

                    await updateQuadrupleForm(obj);
                    resetCreateNewBookingFlow();
                    history.push(
                        `/dashboard/os/view-booking/${crete_booking_new_flow?.id}`
                    );
                } else {
                    resetCreateNewBookingFlow();
                    history.push(
                        `/dashboard/os/view-booking/${crete_booking_new_flow?.id}`
                    );
                }
            }
        };
        updateForm();

    }, [crete_booking_new_flow]);

    useEffect(() => {
        if (createBooking?.id && createBooking?.pk) {
            resetCreateNewBookingFlow();
            history.push(
                `/dashboard/os/view-booking/${createBooking?.id}`
            );
        }
    }, [createBooking]);

    //mapmyindia
    const [suggestedAddress, setSuggestedAddres] = useState<any>([]);
    const [mapAddressObject, setMapAddressObject] = useState<any>({});
    const [accessToken, setAccessToken] = useState<any>("");

    useEffect(() => {
        if (geoFencesMapMyIndia?.latitude && geoFencesMapMyIndia?.longitude) {
            setCustomerLatitude(geoFencesMapMyIndia?.latitude);
            setCustomerLongitude(geoFencesMapMyIndia?.longitude);
        }
    }, [geoFencesMapMyIndia]);

    useEffect(() => {
        if (mapmyindiaAccessToken?.accesstoken) {
            setAccessToken(mapmyindiaAccessToken?.accesstoken);
        }
    }, [mapmyindiaAccessToken]);

    useEffect(() => {
        if (mapAddressObject?.eLoc) {
            getPinCode(mapAddressObject?.addressTokens?.pincode);
            resetAddressComponent();
            setCustomer_landmark(mapAddressObject?.placeAddress);
            setPinCode(mapAddressObject?.addressTokens?.pincode);
            checkGeoFenchMapMyIndia(mapAddressObject?.eLoc, "NA");
        }
    }, [mapAddressObject]);

    const handleDOBForAge = (dob: any) => {
        const a: any = moment();
        const b: any = moment(dob);
        var years = a.diff(b, "year");
        b.add(years, "years");
        var months = a.diff(b, "months");
        b.add(months, "months");
        var days = a.diff(b, "days");
        inputList[0].customerAgeMonths = months;
        inputList[0].customerAgeDays = days;
    };

    //dob end

    const locationAutoCompleteSearch = (val: string) => {
        if (val.length > 2) {
            const urlForMap = `https://atlas.mapmyindia.com/api/places/search/json?query=${val}&access_token=${accessToken}&tokenizeAddress=true`;
            return new Promise(function (resolve, reject) {
                const id = "_" + Math.round(10000 * Math.random());
                const callbackName: any = "jsonp_callback_" + "data" + id;
                (window as any)[callbackName] = (data: any) => {
                    delete window[callbackName];
                    const ele = document.getElementById(id);
                    ele?.parentNode?.removeChild(ele);
                    const suggestedData = data?.suggestedLocations;
                    if (suggestedData.length > 0) {
                        setSuggestedAddres(data?.suggestedLocations);
                    }
                };
                const src = urlForMap + "&callback=" + callbackName;
                const script = document.createElement("script");
                script.src = src;
                script.id = id;
                script.addEventListener("error", reject);
                (
                    document.getElementsByTagName("head")[0] ||
                    document.body ||
                    document.documentElement
                ).appendChild(script);
            });
        }
    };


    const updateResultData = (
        inputListIndex: number,
        index1: any,
        key: any,
        val: any
    ) => {


        let temp: any = [...inputList];
        if (key === "is_snr" && val === true) {
            temp[inputListIndex].tubes[index1]["code"] = "";
        }
        if (key === "code" && val) {
            temp[inputListIndex].tubes[index1]["is_snr"] = false;
            // setTempCode(val);
            val.length > 4 && getValidBarcode(val);
        }

        if (key === "status") {
            temp[inputListIndex].tubes[index1][key] = val;
            if (val === "rejected") {
                temp[inputListIndex].tubes[index1]["is_snr"] = true;
            } else {
                temp[inputListIndex].tubes[index1]["is_snr"] = false;
            }
        } else {
            if (accbarcode.includes(val)) {
                temp[inputListIndex].tubes[index1]["err"] =
                    "Please provide unique barcode.";
            } else {
                temp[inputListIndex].tubes[index1]["err"] = null;
            }
            temp[inputListIndex].tubes[index1][key] = val;
        }

        setInputList(temp);
        setIsDuplicateTube(hasDuplication(temp, "code"));
    };

    const applyCoupon = () => {
        if (couponCode === "") {
            setCouponCode("");
            setCoupon(0);
            setDiscount(0);
            setTnPercentage("");
            setCouponMessage("");
            setTncMessage("");
            return;
        }
        const appliedCoupon =
            couponList.results.find((coup: any) => coup.id === coupon) ||
            couponList.results.find((coup: any) => coup.code === couponCode);
        if (appliedCoupon && appliedCoupon.minimum_price < totalPrice) {
            setCoupon(appliedCoupon.id);
            setCouponAmount("");
            setDiscountApplied(false);
            if (appliedCoupon.discount_type.toLowerCase() === "percentage") {
                setDiscount(Math.floor((price * appliedCoupon.discount) / 100));
                setTnPercentage(appliedCoupon.tnc !== null ? appliedCoupon.tnc : "");
                setCouponMessage(
                    `Coupon ${appliedCoupon.code}  has been applied successfully`
                );
                setTncMessage(
                    `${appliedCoupon.tnc !== null ? `TNC : ${appliedCoupon.tnc}` : ""}`
                );
            }
            if (appliedCoupon.discount_type.toLowerCase() === "amount") {
                setDiscount(Math.floor(appliedCoupon.discount));
                setTnPercentage(appliedCoupon.tnc !== null ? appliedCoupon.tnc : "");
                setCouponMessage(
                    `Coupon ${appliedCoupon.code}  has been applied successfully`
                );
                setTncMessage(
                    `${appliedCoupon.tnc !== null ? `TNC : ${appliedCoupon.tnc}` : ""}`
                );
            }
        } else {
            setCouponCode("");
            setCoupon(0);
            setDiscount(0);
            setTnPercentage("");
            setCouponMessage("");
            setTncMessage("");
        }
    };
    const applyCouponAmt = () => {
        if (!couponAmount) {
            setCouponCode("");
            setCoupon(0);
            setDiscount(0);
            setCouponMessage("");
            setTncMessage("");
            return;
        }
        setCouponCode("");
        setCoupon(0);
        const appliedCoupon = { cType: "amount", cValue: couponAmount };
        if (appliedCoupon.cValue <= totalPrice) {
            if (appliedCoupon.cType === "amount") {
                setDiscount(Math.floor(appliedCoupon.cValue));
                setDiscountApplied(true);
            }
        } else {
            setCouponCode("");
            setCoupon(0);
            setDiscount(0);
        }
    };
    const removeCoupon = () => {
        setCouponCode("");
        setCoupon(0);
        setDiscount(0);
        setCouponMessage("");
        setTncMessage("");
        setCouponAmount("");
        setDiscountApplied(false);
    };

    const [b64file, setB64file] = useState<any>("");
    const toBase64 = (file: any) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    const fileSelectedHandler1 = (e: React.ChangeEvent<{ files: any }>) => {
        toBase64(e.target.files[0]).then((data: any) => {
            setB64file(data);
        });
    };
    const [providerData, setProviderData] = useState<any>();
    useEffect(() => {
        if (couponList) {
            const storeData = couponList.results?.map((list: any) => list.provider);
            setProviderData(storeData);
        } else {
            setProviderData([]);
        }
    }, [couponList]);

    const ageInHisto =
        inputList &&
        inputList.length > 0 &&
        inputList.map((customerData: any) => customerData.customerAge);
    const genderInHisto =
        inputList &&
        inputList.length > 0 &&
        inputList.map((customerData: any) => customerData.customerGender);

    const [editBookingForIndex, setEditBookingForIndex] = useState<number>(-1);
    const [bookingForText, setBookingForText] = useState<string>("");
    const [selfExistsInLead, setSelfExistsInLead] = useState<boolean>(false);

    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const [open, setOpen] = useState(false);
    const [showName, setShowName] = useState<any>(0);
    const [allUHIDCustomer, setAllUHIDCustomer] = useState<any>([]);
    const [urineVolume, setUrineVolume] = useState<any>({});

    useEffect(() => {
        const allUHID: any = [];
        let tempPatientModal: boolean = false,
            tempApiCustomerRes = "";
        // setSelfExistsInLead(false);
        if (get_leads_new && get_leads_new.length > 0) {
            get_leads_new?.map((data: any) => {
                if (data?.booking_for === "self") {
                    setSelfExistsInLead(true);
                }
                allUHID.push({
                    customerId: data?.id,
                    lead: data?.lead,
                    customerDesignation: data?.designation,
                    designation: data?.designation,
                    customerName: data?.display_name,
                    customerAge: data?.age !== null ? data?.age : "",
                    customerOldAge: data?.age !== null ? data?.age : "",
                    customerGender:
                        data?.gender?.trim()?.toLowerCase() === "female" ||
                            data?.designation?.trim()?.toLowerCase() == "ms"
                            ? "female"
                            : "male",
                    customerPackage: [],
                    customerAddOnPackage: [],
                    customerTest: [],
                    packagePrice: 0,
                    dateOfBirth: data?.dob !== null ? data?.dob : "",
                    isSelected: false,
                    is_prescribed: "",
                    bookingFor: data?.booking_for,
                    ref_doctor: data?.ref_doctor,
                    oldBookingFor: data?.booking_for,
                    passport: "",
                    aadhar: "",
                    uploadPrescription: "",
                    sample_volume: 0,
                    oldNameUHID: data?.display_name,
                    isSelectedMember: false,
                    freeGlucoseFastingTestDisabled: false,
                    freeGlucoseFastingRandomTestDisabled: false,
                    freeHbA1cTestDisabled: false,
                    lastBookingDate: data?.last_booking_created_date
                        ? moment(data?.last_booking_created_date).format("Do MMMM, YYYY")
                        : "NA",
                    previousBookedPackages: data?.last_packages_booked
                        ? data?.last_packages_booked
                        : [],
                    hivform: {
                        ref_doctor_name: "",
                        ref_doctor_phone: "",
                        ref_by_doc_or_self: "doctor",
                        adhaar_card: "",
                        adhaar_number: "",
                        counselling_date: "",
                        counsellor_name: "",
                        report_can_be_seen_by: [],
                    },
                    exomeForm: {
                        dr_name: "",
                        dr_phonenumber: "",
                        dr_email: "",
                        clinical_history: "",
                        pre_test_counsellor: "",

                    },
                    allergyForm: [],
                    isValidEmail: true,
                    doctorNumber: true,
                });
            });
            tempPatientModal = true;
        } else {
            if (search.length === 10 && mobError === "") {
                tempApiCustomerRes =
                    "There is no any member, please add member through Add New Button.";
            } else {
                tempApiCustomerRes = "";
            }
        }
        setAllUHIDCustomer(allUHID);
        setOpen(tempPatientModal);
        setApiCustomerRes(tempApiCustomerRes);
    }, [get_leads_new]);

    useEffect(() => {
        const selectedCustomer: any = [];
        allUHIDCustomer.map((data: any) => {
            if (data.isSelected) {
                selectedCustomer.push(data);
            }
        });
        if (selectedCustomer.length !== 0) {
            setInputList(selectedCustomer);
            setShowName(1);
        } else {
            setShowName(0);
        }
    }, [allUHIDCustomer]);

    const handleUHIDAddCustomer = (data: any, index: any) => {
        const list = [...allUHIDCustomer];
        list[index]["isSelected"] = true;

        setAllUHIDCustomer(list);
    };

    const handleUHIDRemoveCustomer = (data: any, index: any) => {
        const list = [...allUHIDCustomer];
        list[index]["isSelected"] = false;
        setAllUHIDCustomer(list);
    };

    const handleRemoveClick = (data: any, index: any) => {
        const indexOfUHID = allUHIDCustomer.findIndex(
            (item: any) => item.customerId === data?.customerId
        );

        if (indexOfUHID !== -1) {
            handleUHIDRemoveCustomer("data", indexOfUHID);
            handleClose();
        } else {
            const list = [...inputList];
            handlePackage(index, []);
            // handlePackage((index), [], -1);
            list.splice(index, 1);
            setInputList(list);
            //   setIndexAddNewMember(null);
        }
    };

    const allergyAnsHandler = (val: any, index: any, index2: any, key: any) => {
        let ans = val.trimStart();
        let arr2: any = [...inputList];
        if (index2 !== "") {
            let arr = [...inputList[index2].allergyForm];
            arr[index][key] = ans;
            arr2[index2].allergyForm = arr;
            setInputList(arr2);
        }
    };

    const [openAddMemberModal, setOpenAddMemberModal] = useState<boolean>(false);

    const handleAddMemberModal = () => {
        setOpenAddMemberModal(true);
    };

    useEffect(() => {
        let editAddUHID: any = [...allUHIDCustomer];
        if (add_unique_customer?.length > 0) {
            editAddUHID.push({
                customerId: add_unique_customer[0]?.id,
                lead: add_unique_customer[0]?.lead, //notcoming
                customerDesignation: add_unique_customer[0]?.designation,
                designation: add_unique_customer[0]?.designation,
                customerName: add_unique_customer[0]?.display_name,
                customerAge: add_unique_customer[0]?.customer_age,
                customerOldAge: add_unique_customer[0]?.customer_age,
                customerGender:
                    add_unique_customer[0]?.gender?.trim()?.toLowerCase() === "female" ||
                        add_unique_customer[0]?.designation?.trim()?.toLowerCase() == "ms"
                        ? "female"
                        : "male",
                customerPackage: [],
                customerAddOnPackage: [],
                customerTest: [],
                packagePrice: 0,
                dateOfBirth:
                    add_unique_customer[0]?.dob !== null
                        ? add_unique_customer[0]?.dob
                        : "",
                isSelected: true,
                is_prescribed: "",
                bookingFor: add_unique_customer[0].relation,
                ref_doctor: add_unique_customer[0].ref_doctor,
                oldBookingFor: add_unique_customer[0].relation,
                passport: "",
                aadhar: "",
                uploadPrescription: "",
                sample_volume: 0,
                oldNameUHID: add_unique_customer[0].first_name,
                isSelectedMember: false,
                freeGlucoseFastingTestDisabled: false,
                freeGlucoseFastingRandomTestDisabled: false,
                freeHbA1cTestDisabled: false,
                // lastBookingDate: data?.last_booking_created_date
                //   ? moment(data?.last_booking_created_date).format("Do MMMM, YYYY")
                //   : "NA",
                lastBookingDate: "N/A",
                // previousBookedPackages: data?.last_packages_booked
                //   ? data?.last_packages_booked
                //   : [],
                previousBookedPackages: [],
                allergyForm: [],
                hivform: {
                    ref_doctor_name: "",
                    ref_doctor_phone: "",
                    ref_by_doc_or_self: "doctor",
                    adhaar_card: "",
                    adhaar_number: "",
                    counselling_date: "",
                    counsellor_name: "",
                    report_can_be_seen_by: [],
                },
                exomeForm: {
                    dr_name: "",
                    dr_phonenumber: "",
                    dr_email: "",
                    clinical_history: "",
                    pre_test_counsellor: "",

                },
                isValidEmail: true,
                doctorNumber: true,
            });

            if (editAddUHID.length === 1) {
                setApiCustomerRes("");
            }

        }
        setAllUHIDCustomer(editAddUHID);
    }, [add_unique_customer]);

    // Edit Booking Functionality

    // useEffect(() => {
    //   let editAddUHID: any = [...allUHIDCustomer];
    //   if (familyMemberUpdateData?.id) {
    //     editAddUHID.length > 0 &&
    //       editAddUHID?.forEach((list: any, index: number) => {
    //         if (list.customerId === familyMemberUpdateData?.id) {
    //           list.bookingFor = familyMemberUpdateData?.booking_for;
    //           list.oldBookingFor = familyMemberUpdateData?.booking_for;
    //         }
    //       });
    //     resetFamilyMemberBooking();
    //   }
    //   setAllUHIDCustomer(editAddUHID);
    // }, [familyMemberUpdateData]);

    // NBS Form setup
    const [customerName, setCustomerName] = useState("");
    const [dob, setDob] = useState("");
    const [trackNbsIndex, setTrackNbsIndex] = useState<number | null>(null);

    const handleNbsForm = (nbsIndex: number, inputListNbs: any) => {
        setTrackNbsIndex(nbsIndex);
        setCustomerName(inputListNbs?.customerName);
        setDob(inputListNbs?.dateOfBirth);
        setPerPackNbs(inputListNbs?.perPack);
        setDataNbs({
            birth_time: "",
            birth_time_hh: "00",
            birth_time_mm: "00",
            consanguinity: "",
            baby_weight: "",
            baby_admitted_in_nicu: "",
            blood_transfusion: "",
            transfusion_date: "",
            gestational_age_weeks: "",
            gestational_age_days: "",
            birth_order: "",
            type_of_feed: "",
            history: "",
            ch: "",
            cah: "",
            g6pd: "",
            gal: "",
            cp: "",
            pku: "",
            bio: "",
            nbs_collection_date: "",
            nbs_collection_time: "",
        });
        setOpenNbsModal(true);
    };

    useEffect(() => {
        let storeData = [...inputList];
        if (!openNbsModal && trackNbsIndex !== null) {
            storeData[trackNbsIndex].baby_admitted_in_nicu =
                dataNbs.baby_admitted_in_nicu;
            storeData[trackNbsIndex].baby_weight = dataNbs.baby_weight;
            storeData[trackNbsIndex].bio = dataNbs.bio;
            storeData[trackNbsIndex].birth_order = dataNbs.birth_order;
            storeData[trackNbsIndex].birth_time = dataNbs.birth_time;
            storeData[trackNbsIndex].birth_time_hh = dataNbs.birth_time_hh;
            storeData[trackNbsIndex].birth_time_mm = dataNbs.birth_time_mm;
            storeData[trackNbsIndex].blood_transfusion = dataNbs.blood_transfusion;
            storeData[trackNbsIndex].cah = dataNbs.cah;
            storeData[trackNbsIndex].ch = dataNbs.ch;
            storeData[trackNbsIndex].consanguinity = dataNbs.consanguinity;
            storeData[trackNbsIndex].cp = dataNbs.cp;
            storeData[trackNbsIndex].g6pd = dataNbs.g6pd;
            storeData[trackNbsIndex].gal = dataNbs.gal;
            storeData[trackNbsIndex].gestational_age_days =
                dataNbs.gestational_age_days;
            storeData[trackNbsIndex].gestational_age_weeks =
                dataNbs.gestational_age_weeks;
            storeData[trackNbsIndex].history = dataNbs.history;
            storeData[trackNbsIndex].pku = dataNbs.pku;
            storeData[trackNbsIndex].transfusion_date = dataNbs.transfusion_date;
            storeData[trackNbsIndex].type_of_feed = dataNbs.type_of_feed;
            storeData[trackNbsIndex].nbs_collection_time =
                dataNbs?.nbs_collection_time;
            storeData[trackNbsIndex].nbs_collection_date =
                dataNbs?.nbs_collection_date;
            setTrackNbsIndex(null);
            setCustomerName("");
            setDob("");
            setPerPackNbs([]);
        }
        setInputList(storeData);
    }, [openNbsModal]);

    useEffect(() => {

        const packageCode = inputList?.flatMap((data: any) =>
            data?.customerPackage?.map((Code: any) => Code?.code)
        );

        const matchingPackageCode = packageCode?.filter((code: string) =>
            coupleBookingTest.includes(code)
        );

        const packageStatus = matchingPackageCode?.some((code: any, index: any) =>
            matchingPackageCode.indexOf(code) !== index
        );

        if (
            packageCode && coupleBookingTest.includes(packageCode[packageCode.length - 1]) && !packageStatus
        ) {
            alert(
                "To book, add two members of opposite gender with the same package."
            );
        }
    }, [
        JSON.stringify(
            packageList.results?.map((data: any) =>
                coupleBookingTest?.includes((Code: any) => Code?.code === data.code) || []
            )
        ),
    ]);
    useEffect(() => {
        const packageCode = inputList?.flatMap((data: any) =>
            data?.customerPackage?.map((Code: any) => Code?.code)
        );
        const matchingPackageCode = packageCode?.some((code: string) =>
            coupleBookingTest.includes(code)
        );
        if (matchingPackageCode) {
            setCoupleBookingAlert(true);
        } else {
            setCoupleBookingAlert(false);
        }
    }, [inputList]);

    useEffect(() => {

        const packageCode = inputList?.flatMap((data: any) =>
            data?.customerPackage?.map((Code: any) => Code?.code) || []
        );
        const matchingPackageCode = packageCode?.filter((code: string) =>
            coupleBookingTest.includes(code)
        );

        // const packageStatus = matchingPackageCode.length >= 2;

        const packageStatus = matchingPackageCode?.some((code: any, index: any) =>
            matchingPackageCode.indexOf(code) !== index
        );

        const isValidPackageStatus =
            packageStatus && packageCode.length >= 2;

        const bookingGender = inputList?.map((data: any) => data?.customerGender || []);
        const hasMale = bookingGender.includes("male");
        const hasFemale = bookingGender.includes("female");
        const isValidGenderCombination = bookingGender.length >= 2 && hasMale && hasFemale;

        if (isValidPackageStatus && isValidGenderCombination) {
            setDisableCoupleBookingTest(true);
        }
        else {
            setDisableCoupleBookingTest(false);
        }
    }, [inputList]);

    useEffect(() => {
        return () => {
            setAllUHIDCustomer([]);
            setInputList([]);
            setDataNbs([]);
            setMobError("");
            handleClose();
        };
    }, []);

    const [windowWidth, windowHeight] = useWindowSize();

    const [selfAcc, setSelfAcc] = useState<string[]>([]);
    useEffect(() => {
        if (inputList.length > 0) {
            setSelfAcc(
                inputList.reduce((acc: string[], list: any, index: number) => {
                    if (!acc.includes(list.bookingFor)) {
                        acc.push(list.bookingFor);
                    }
                    return acc;
                }, [])
            );
        }
    }, [inputList]);

    const handleCheckBoxReferredBy = async (data: any, index: any) => {
        const list = [...inputList];
        list[index].hivform["ref_by_doc_or_self"] = data;
        setInputList(list);
    };

    const handleCheckBox = async (data: any, index: any) => {
        const list = [...inputList];
        list[index].hivform["report_can_be_seen_by"] = [...data];
        setInputList(list);
    };

    const handleFileSelected = async (
        e: React.ChangeEvent<{ files: any }>,
        index: any
    ) => {
        const base64: any = await convertBase64(e.target.files[0]);
        const newBase = base64.split(",")[1];
        const list = [...inputList];
        list[index].hivform["adhaar_card"] = newBase;
        setInputList(list);
    };

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const barcodeLength = inputList.filter((item: any) => item?.tubes &&
        item?.tubes.some((data: any) => data?.code.length < 7 &&
            data?.status !== "rejected" &&
            data?.status !== "pending"
        )
    );
 

    useEffect(() => {
        if (checkSubscription?.is_subscribed === true) {
            setAlreadyARedPro(true);
        }
    }, [checkSubscription]);
    const [vipMinusPrice, setVipMinusPrice] = useState<any>(0);
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
            className={classes.content}
        >
            <main className={classes.content_two}>




                <div
                    className={classes.contentTable}
                    style={
                        openAddMemberModal ? { filter: "blur(5px" } : { filter: "blur(0px" }
                    }
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <Grid
                            container
                            spacing={3}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={12}
                                md={3}
                                style={showName !== 1 ? { display: "none" } : {}}
                            >
                                <Button
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    onClick={() =>
                                        history.push("/dashboard/os/ccBooking_index_four")
                                    }
                                    fullWidth
                                    disabled={showName !== 1}
                                >
                                    Change Number
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField
                                    fullWidth
                                    id="mobileNumberId"
                                    label="Search by Phone Number"
                                    variant="outlined"
                                    size="small"
                                    value={search}
                                    onChange={(e) => handleSearch(e)}
                                    error={Boolean(mobNumErr)}
                                    helperText={mobNumErr}
                                    inputProps={{
                                        maxLength: 10,
                                        inputMode: "numeric",
                                    }}
                                    disabled={
                                        inputList?.some((list: any) => list?.isSelected) &&
                                        search.length === 10
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Button
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    style={
                                        (search.length === 10 && mobNumErr === "" ? false : true)
                                            ? {
                                                textTransform: "capitalize",
                                                background: "#dfe6e9",
                                                color: "#b2bec3",
                                                fontWeight: "bold",
                                            }
                                            : {
                                                textTransform: "capitalize",
                                                background: "#1976d2",
                                                color: "#fff",
                                            }
                                    }
                                    disabled={
                                        (search.length === 10 && mobNumErr === "" ? false : true)
                                    }
                                    onClick={handleAddMemberModal}
                                    fullWidth
                                >
                                    Add New Member
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={3}
                            style={
                                apiCustomerRes
                                    ? {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "red",
                                        padding: "5px",
                                    }
                                    : { display: "none" }
                            }
                        >
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {apiCustomerRes}
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} style={{ marginTop: "10px" }}>
                            <Grid item xs={12} md={12}>
                                <Select
                                    className="input"
                                    name="designation"
                                    variant="outlined"
                                    value={showName === 0 ? [] : inputList}
                                    onChange={(e) => e.stopPropagation()}
                                    open={open}
                                    onClose={handleClose}
                                    onOpen={handleOpen}
                                    multiple
                                    fullWidth
                                    input={
                                        <OutlinedInput id="select-multiple-patient" label="Chip" />
                                    }
                                    renderValue={(selected: any) => (
                                        <Box sx={{ display: "flex", gap: 0.5 }}>
                                            {selected.map((value: any) => (
                                                <Chip
                                                    key={value?.customerName}
                                                    label={value?.customerName}
                                                />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                    disabled={allUHIDCustomer?.length === 0 || search.length < 10}
                                >
                                    {allUHIDCustomer &&
                                        allUHIDCustomer.length > 0 &&
                                        allUHIDCustomer.map((data: any, index: any) => (
                                            <MenuItem
                                                key={data?.customerId}
                                                value={data?.customerId}
                                                onClick={handleOpen}
                                                style={{
                                                    borderBottom: "1px solid #d0cccc",
                                                    display: "flex",
                                                    flexDirection: windowWidth <= 425 ? "column" : "row",
                                                    alignItems: "center",
                                                    cursor: "default",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        width: "100%",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <h6 style={{ minWidth: "18px", fontWeight: "300" }}>
                                                        {index + 1 + "-"}
                                                    </h6>
                                                    <h6
                                                        style={{
                                                            width: "60%",
                                                            fontWeight: "300",
                                                            marginLeft: "4px",
                                                        }}
                                                    >
                                                        {data?.customerDesignation} {data?.customerName}
                                                    </h6>
                                                    <h5
                                                        style={{
                                                            minWidth: "30px",
                                                            width: 100,
                                                            fontWeight: "300",
                                                        }}
                                                    >
                                                        <h6>
                                                            {data?.customerAge
                                                                ? data?.customerAge + " Y"
                                                                : "NA"}
                                                        </h6>
                                                    </h5>
                                                    <h5
                                                        style={{
                                                            minWidth: "60%",
                                                            fontWeight: "300",
                                                            display: windowWidth <= 1047 ? "none" : "block",
                                                        }}
                                                    >
                                                        <h6>{"\u00A0" + data?.bookingFor}</h6>
                                                    </h5>
                                                    <h6
                                                        style={{
                                                            minWidth: "80px",
                                                            fontWeight: "300",
                                                            display: windowWidth <= 425 ? "none" : "block",
                                                        }}
                                                    >
                                                        {data?.customerGender?.toLowerCase() === "male"
                                                            ? "Male"
                                                            : data?.customerGender?.toLowerCase() === "female"
                                                                ? "Female"
                                                                : "Other"}
                                                    </h6>
                                                    {data?.isSelected ? (
                                                        <Button
                                                            style={{ backgroundColor: "red", color: "white" }}
                                                            onClick={() => {
                                                                handleUHIDRemoveCustomer(data, index);
                                                            }}
                                                        >
                                                            REMOVE
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            style={{
                                                                background: "green",
                                                                color: "white",
                                                                width: "10%",
                                                            }}
                                                            onClick={() => handleUHIDAddCustomer(data, index)}
                                                        >
                                                            ADD
                                                        </Button>
                                                    )}
                                                </div>
                                                <div
                                                    id="hello"
                                                    style={{
                                                        width: "100%",
                                                        display: windowWidth <= 425 ? "flex" : "none",
                                                        flexDirection: "row",
                                                        justifyContent: "space-between",
                                                        paddingLeft: "5px",
                                                    }}
                                                >
                                                    {editBookingForIndex === index ? (
                                                        <Select
                                                            className="input"
                                                            name="bookingForText"
                                                            variant="outlined"
                                                            value={bookingForText}
                                                            style={{
                                                                width: "100%",
                                                                margin: "0",
                                                            }}
                                                            onChange={(e) =>
                                                                setBookingForText(e.target.value as string)
                                                            }
                                                        >
                                                            <MenuItem
                                                                value="self"
                                                                disabled={selfExistsInLead}
                                                            >
                                                                Self
                                                            </MenuItem>
                                                            <MenuItem value="father">Father</MenuItem>
                                                            <MenuItem value="mother">Mother</MenuItem>
                                                            <MenuItem value="son">Son</MenuItem>
                                                            <MenuItem value="daughter">Daughter</MenuItem>
                                                            <MenuItem value="spouse">Spouse</MenuItem>
                                                            <MenuItem value="grandparents">
                                                                Grandparents
                                                            </MenuItem>
                                                            <MenuItem value="siblings">Siblings</MenuItem>
                                                            <MenuItem value="in-laws">In-laws</MenuItem>
                                                            <MenuItem value="other">Others</MenuItem>
                                                        </Select>
                                                    ) : (
                                                        <h6 style={{ minWidth: "100%" }}></h6>
                                                    )}
                                                </div>
                                            </MenuItem>
                                        ))}
                                </Select>
                            </Grid>
                        </Grid>
                    </div>
                </div>

                <div
                    className={classes.contentTable}
                    style={
                        openAddMemberModal || !showName
                            ? { filter: "blur(5px" }
                            : { filter: "blur(0px" }
                    }
                >
                    <form onSubmit={submitForm}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-end"
                            spacing={2}
                            style={{ margin: "1rem auto", background: "#eff" }}
                        >
                            <Grid item md={2} xs={12}>
                                {/* <p>Mobile Number*</p> */}
                                {lead_customer_phonenumber ? (
                                    <TextField
                                        className="input"
                                        name="customer_phonenumber"
                                        disabled={lead_customer_phonenumber ? true : false}
                                        value={"XXXXXXXXXX"}
                                        placeholder="Mobile Number"
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        label="Mobile Number"
                                    />
                                ) : (
                                    <TextField
                                        className="input"
                                        name="customer_phonenumber"
                                        // disabled={lead_customer_phonenumber ? true : false}
                                        disabled
                                        value={customer_phonenumber}
                                        placeholder="Mobile Number"
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        onChange={(e) =>
                                            setCustomer_phonenumber(e.target.value as String)
                                        }
                                        type="number"
                                        onWheel={(e: any) => e.target.blur()}
                                        onInput={(e: any) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value))
                                                .toString()
                                                .slice(0, 10);
                                        }}
                                        onBlur={() => verifyMobile("mobile")}
                                        onFocus={() => {
                                            setMobileValidation((prev: any) => ({
                                                ...prev,
                                                customer_phonenumber: true,
                                            }));
                                        }}
                                        helperText={
                                            !mobileValidation.customer_phonenumber &&
                                            "Incorrect Phone Number"
                                        }
                                        required
                                        label="Mobile Number"
                                    />
                                )}
                            </Grid>
                            <Grid item md={2} xs={12}>
                                {/* <p>Alternate Mobile Number</p> */}
                                {lead_customer_phonenumber ? (
                                    <TextField
                                        className="input"
                                        name="customer_alternatenumber"
                                        disabled={lead_customer_phonenumber ? true : false}
                                        value={"XXXXXXXXXX"}
                                        placeholder="Alternate Mobile Number"
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        label="Alternate Mobile Number"
                                    />
                                ) : (
                                    <TextField
                                        className="input"
                                        name="customer_alternatenumber"
                                        type="number"
                                        onWheel={(e: any) => e.target.blur()}
                                        onInput={(e: any) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value))
                                                .toString()
                                                .slice(0, 10);
                                        }}
                                        disabled={lead_customer_phonenumber ? true : false}
                                        value={customer_alternatenumber}
                                        placeholder="Alternate Mobile Number"
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        onChange={(e) =>
                                            setCustomer_alternatenumber(e.target.value as String)
                                        }
                                        onBlur={() => verifyMobile("alternate")}
                                        onFocus={() => {
                                            setMobileValidation((prev: any) => ({
                                                ...prev,
                                                customer_alternatenumber: true,
                                            }));
                                        }}
                                        helperText={
                                            !mobileValidation.customer_alternatenumber &&
                                            "Incorrect Phone Number"
                                        }
                                        label="Alternate Mobile Number"
                                    />
                                )}
                            </Grid>
                            <Grid item md={2} xs={12}>
                                {lead_customer_whatsapppnumber ? (
                                    <TextField
                                        className="input"
                                        name="customer_whatsapppnumber"
                                        placeholder="Whatsapp Number"
                                        disabled={lead_customer_whatsapppnumber ? true : false}
                                        value={"XXXXXXXXXX"}
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        label="Whatsapp Number"
                                    />
                                ) : (
                                    <TextField
                                        className="input"
                                        name="customer_whatsapppnumber"
                                        type="number"
                                        onWheel={(e: any) => e.target.blur()}
                                        onInput={(e: any) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value))
                                                .toString()
                                                .slice(0, 10);
                                        }}
                                        placeholder="Whatsapp Number"
                                        disabled={lead_customer_whatsapppnumber ? true : false}
                                        value={customer_whatsapppnumber}
                                        variant="outlined"
                                        style={{ margin: "0", width: "100%" }}
                                        onChange={(e) =>
                                            setCustomer_whatsapppnumber(e.target.value as String)
                                        }
                                        onBlur={() => verifyMobile("whatsapp")}
                                        onFocus={() => {
                                            setMobileValidation((prev: any) => ({
                                                ...prev,
                                                customer_whatsapppnumber: true,
                                            }));
                                        }}
                                        helperText={
                                            !mobileValidation.customer_whatsapppnumber &&
                                            "Incorrect Whatsapp Number"
                                        }
                                        label="Whatsapp Number"
                                    />
                                )}
                            </Grid>
                            <Grid item md={3} xs={12}>
                                {/* <p>Email*</p> */}
                                <TextField
                                    className="input"
                                    name="customer_email"
                                    type="email"
                                    placeholder="customer.reports@redcliffelabs.com"
                                    value={customer_email}
                                    variant="outlined"
                                    style={{ margin: "0", width: "100%" }}
                                    onChange={(e) => {
                                        const trimmedValue = e.target.value.replace(/\s/g, "");
                                        setCustomer_email(trimmedValue);
                                    }}
                                    label="Email"
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                {/* <p>Passport Number*</p> */}
                                <TextField
                                    className="input"
                                    name="passport"
                                    type="text"
                                    placeholder="Enter Passport Number"
                                    value={passport}
                                    variant="outlined"
                                    style={{ margin: "0", width: "100%" }}
                                    onChange={(e) =>
                                        setPassport(e.target.value.replace(/\s/g, "") as String)
                                    }
                                    label="Passport Number"
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            md={3}
                            xs={12}
                            style={{ display: "flex", justifyContent: "start" }}
                        >
                            <FormControl>
                                <FormControlLabel
                                    value="stat"
                                    control={
                                        <Checkbox
                                            checked={urgentBooking}
                                            onChange={(e) => setUrgentBooking(e.target.checked)}
                                            name="Urgent Booking"
                                        />
                                    }
                                    label={
                                        <Typography
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: "inherit",
                                                color: "purple",
                                            }}
                                        >
                                            URGENT BOOKING
                                        </Typography>
                                    }
                                    labelPlacement="start"
                                />
                            </FormControl>
                        </Grid>

                        <Grid
                            container
                            spacing={2}
                            // style={{
                            //   overflow: "auto",
                            //   maxHeight: "520px",
                            // }}
                            direction="row"
                            alignItems="flex-end"
                            style={{ margin: "1rem auto", background: "#eff" }}
                        >
                            {showName === 1 &&
                                inputList.length > 0 &&
                                inputList.map((x: any, index: number) => {
                                    const currAllergyQn = x.allergyForm;
                                    return (
                                        <>
                                            {windowWidth > 425 && (
                                                <TableContainer
                                                    key={x.customerId}
                                                    component={Paper}
                                                    className={classes.tableContainer}
                                                    style={
                                                        index % 2 === 0
                                                            ? { background: "#81ecec", margin: "10px 0" }
                                                            : { background: "#dfe6e9", margin: "10px 0" }
                                                    }
                                                >
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ background: "#636e72" }}>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Remove
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    UHID
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Patient Name
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Age/DOB
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Gender
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{ fontWeight: "bold", color: "#fff" }}
                                                                >
                                                                    Booking For
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    {inputList.length !== 1 ? (
                                                                        <HighlightOffIcon
                                                                            style={{
                                                                                height: "40px",
                                                                                width: "40px",
                                                                                borderRadius: "50%",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleRemoveClick(x, index)
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        "N/A"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>{x.customerId || "N/A"}</TableCell>
                                                                <TableCell>
                                                                    {x.designation + " " + x.customerName}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: "10px",
                                                                            marginBottom: "10px",
                                                                        }}
                                                                    >
                                                                        <IconButton
                                                                            onClick={() =>
                                                                                handleInputChange(
                                                                                    { target: { name: "decrementAge" } },
                                                                                    index
                                                                                )
                                                                            }
                                                                            name="decrementAge"
                                                                            style={{
                                                                                width: "2rem",
                                                                                height: "2rem",
                                                                                backgroundColor:
                                                                                    Number(x.customerOldAge) - 2 ===
                                                                                        Number(x.customerAge)
                                                                                        ? "rgba(0, 0, 0, 0.12)"
                                                                                        : "#1976d2",
                                                                                color:
                                                                                    Number(x.customerOldAge) - 2 ===
                                                                                        Number(x.customerAge)
                                                                                        ? "rgba(0, 0, 0, 0.26)"
                                                                                        : "white",
                                                                                borderRadius: "4px",
                                                                            }}
                                                                            disabled={
                                                                                Number(x.customerOldAge) - 2 ===
                                                                                Number(x.customerAge)
                                                                            }
                                                                        >
                                                                            <RemoveIcon />
                                                                        </IconButton>
                                                                        <TextField
                                                                            className="input"
                                                                            name="customerAge"
                                                                            type="number"
                                                                            placeholder="Enter Age"
                                                                            value={x.customerAge}
                                                                            disabled={
                                                                                lead_details?.patient_name !== null &&
                                                                                lead_details.patient_age !== 0
                                                                            }
                                                                            variant="outlined"
                                                                            style={{
                                                                                width: "3.8rem",
                                                                            }}
                                                                            inputProps={{ min: 0, max: 100 }}
                                                                            onChange={(e) => {
                                                                                let ageValue = parseInt(e.target.value);
                                                                                if (ageValue > 150) ageValue = 150;
                                                                                if (ageValue < 0) ageValue = 0;
                                                                                e.target.value = ageValue.toString();
                                                                                handleInputChange(e, index);
                                                                            }}
                                                                        />
                                                                        <IconButton
                                                                            onClick={() =>
                                                                                handleInputChange(
                                                                                    { target: { name: "incrementAge" } },
                                                                                    index
                                                                                )
                                                                            }
                                                                            name="incrementAge"
                                                                            style={{
                                                                                width: "2rem",
                                                                                height: "2rem",
                                                                                backgroundColor:
                                                                                    Number(x.customerOldAge) + 2 ===
                                                                                        Number(x.customerAge)
                                                                                        ? "rgba(0, 0, 0, 0.12)"
                                                                                        : "#1976d2",
                                                                                color:
                                                                                    Number(x.customerOldAge) + 2 ===
                                                                                        Number(x.customerAge)
                                                                                        ? "rgba(0, 0, 0, 0.26)"
                                                                                        : "white",
                                                                                borderRadius: "4px",
                                                                            }}
                                                                            disabled={
                                                                                Number(x.customerOldAge) + 2 ===
                                                                                Number(x.customerAge)
                                                                            }
                                                                        >
                                                                            <AddIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                    <p style={{ color: "red" }}>
                                                                        Note:Only ± 2 years of change in age is
                                                                        allowed.{" "}
                                                                    </p>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {x.customerGender === "male"
                                                                        ? "Male"
                                                                        : x.customerGender === "female"
                                                                            ? "Female"
                                                                            : "N/A"}
                                                                </TableCell>
                                                                <TableCell>{x.bookingFor || "N/A"}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}

                                            {windowWidth <= 425 && (
                                                <div className="card_img" key={x.customerId}>
                                                    <article className="card_container">
                                                        <span onClick={() => handleRemoveClick(x, index)}>
                                                            <CloseTwoToneIcon />
                                                        </span>
                                                        <section className="card_sub_container">
                                                            <div className="card_details">
                                                                <strong>UHID</strong>
                                                                <div>{x.customerId || "N/A"}</div>
                                                            </div>
                                                            <div className="card_details">
                                                                <strong>Booking For</strong>
                                                                <div>{x.bookingFor || "N/A"}</div>
                                                            </div>
                                                        </section>
                                                        <section className="card_sub_container">
                                                            <div className="card_details">
                                                                <strong>Patient Name</strong>
                                                                <div>
                                                                    {x.designation + " " + x.customerName}
                                                                </div>
                                                            </div>
                                                            <div className="card_details">
                                                                <strong>Age/DOB</strong>
                                                                <div>
                                                                    {" "}
                                                                    {x.dateOfBirth
                                                                        ? moment(x.dateOfBirth).format("DD-MM-YYYY")
                                                                        : x.customerAge
                                                                            ? x.customerAge
                                                                            : "N/A"}
                                                                </div>
                                                            </div>
                                                            <div className="card_details">
                                                                <strong>Gender</strong>
                                                                <div>
                                                                    {" "}
                                                                    {x.customerGender === "male"
                                                                        ? "Male"
                                                                        : x.customerGender === "female"
                                                                            ? "Female"
                                                                            : "N/A"}
                                                                </div>
                                                            </div>
                                                        </section>
                                                    </article>
                                                </div>
                                            )}

                                            <Grid
                                                container
                                                spacing={2}
                                                direction="row"
                                                alignItems="center"
                                                style={{ margin: "0.5rem auto", background: "#eff" }}
                                            >
                                                <Grid item md={3} xs={12}>
                                                    {checkboxChecked ? (
                                                        <Autocomplete
                                                            id="customerPackage"
                                                            key={packageKey}
                                                            loading={loading}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    let packs: any = [];
                                                                    newValue.map((val: any) => {
                                                                        let obj = JSON.parse(
                                                                            JSON.stringify(val, null, " ")
                                                                        );
                                                                        packs.push(obj);
                                                                    });
                                                                    if (indexToInsertTube !== index) {
                                                                        setIndexToInsertTube(index);
                                                                    }

                                                                    fetchAllergyQn(
                                                                        packs.length > 0 &&
                                                                        packs.map((val: any) => val.id),
                                                                        index
                                                                    );

                                                                    setCustomerPackages(packs);
                                                                    handlePackage(index, packs);
                                                                }
                                                            }}
                                                            fullWidth
                                                            multiple
                                                            disableClearable
                                                            options={packageList.results || []}
                                                            limitTags={0}
                                                            disabled={
                                                                centre === "" ||
                                                                x.customerGender === "" ||
                                                                x.customerAge === ""
                                                            }
                                                            freeSolo
                                                            disableCloseOnSelect
                                                            aria-required
                                                            onInputChange={(event, newInputValue) => {
                                                                clearTimeout(timer.current);
                                                                timer.current = setTimeout(() => {
                                                                    let searchParam = "";
                                                                    if (checkboxChecked[index] === "package") {
                                                                        searchParam = "&search=package";
                                                                    } else if (checkboxChecked[index] === "test") {
                                                                        searchParam = "&search=test";
                                                                    } else if (checkboxChecked[index] === "both") {
                                                                        searchParam = "&search=both";
                                                                    }
                                                                    getPackage(
                                                                        centre,
                                                                        String(newInputValue).replace(
                                                                            /[^a-zA-Z0-9 ]/g,
                                                                            ""
                                                                        ),
                                                                        userDetails?.profile?.username +
                                                                        searchParam,
                                                                        ""
                                                                    );
                                                                }, 700);
                                                            }}
                                                            value={x?.customerPackage}
                                                            getOptionLabel={(option: any) => {
                                                                return (
                                                                    String(option.name) +
                                                                    "(" +
                                                                    option.code +
                                                                    ")" +
                                                                    ", Rs. " +
                                                                    String(option?.package_lab_prices)
                                                                );
                                                            }}
                                                            getOptionDisabled={(option: any) => {
                                                                if (
                                                                    option.recommended_gender === "both" ||
                                                                    option.recommended_gender === x.customerGender
                                                                ) {
                                                                    const packID = x?.customerPackage.map(
                                                                        (pack: any) => pack.id
                                                                    );
                                                                    return packID.includes(option.id);
                                                                } else {
                                                                    return (
                                                                        option.recommended_gender !== "both" &&
                                                                        option.recommended_gender !==
                                                                        x.customerGender
                                                                    );
                                                                }
                                                            }}
                                                            renderOption={(option, { selected }) => (
                                                                <>
                                                                    <Checkbox
                                                                        icon={
                                                                            <CheckBoxOutlineBlankIcon fontSize="small" />
                                                                        }
                                                                        checkedIcon={
                                                                            <CheckBoxIcon fontSize="small" />
                                                                        }
                                                                        style={{ marginRight: 8 }}
                                                                        checked={selected}
                                                                    />
                                                                    {String(option.name) +
                                                                        "(" +
                                                                        option.code +
                                                                        ")" +
                                                                        ", Rs. " +
                                                                        String(option?.package_lab_prices) +
                                                                        "/-"}
                                                                    <br />
                                                                    <span style={{ color: "red" }}>
                                                                        {option.recommended_gender !== "both" &&
                                                                            option.recommended_gender !== null &&
                                                                            option.recommended_gender !==
                                                                            x.customerGender
                                                                            ? `(It's for ${option.recommended_gender} only)`
                                                                            : ""}
                                                                    </span>
                                                                </>
                                                            )}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder="Test or Packages"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    ) : (
                                                        <Autocomplete
                                                            id="customerPackage"
                                                            key={packageKey}
                                                            loading={loading}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    let packs: any = [];
                                                                    newValue.map((val: any) => {
                                                                        let obj = JSON.parse(
                                                                            JSON.stringify(val, null, " ")
                                                                        );
                                                                        packs.push(obj);
                                                                    });
                                                                    if (indexToInsertTube !== index) {
                                                                        setIndexToInsertTube(index);
                                                                    }
                                                                    fetchAllergyQn(
                                                                        packs.length > 0 &&
                                                                        packs.map((val: any) => val.id),
                                                                        index
                                                                    );
                                                                    handlePackage(index, packs);
                                                                }
                                                            }}
                                                            fullWidth
                                                            multiple
                                                            disableClearable
                                                            options={packageList.results || []}
                                                            limitTags={0}
                                                            disabled={
                                                                centre === "" ||
                                                                x.customerGender === "" ||
                                                                x.customerAge === ""
                                                            }
                                                            freeSolo
                                                            disableCloseOnSelect
                                                            aria-required
                                                            onInputChange={(event, newInputValue) => {
                                                                clearTimeout(timer.current);
                                                                timer.current = setTimeout(() => {
                                                                    getPackage(
                                                                        centre,
                                                                        String(newInputValue).replace(
                                                                            /[^a-zA-Z0-9 ]/g,
                                                                            ""
                                                                        ),
                                                                        userDetails?.profile?.username,
                                                                        ""
                                                                    );
                                                                }, 700);
                                                            }}
                                                            value={x?.customerPackage}
                                                            getOptionLabel={(option: any) => {
                                                                return (
                                                                    String(option.name) +
                                                                    "(" +
                                                                    option.code +
                                                                    ")" +
                                                                    ", Rs. " +
                                                                    String(option?.package_lab_prices)
                                                                );
                                                            }}
                                                            getOptionDisabled={(option: any) => {
                                                                if (
                                                                    option.recommended_gender === "both" ||
                                                                    option.recommended_gender === x.customerGender
                                                                ) {
                                                                    const packID = x?.customerPackage.map(
                                                                        (pack: any) => pack.id
                                                                    );
                                                                    return packID.includes(option.id);
                                                                } else {
                                                                    return (
                                                                        option.recommended_gender !== "both" &&
                                                                        option.recommended_gender !==
                                                                        x.customerGender
                                                                    );
                                                                }
                                                            }}
                                                            renderOption={(option, { selected }) => (
                                                                <>
                                                                    <Checkbox
                                                                        icon={
                                                                            <CheckBoxOutlineBlankIcon fontSize="small" />
                                                                        }
                                                                        checkedIcon={
                                                                            <CheckBoxIcon fontSize="small" />
                                                                        }
                                                                        style={{ marginRight: 8 }}
                                                                        checked={selected}
                                                                    />
                                                                    {String(option.name) +
                                                                        "(" +
                                                                        option.code +
                                                                        ")" +
                                                                        ", Rs. " +
                                                                        String(option?.package_lab_prices) +
                                                                        "/-"}
                                                                    <br />
                                                                    <span style={{ color: "red" }}>
                                                                        {option.recommended_gender !== "both" &&
                                                                            option.recommended_gender !== null &&
                                                                            option.recommended_gender !==
                                                                            x.customerGender
                                                                            ? `(It's for ${option.recommended_gender} only)`
                                                                            : ""}
                                                                    </span>
                                                                </>
                                                            )}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder="Test"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <TextField
                                                        className="input"
                                                        name="aadhar"
                                                        type="number"
                                                        onWheel={(e: any) => e.target.blur()}
                                                        onInput={(e: any) => {
                                                            e.target.value = Math.max(
                                                                0,
                                                                parseInt(e.target.value)
                                                            )
                                                                .toString()
                                                                .slice(0, 12);
                                                        }}
                                                        placeholder="Enter Aadhaar Number(Optional)"
                                                        value={x.aadhar || ""}
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        style={{ width: "100%", margin: "0" }}
                                                        onChange={(e) => handleInputChange(e, index)}
                                                    />
                                                </Grid>
                                                <Grid item md={3} xs={10}>
                                                    <Autocomplete
                                                        onChange={(event, newValue) => {
                                                            if (newValue) {
                                                                let obj = JSON.parse(
                                                                    JSON.stringify(newValue, null, " ")
                                                                );
                                                                handleDoctor(index, obj);

                                                            }
                                                        }}


                                                        freeSolo
                                                        blurOnSelect
                                                        options={refDoctor?.results || []}
                                                        onInputChange={(event, newInputValue) => {
                                                            clearTimeout(timer.current);
                                                            timer.current = setTimeout(() => {
                                                                getRefDoctor(
                                                                    `?name=${newInputValue}${centreSubType === "cep"
                                                                        ? `&center=${centre}`
                                                                        : ""
                                                                    }`
                                                                );
                                                            }, 1000);
                                                        }}
                                                        loading={loading}
                                                        disableCloseOnSelect
                                                        disableClearable
                                                        getOptionLabel={(option: any) => option?.name}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Doctor's Name"
                                                                variant="outlined"
                                                                required={
                                                                    userDetails?.profile?.executive_type ===
                                                                        "OLCP-Disabled"
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={1}
                                                    xs={2}
                                                    style={
                                                        centreSubType !== "cep"
                                                            ? {
                                                                display: "block",
                                                            }
                                                            : { display: "none" }
                                                    }
                                                >
                                                    <AddCircleIcon
                                                        onClick={handleAddDoctor}
                                                        fontSize="large"
                                                    />
                                                </Grid>
                                                {/* <Grid item md={2} xs={12}>
                          <FormControlLabel
                          style={{ marginTop:"8px"}}
                            control={
                              <Checkbox
                              checked={checkboxChecked}
                              onChange={(event) =>
                                setCheckboxChecked(event.target.checked)
                              }
                              />
                            }
                            label="Show Only Package"
                          />
                        </Grid> */}
                                                <Grid item md={2} xs={12}>
                                                    <Button
                                                        startIcon={<AddIcon />}
                                                        variant="contained"
                                                        onClick={() => handleTestClick()}
                                                    >
                                                        Estimate Test
                                                    </Button>
                                                </Grid>
                                                <div>
                                                    <FormControlLabel
                                                        style={{ marginTop: "8px" }}
                                                        control={
                                                            <Checkbox
                                                                checked={checkboxChecked[index] === "test"}
                                                                onChange={() => handleCheckboxChange("test", index)}
                                                            />
                                                        }
                                                        label="Test"
                                                    />
                                                </div>
                                                <div>
                                                    <FormControlLabel
                                                        style={{ marginTop: "8px" }}
                                                        control={
                                                            <Checkbox
                                                                checked={checkboxChecked[index] === "package"}
                                                                onChange={() => handleCheckboxChange("package", index)}
                                                            />
                                                        }
                                                        label="Package"
                                                    />
                                                </div>
                                                <div>
                                                    <FormControlLabel
                                                        style={{ marginTop: "8px" }}
                                                        control={
                                                            <Checkbox
                                                                checked={checkboxChecked[index] === "both"}
                                                                onChange={() => handleCheckboxChange("both", index)}
                                                            />
                                                        }
                                                        label="Both"
                                                    />
                                                </div>
                                                <Grid item xs={12} sm={3} md={3}>
                                                    <p style={{ fontWeight: "bolder", fontSize: "15px", marginBottom: "8px" }}>Upload Prescription</p>
                                                    <input
                                                        className="input"
                                                        style={{
                                                            width: "100%",
                                                            marginBottom: "10px",
                                                            padding: "5.5px 14px",
                                                            border: "1px solid rgba(0, 0, 0, 0.23)",
                                                            borderRadius: "5px",
                                                        }}
                                                        type="file"
                                                        name="file"
                                                        id="file"
                                                        accept=".png,.jpg,.jpeg,.docx,.pdf"
                                                        onChange={(e) => handleUploadPrescription(e, index)} />
                                                </Grid>
                                                {
                                                    urineVolume[index] ?
                                                        <div
                                                            style={{
                                                                width: "298px",
                                                                marginTop: "7px",
                                                                marginLeft: "40px",
                                                            }}
                                                        >
                                                            <TextField
                                                                name="sample_volume"
                                                                type="number"
                                                                id="sample_volume"
                                                                required
                                                                className="input"
                                                                label="Urine volume"
                                                                variant="outlined"
                                                                placeholder="Enter urine volume in mL"
                                                                value={x.sample_volume || ""}
                                                                onChange={(e) => {
                                                                    let value = e.target.value.replace(/\D/g, "");
                                                                    if (value.startsWith("0") && value.length > 1) {
                                                                        value = value.replace(/^0+/, "");
                                                                    }
                                                                    if (value.length > 5) {
                                                                        value = value.slice(0, 5);
                                                                    }

                                                                    const numericValue = Number(value);
                                                                    if (numericValue >= 0 && numericValue <= 10000) {
                                                                        e.target.value = value;
                                                                        handleInputChange(e, index);
                                                                    }
                                                                }}
                                                                style={{ width: "100%" }}
                                                                helperText="Volume should be between 0 - 10000 in mL"
                                                                FormHelperTextProps={{
                                                                    style: { color: "red" },
                                                                }}
                                                            />
                                                        </div>
                                                        : ""
                                                }

                                                {x.showBloodRelationText && (
                                                    <Grid item md={3} xs={12}>
                                                        <FormControl required>
                                                            <FormLabel id="demo-row-radio-buttons-group-label">
                                                                Consanguinity (Blood relationship)
                                                            </FormLabel>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="isBloodRelation"
                                                                value={x.isBloodRelation}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                            >
                                                                <FormControlLabel
                                                                    value={true}
                                                                    control={<Radio />}
                                                                    label="Yes"
                                                                />
                                                                <FormControlLabel
                                                                    value={false}
                                                                    control={<Radio />}
                                                                    label="No"
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>
                                                )}
                                                <Grid item md={3} xs={12}>
                                                    {Boolean(location?.state?.packages?.length > 0) &&
                                                        !x.isEstimateAdded && (
                                                            <Button
                                                                style={{ width: "90%", margin: 2 }}
                                                                variant="outlined"
                                                                disabled={
                                                                    !Boolean(
                                                                        location?.state?.packages?.length > 0
                                                                    ) || x.isEstimateAdded
                                                                }
                                                                onClick={() => {
                                                                    if (indexToInsertTube !== index) {
                                                                        setIndexToInsertTube(index);
                                                                    }
                                                                    handlePackage(
                                                                        index,
                                                                        location?.state?.packages,
                                                                        "estimateBtn"
                                                                    );
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                            >
                                                                Add packages as per estimate
                                                            </Button>
                                                        )}
                                                </Grid>
                                            </Grid>

                                            {validateQuadrupleForm && x?.isEnableQuadruple && (
                                                <Grid item md={3} xs={12}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        fullWidth
                                                        onClick={() => { setOpenBioMarkerForm(true); setBioQuadIndex(index) }}
                                                        disabled={!x?.isEnableQuadruple}
                                                    >
                                                        Quadruple Marker Form
                                                    </Button>
                                                </Grid>)}
                                            {validateBiomarkerLatestStatus && x?.isEnableBiomarker && <Grid item md={3} xs={10}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    color="secondary"
                                                    onClick={() => { setOpenQuadrupleForm(true); setBioQuadIndex(index) }}
                                                    disabled={!x?.isEnableBiomarker}
                                                >
                                                    BIO Marker Form
                                                </Button>
                                            </Grid>}
                                            <Grid item md={3} xs={10}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    color="secondary"
                                                    onClick={() => SetOpenHistoryForm(true)}
                                                    disabled={!validationStatus[index]?.histoStatus}
                                                >
                                                    HISTOPATHOLOGY FORM
                                                </Button>
                                            </Grid>
                                            <Grid item md={2} xs={10}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    color="secondary"
                                                    onClick={() => setOpenNbsModal(true)}
                                                    disabled={!validationStatus[index]?.nbsStatus}
                                                >
                                                    NBS FORM
                                                </Button>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    fullWidth
                                                    disabled={!validationStatus[index]?.gutStatus}
                                                    // disabled={!(validatingData.length > 0 && validatingData.some(
                                                    //   (item: any) => item.customerId === x?.customerId && item?.checkGutStatus
                                                    // ))}
                                                    onClick={() => setOpenGutForm(true)}
                                                >
                                                    GUT MICROBIOME FORM
                                                </Button>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    fullWidth
                                                    onClick={() => setOpenGenomicsModal(index)}
                                                    disabled={!x?.isEnableGenomicsFormButton || (x.genomicsForm && Object.entries(x.genomicsForm).length > 0)}
                                                >
                                                    Genomics Form
                                                </Button>
                                                {(x?.isEnableGenomicsFormButton && !(x.genomicsForm && Object.entries(x.genomicsForm).length > 0)) && <div style={{ fontSize: "14px", color: "red", marginTop: "6px", marginBottom: "10px" }}>Please select all the Genomics packages before filling the form.</div>}
                                            </Grid>
                                            {validationStatus[index]?.hivStatus &&
                                                x?.customerPackage &&
                                                x?.customerPackage?.length > 0 && (
                                                    <Grid
                                                        container
                                                        md={12}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            backgroundColor: "#bdd8ef94",
                                                        }}
                                                    >
                                                        <Grid
                                                            item
                                                            md={3}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "flex-start",
                                                                marginBottom: "12px",
                                                                marginTop: 10,
                                                            }}
                                                        >
                                                            <h6 style={{ fontWeight: "bold" }}>
                                                                HIV CONSENT FORM
                                                            </h6>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            md={3}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                marginBottom: "10px",
                                                                marginTop: "10px",
                                                            }}
                                                        >
                                                            <div
                                                                className="checkList"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <div style={{ fontWeight: "bolder" }}>
                                                                    Ref By:
                                                                </div>
                                                                <div style={{ display: "flex" }}>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"self"}
                                                                            type="checkbox"
                                                                            checked={
                                                                                x?.hivform?.ref_by_doc_or_self ===
                                                                                "self"
                                                                            }
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    handleCheckBoxReferredBy(
                                                                                        "self",
                                                                                        index
                                                                                    );
                                                                                } else {
                                                                                    handleCheckBoxReferredBy(
                                                                                        "doctor",
                                                                                        index
                                                                                    );
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.ref_by_doc_or_self?.length >
                                                                                    0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Self
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"doctor"}
                                                                            type="checkbox"
                                                                            checked={
                                                                                x?.hivform?.ref_by_doc_or_self ===
                                                                                "doctor"
                                                                            }
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    handleCheckBoxReferredBy(
                                                                                        "doctor",
                                                                                        index
                                                                                    );
                                                                                } else {
                                                                                    handleCheckBoxReferredBy(
                                                                                        "self",
                                                                                        index
                                                                                    );
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.ref_by_doc_or_self?.length >
                                                                                    0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Doctor
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            md={6}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                marginBottom: "10px",
                                                                marginTop: "10px",
                                                            }}
                                                        >
                                                            <div
                                                                className="checkList"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <div style={{ fontWeight: "bolder" }}>
                                                                    Report Can Be Seen By*:
                                                                </div>
                                                                <div style={{ display: "flex" }}>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"self"}
                                                                            type="checkbox"
                                                                            checked={x?.hivform?.report_can_be_seen_by?.includes(
                                                                                "self"
                                                                            )}
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    let list = [
                                                                                        ...x?.hivform
                                                                                            ?.report_can_be_seen_by,
                                                                                        value,
                                                                                    ];
                                                                                    handleCheckBox(list, index);
                                                                                } else {
                                                                                    let list =
                                                                                        x?.hivform?.report_can_be_seen_by.filter(
                                                                                            (item: string) => item !== value
                                                                                        );
                                                                                    handleCheckBox(list, index);
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.report_can_be_seen_by
                                                                                    ?.length > 0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Self
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"refdoctor"}
                                                                            type="checkbox"
                                                                            checked={x?.hivform?.report_can_be_seen_by?.includes(
                                                                                "refdoctor"
                                                                            )}
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    let list = [
                                                                                        ...x?.hivform
                                                                                            ?.report_can_be_seen_by,
                                                                                        value,
                                                                                    ];
                                                                                    handleCheckBox(list, index);
                                                                                } else {
                                                                                    let list =
                                                                                        x?.hivform?.report_can_be_seen_by.filter(
                                                                                            (item: string) => item !== value
                                                                                        );
                                                                                    handleCheckBox(list, index);
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.report_can_be_seen_by
                                                                                    ?.length > 0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Ref. Doctor
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"refagency"}
                                                                            type="checkbox"
                                                                            checked={x?.hivform?.report_can_be_seen_by?.includes(
                                                                                "refagency"
                                                                            )}
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    let list = [
                                                                                        ...x?.hivform
                                                                                            ?.report_can_be_seen_by,
                                                                                        value,
                                                                                    ];
                                                                                    handleCheckBox(list, index);
                                                                                } else {
                                                                                    let list =
                                                                                        x?.hivform?.report_can_be_seen_by.filter(
                                                                                            (item: string) => item !== value
                                                                                        );
                                                                                    handleCheckBox(list, index);
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.report_can_be_seen_by
                                                                                    ?.length > 0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Ref. Agency
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ paddingLeft: "20px" }}>
                                                                        <input
                                                                            value={"relative"}
                                                                            type="checkbox"
                                                                            checked={x?.hivform?.report_can_be_seen_by?.includes(
                                                                                "relative"
                                                                            )}
                                                                            onChange={(e) => {
                                                                                const { checked, value } = e.target;
                                                                                if (checked) {
                                                                                    let list = [
                                                                                        ...x?.hivform
                                                                                            ?.report_can_be_seen_by,
                                                                                        value,
                                                                                    ];
                                                                                    handleCheckBox(list, index);
                                                                                } else {
                                                                                    let list =
                                                                                        x?.hivform?.report_can_be_seen_by.filter(
                                                                                            (item: string) => item !== value
                                                                                        );
                                                                                    handleCheckBox(list, index);
                                                                                }
                                                                            }}
                                                                            required={
                                                                                x?.hivform?.report_can_be_seen_by
                                                                                    ?.length > 0
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                        />
                                                                        <span style={{ paddingLeft: "4px" }}>
                                                                            Relative
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid container spacing={3}>
                                                            <Grid item md={3}>
                                                                <p
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        color: "#131313",
                                                                    }}
                                                                >
                                                                    Counsellor Name*
                                                                </p>
                                                                <TextField
                                                                    name="hivform.counsellor_name"
                                                                    type="text"
                                                                    placeholder="Enter Counsellor Name"
                                                                    value={x?.hivform?.counsellor_name}
                                                                    className="input"
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    style={{ width: "100%", margin: "0" }}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    required={
                                                                        x?.hivform?.ref_by_doc_or_self === "doctor"
                                                                    }
                                                                    disabled={
                                                                        x?.hivform?.ref_by_doc_or_self === "self"
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item md={3}>
                                                                <p
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        color: "#131313",
                                                                    }}
                                                                >
                                                                    Counselling Date*
                                                                </p>
                                                                <input
                                                                    className="input"
                                                                    id="noTyping"
                                                                    name="hivform.counselling_date"
                                                                    type="date"
                                                                    value={x?.hivform?.counselling_date}
                                                                    style={{
                                                                        width: "100%",
                                                                        margin: "0",
                                                                        padding: "18.5px 14px",
                                                                        height: "40px",
                                                                        // background:""
                                                                    }}
                                                                    min={moment(new Date()).format("YYYY-MM-DD")}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    required={
                                                                        x?.hivform?.ref_by_doc_or_self === "doctor"
                                                                    }
                                                                    disabled={
                                                                        x?.hivform?.ref_by_doc_or_self === "self"
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                md={3}
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "flex-end",
                                                                }}
                                                            >
                                                                <sup
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        fontWeight: "600",
                                                                        color: "#131313",
                                                                        letterSpacing: "0.00938em",
                                                                    }}
                                                                >
                                                                    Upload Aadhaar Card*
                                                                </sup>
                                                                <input
                                                                    className="input"
                                                                    style={{
                                                                        width: "100%",
                                                                        marginTop: "17px",
                                                                        padding: "6px 14px",
                                                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                                                        borderRadius: "5px",
                                                                    }}
                                                                    accept=".jpg,.jpeg,.png"
                                                                    type="file"
                                                                    name="file"
                                                                    id="file"
                                                                    required
                                                                    onChange={(e) => handleFileSelected(e, index)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}

                                            {
                                                // validationStatus[index]?.exomeStatus &&
                                                x?.customerPackage &&
                                                x?.customerPackage?.length > 0 && x?.customerPackage?.some((data: any) => data?.consent_form_required === true) &&
                                                (<Grid
                                                    container
                                                    direction="row"
                                                    justify="space-between"
                                                    alignItems="flex-end"
                                                    spacing={2}
                                                    style={{
                                                        margin: "1rem auto",
                                                        background: "linear-gradient(to right, rgb(218 225 235)  100%, #f5f7fa 30%)",
                                                        borderRadius: "15px",
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                    }}
                                                >
                                                    <Grid
                                                        item
                                                        md={12}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            marginBottom: "-5px",
                                                            marginTop: 10,
                                                        }}
                                                    >
                                                        <h4 style={{

                                                            background: "rgba(0, 0, 0, 0.2)",
                                                            color: "black",
                                                            display: "block",
                                                            width: "100%",
                                                            padding: "8px 70px",
                                                            borderRadius: "15px",
                                                            fontWeight: "bold",
                                                            textAlign: "center"
                                                        }}>Exome FORM</h4>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={3}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            fontSize: "larger",
                                                            color: "#333",
                                                            marginBottom: "10px",
                                                        }}>
                                                            Doctor Name</p>
                                                        <TextField
                                                            className="input"
                                                            name="exomeForm.dr_name"
                                                            type="text"
                                                            placeholder="Enter Doctor Name"
                                                            value={x.exomeForm.dr_name || ""}
                                                            variant="outlined"
                                                            style={{ margin: "0", width: "100%", height: "40px" }}
                                                            onChange={(e) => handleInputChange(e, index)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={3}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            fontSize: "larger",
                                                            color: "#333",
                                                            marginBottom: "10px",
                                                        }}>Number</p>
                                                        <TextField
                                                            className="input"
                                                            name="exomeForm.dr_phonenumber"
                                                            type="number"
                                                            placeholder="Enter Number"
                                                            value={x.exomeForm.dr_phonenumber}
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            variant="outlined"
                                                            style={{ margin: "0", width: "100%", height: "40px" }}
                                                            onWheel={(e: any) => e.target.blur()}
                                                            onInput={(e: any) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                                    .toString()
                                                                    .slice(0, 10);
                                                            }}
                                                            onBlur={() => verifyMobileNew(index)}
                                                            onFocus={() => {
                                                                const list = [...inputList];
                                                                list[index].doctorNumber = true;
                                                                setInputList(list);
                                                            }}
                                                            helperText={
                                                                !x?.doctorNumber && "Incorrect Mobile Number"
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={3}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            fontSize: "larger",
                                                            color: "#333",
                                                            marginBottom: "10px",
                                                        }}>Email</p>
                                                        <TextField
                                                            className="input"
                                                            name="exomeForm.dr_email"
                                                            type="text"
                                                            placeholder="Enter Email"
                                                            value={x.exomeForm.dr_email}
                                                            variant="outlined"
                                                            style={{ margin: "0", width: "100%", height: "40px" }}
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            onBlur={() => verifyEmail(index)}
                                                            onFocus={() => {
                                                                const list = [...inputList];
                                                                list[index].isValidEmail = true;
                                                                setInputList(list);
                                                            }}
                                                        />
                                                        <sub style={{ color: "red" }}>
                                                            {!x?.isValidEmail ? "Please enter a valid e-mail id" : ""}
                                                        </sub>

                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={3}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            fontSize: "larger",
                                                            color: "#333",
                                                            marginBottom: "10px",
                                                        }}>Pre-test counsellor require</p>
                                                        <Select
                                                            className="input"
                                                            name="exomeForm.pre_test_counsellor"
                                                            variant="outlined"
                                                            value={x.exomeForm.pre_test_counsellor}
                                                            style={{ width: "100%", margin: "0", height: "40px" }}
                                                            onChange={(e) => handleInputChange(e, index)}
                                                        >
                                                            <MenuItem value="yes">Yes</MenuItem>
                                                            <MenuItem value="no">No</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            fontSize: "larger",
                                                            color: "#333",
                                                            marginBottom: "10px",
                                                        }}>Clinical History & Pedigree</p>
                                                        <TextField
                                                            name="exomeForm.clinical_history"
                                                            className="input"
                                                            type="text"
                                                            value={x.exomeForm.clinical_history}
                                                            placeholder="Enter Clinical History & Pedigree"
                                                            variant="outlined"
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            style={{ width: "100%" }}
                                                            multiline
                                                            rows={6}
                                                        />
                                                    </Grid>
                                                </Grid>)
                                            }
                                            {!pincode ? (
                                                <Grid item md={2} xs={10}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        fullWidth
                                                        onClick={() => setOpenLocationModal(true)}
                                                    // disabled={collection_date === ""}
                                                    >
                                                        Select Address
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                ""
                                            )}

                                            {currAllergyQn && currAllergyQn.length > 0 ? (
                                                <Grid
                                                    item
                                                    md={12}
                                                    style={{
                                                        backgroundColor: "#edd6d6",
                                                        marginTop: "10px",
                                                        border: "1px dashed",
                                                        borderRadius: "2px",
                                                        margin: "10px",
                                                    }}
                                                >
                                                    <h6 id="form-dialog-title">
                                                        Question For Allergy packages
                                                    </h6>

                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        style={{
                                                            margin: "0px 10px 10px 10px",
                                                            minWidth: "500px",
                                                            width: "70%",
                                                        }}
                                                    >
                                                        {currAllergyQn.map((data: any, index2: any) => {
                                                            return (
                                                                <>
                                                                    <Grid item xs={12} md={12}>
                                                                        <p>
                                                                            {index2 + 1}:{data.question_text} (If yes,
                                                                            please specify)*
                                                                        </p>

                                                                        <>
                                                                            <RadioGroup
                                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                                name="controlled-radio-buttons-group"
                                                                                value={data?.checked}
                                                                                onChange={(e) =>
                                                                                    allergyAnsHandler(
                                                                                        e.target.value,
                                                                                        index2,
                                                                                        index,
                                                                                        "checked"
                                                                                    )
                                                                                }
                                                                                row
                                                                            >
                                                                                <FormControlLabel
                                                                                    value="yes"
                                                                                    control={<Radio required />}
                                                                                    label="Yes"
                                                                                />
                                                                                <FormControlLabel
                                                                                    value="no"
                                                                                    control={<Radio required />}
                                                                                    label="No"
                                                                                />
                                                                            </RadioGroup>
                                                                        </>

                                                                        {(data?.checked === "yes") ? (
                                                                            <TextField
                                                                                className="input"
                                                                                name="allergy_question"
                                                                                type={
                                                                                    data.question_type === "number"
                                                                                        ? "number"
                                                                                        : "text"
                                                                                }
                                                                                value={data?.answer}
                                                                                variant="outlined"
                                                                                style={{ width: "100%", margin: "0" }}
                                                                                required
                                                                                inputProps={{ maxLength: 100 }}
                                                                                onChange={(e) => {
                                                                                    allergyAnsHandler(
                                                                                        data.question_type !== "number"
                                                                                            ? e.target.value
                                                                                            : data.question_type === "number" &&
                                                                                                Number(e.target.value) > 0 &&
                                                                                                Number(e.target.value) < 101
                                                                                                ? e.target.value
                                                                                                : "",
                                                                                        index2,
                                                                                        index,
                                                                                        "answer"
                                                                                    );
                                                                                }}
                                                                                placeholder="Type Here..."
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Grid>
                                                                </>
                                                            );
                                                        })}
                                                        <p style={{ fontSize: "17px", marginTop: "10px" }}>
                                                            * This information will be sent to the lab as Well
                                                            as Customer
                                                        </p>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                ""
                                            )}

                                            <Grid
                                                container
                                                spacing={2}
                                                // style={{ margin: "0 auto" }}
                                                style={
                                                    inputList[index]?.customerPackage?.length > 0
                                                        ? { display: "block", margin: "0 auto" }
                                                        : { display: "none" }
                                                }
                                            >
                                                <Grid item xs={12}>
                                                    {
                                                        inputList[index]?.customerPackage?.length > 0 ? (
                                                            <>
                                                                {windowWidth > 425 && (
                                                                    <TableContainer
                                                                        component="div"
                                                                        className={classes.tableContainer}
                                                                    >
                                                                        <Table size="small" aria-label="purchases">
                                                                            <TableHead>
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell align="center">
                                                                                        <b>Container Name</b>
                                                                                    </StyledTableCell>
                                                                                    <StyledTableCell align="center">
                                                                                        <b>Barcode</b>
                                                                                        <br />
                                                                                        <sup>
                                                                                            (Enter Barcode in numbers only)
                                                                                        </sup>
                                                                                    </StyledTableCell>
                                                                                    <StyledTableCell align="center">
                                                                                        <b>Action</b>
                                                                                    </StyledTableCell>
                                                                                    <StyledTableCell align="center">
                                                                                        <b>Collection Date & Time</b>
                                                                                    </StyledTableCell>
                                                                                    <StyledTableCell align="center">
                                                                                        <b>Collection status</b>
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {inputList[index]?.tubes &&
                                                                                    inputList[index]?.tubes?.length > 0 &&
                                                                                    inputList[index]?.tubes?.map(
                                                                                        (data: any, tubeIndex: any) => {
                                                                                            return (
                                                                                                <StyledTableRow>
                                                                                                    <StyledTableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        align="center"
                                                                                                    >
                                                                                                        {data?.name}
                                                                                                    </StyledTableCell>
                                                                                                    <StyledTableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        align="center"
                                                                                                    >
                                                                                                        {/* <BootstrapTooltip
                                                  arrow
                                                  title={
                                                    data?.code?.length > 4 &&
                                                    data.code === tempCode &&
                                                    validBarcode?.status ===
                                                      false ? (
                                                      <span
                                                        style={{
                                                          color: "white",
                                                          fontSize: 16,
                                                        }}
                                                      >
                                                        Duplicate Barcode!
                                                      </span>
                                                    ) : inputList[
                                                        index
                                                      ].tubes.filter(
                                                        (val: any) =>
                                                          val.code &&
                                                          val.code === data.code
                                                      ).length > 1 ? (
                                                      <span
                                                        style={{
                                                          color: "white",
                                                          fontSize: 16,
                                                        }}
                                                      >
                                                        Barcode already used in
                                                        this booking!
                                                      </span>
                                                    ) : (
                                                      ""
                                                    )
                                                  }
                                                > */}
                                                                                                        <TextField
                                                                                                            variant="outlined"
                                                                                                            fullWidth
                                                                                                            style={{ width: "100px" }}
                                                                                                            value={data?.code}
                                                                                                            error={data.code.length > 0 && data.code.length < 7}
                                                                                                            helperText={
                                                                                                                data.code.length > 0 && data.code.length < 7 ? "Minimum length must be 7!" : ""
                                                                                                            }
                                                                                                            required={
                                                                                                                data?.status !==
                                                                                                                "pending" &&
                                                                                                                !data?.is_snr &&
                                                                                                                data?.status !==
                                                                                                                "rejected"
                                                                                                            }
                                                                                                            onChange={(e) => {
                                                                                                                const code =
                                                                                                                    e.target.value.replace(
                                                                                                                        /[^0-9]/g,
                                                                                                                        ""
                                                                                                                    );
                                                                                                                if (code) {
                                                                                                                    updateResultData(
                                                                                                                        index,
                                                                                                                        tubeIndex,
                                                                                                                        "code",
                                                                                                                        String(code)
                                                                                                                    );
                                                                                                                    updateResultData(
                                                                                                                        index,
                                                                                                                        tubeIndex,
                                                                                                                        "status",
                                                                                                                        ""
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    updateResultData(
                                                                                                                        index,
                                                                                                                        tubeIndex,
                                                                                                                        "code",
                                                                                                                        ""
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                        />
                                                                                                        <div>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    color: "red",
                                                                                                                    fontWeight: "bolder",
                                                                                                                }}
                                                                                                            >
                                                                                                                {data?.err}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {/* </BootstrapTooltip> */}
                                                                                                    </StyledTableCell>
                                                                                                    <StyledTableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        align="center"
                                                                                                    >
                                                                                                        <Select
                                                                                                            variant="outlined"
                                                                                                            value={
                                                                                                                data?.status || "none"
                                                                                                            }
                                                                                                            disabled={
                                                                                                                data?.code !== ""
                                                                                                            }
                                                                                                            onChange={(e) => {
                                                                                                                const status =
                                                                                                                    e.target.value;
                                                                                                                updateResultData(
                                                                                                                    index,
                                                                                                                    tubeIndex,
                                                                                                                    "status",
                                                                                                                    status
                                                                                                                );

                                                                                                                if (data?.code) {
                                                                                                                    updateResultData(
                                                                                                                        index,
                                                                                                                        tubeIndex,
                                                                                                                        "code",
                                                                                                                        ""
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            <MenuItem
                                                                                                                value="none"
                                                                                                                disabled
                                                                                                            >
                                                                                                                None
                                                                                                            </MenuItem>
                                                                                                            <MenuItem value="rejected">
                                                                                                                Rejected
                                                                                                            </MenuItem>
                                                                                                            <MenuItem value="pending">
                                                                                                                Pending for Pickup
                                                                                                            </MenuItem>
                                                                                                        </Select>
                                                                                                    </StyledTableCell>
                                                                                                    <StyledTableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        align="center"
                                                                                                    >
                                                                                                        <TextField
                                                                                                            id="datetime-local"
                                                                                                            variant="outlined"
                                                                                                            type="datetime-local"
                                                                                                            fullWidth
                                                                                                            disabled
                                                                                                            value={moment().format(
                                                                                                                "YYYY-MM-DDTHH:mm"
                                                                                                            )}
                                                                                                        />
                                                                                                    </StyledTableCell>
                                                                                                    <StyledTableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        align="center"
                                                                                                    >
                                                                                                        <Chip
                                                                                                            label={
                                                                                                                data.is_snr
                                                                                                                    ? "Rejected"
                                                                                                                    : data.code !== ""
                                                                                                                        ? "Collected"
                                                                                                                        : data.status ===
                                                                                                                            "rejected"
                                                                                                                            ? "Rejected"
                                                                                                                            : data.status ===
                                                                                                                                "pending"
                                                                                                                                ? "Pending for Pickup"
                                                                                                                                : "Collection Pending"
                                                                                                            }
                                                                                                            color={
                                                                                                                data.is_snr
                                                                                                                    ? "error"
                                                                                                                    : data.code !== ""
                                                                                                                        ? "success"
                                                                                                                        : data.status ===
                                                                                                                            "rejected"
                                                                                                                            ? "secondary"
                                                                                                                            : data.status ===
                                                                                                                                "pending"
                                                                                                                                ? "warning"
                                                                                                                                : "default"
                                                                                                            }
                                                                                                        />
                                                                                                    </StyledTableCell>
                                                                                                </StyledTableRow>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                )}
                                                                {windowWidth <= 425 && (
                                                                    <>
                                                                        {inputList[index]?.tubes &&
                                                                            inputList[index]?.tubes?.length > 0 &&
                                                                            inputList[index]?.tubes?.map(
                                                                                (data: any, tubeIndex: any) => (
                                                                                    <Grid
                                                                                        container
                                                                                        spacing={2}
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            justifyContent: "center",
                                                                                            alignItems: "center",
                                                                                            margin: "1px 0",
                                                                                            borderRadius: "5px",
                                                                                            background:
                                                                                                "linear-gradient(120deg, #5983e8, #00e4d0)",
                                                                                        }}
                                                                                    >
                                                                                        <Grid
                                                                                            item
                                                                                            xs={12}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-between",
                                                                                                alignItems: "center",
                                                                                                padding: "2px 20px",
                                                                                            }}
                                                                                        >
                                                                                            <div>{data?.name}</div>
                                                                                            <Chip
                                                                                                label={
                                                                                                    data.is_snr
                                                                                                        ? "Rejected"
                                                                                                        : data.code !== ""
                                                                                                            ? "Collected"
                                                                                                            : data.status === "rejected"
                                                                                                                ? "Rejected"
                                                                                                                : data.status === "pending"
                                                                                                                    ? "Pending for Pickup"
                                                                                                                    : "Collection Pending"
                                                                                                }
                                                                                                color={
                                                                                                    data.is_snr
                                                                                                        ? "error"
                                                                                                        : data.code !== ""
                                                                                                            ? "success"
                                                                                                            : data.status === "rejected"
                                                                                                                ? "secondary"
                                                                                                                : data.status === "pending"
                                                                                                                    ? "warning"
                                                                                                                    : "default"
                                                                                                }
                                                                                            />
                                                                                        </Grid>
                                                                                        <Grid
                                                                                            item
                                                                                            xs={12}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "center",
                                                                                                alignItems: "center",
                                                                                                flexDirection: "column",
                                                                                            }}
                                                                                        >
                                                                                            <TextField
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                size="small"
                                                                                                value={data?.code}
                                                                                                required={
                                                                                                    data?.status !== "pending" &&
                                                                                                    !data?.is_snr &&
                                                                                                    data?.status !== "rejected"
                                                                                                }
                                                                                                label="Barcode"
                                                                                                onChange={(e) => {
                                                                                                    const code =
                                                                                                        e.target.value.replace(
                                                                                                            /[^0-9]/g,
                                                                                                            ""
                                                                                                        );
                                                                                                    if (code) {
                                                                                                        updateResultData(
                                                                                                            index,
                                                                                                            tubeIndex,
                                                                                                            "code",
                                                                                                            String(code)
                                                                                                        );
                                                                                                        updateResultData(
                                                                                                            index,
                                                                                                            tubeIndex,
                                                                                                            "status",
                                                                                                            ""
                                                                                                        );
                                                                                                    } else {
                                                                                                        updateResultData(
                                                                                                            index,
                                                                                                            tubeIndex,
                                                                                                            "code",
                                                                                                            ""
                                                                                                        );
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                            <div>
                                                                                                <span
                                                                                                    style={{
                                                                                                        color: "#fff",
                                                                                                        fontWeight: "bolder",
                                                                                                    }}
                                                                                                >
                                                                                                    {data?.err}
                                                                                                </span>
                                                                                            </div>
                                                                                        </Grid>
                                                                                        <Grid item xs={12}>
                                                                                            <TextField
                                                                                                select
                                                                                                variant="outlined"
                                                                                                value={data?.status || "none"}
                                                                                                disabled={data?.code !== ""}
                                                                                                fullWidth
                                                                                                size="small"
                                                                                                label="Status"
                                                                                                onChange={(e) => {
                                                                                                    const status = e.target.value;
                                                                                                    updateResultData(
                                                                                                        index,
                                                                                                        tubeIndex,
                                                                                                        "status",
                                                                                                        status
                                                                                                    );

                                                                                                    if (data?.code) {
                                                                                                        updateResultData(
                                                                                                            index,
                                                                                                            tubeIndex,
                                                                                                            "code",
                                                                                                            ""
                                                                                                        );
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <MenuItem value="none" disabled>
                                                                                                    None
                                                                                                </MenuItem>
                                                                                                <MenuItem value="rejected">
                                                                                                    Rejected
                                                                                                </MenuItem>
                                                                                                <MenuItem value="pending">
                                                                                                    Pending for Pickup
                                                                                                </MenuItem>
                                                                                            </TextField>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                )
                                                                            )}
                                                                    </>
                                                                )}
                                                            </>
                                                        ) : (
                                                            ""
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>
                                        </>
                                    );
                                })}

                            <Grid item lg={3} md={3} xs={12}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <span style={{ fontWeight: "bold" }}>Or&nbsp;&nbsp;</span>
                                    <Button
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        style={
                                            (search.length === 10 && mobNumErr === ""
                                                ? false
                                                : true) || allUHIDCustomer.length === 10
                                                ? {
                                                    textTransform: "capitalize",
                                                    background: "#dfe6e9",
                                                    color: "#b2bec3",
                                                    fontWeight: "bold",
                                                }
                                                : {
                                                    textTransform: "capitalize",
                                                    background: "#1976d2",
                                                    color: "#fff",
                                                }
                                        }
                                        disabled={
                                            (search.length === 10 && mobNumErr === ""
                                                ? false
                                                : true) || allUHIDCustomer.length === 10
                                        }
                                        onClick={handleAddMemberModal}
                                        fullWidth
                                    >
                                        Add New Member
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {oneplusOneChecker && (
                            <p style={{ color: "red" }}>
                                This is a one plus one booking. Please select at least two or four members
                                members.
                            </p>
                        )}

                        <Grid
                            container
                            spacing={3}
                            direction="row"
                            justify="center"
                            alignItems="center"
                            style={{ margin: "1rem auto" }}
                        >
                            {windowWidth > 425 && (
                                <Grid item xs={12} md={7} style={{ padding: "10px" }}>
                                    <div className="price-details-new-booking-cc">
                                        <table style={{ width: "100%", margin: "0" }}>
                                            <thead>
                                                <tr>
                                                    <td className="cell" align="center">
                                                        Sr No.
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Patient with Age
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Test code
                                                    </td>

                                                    <td className="cell" align="center">
                                                        Test Name
                                                    </td>

                                                    <td className="cell" align="center">
                                                        TAT
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Price
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Camp Discount
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {inputList &&
                                                    inputList.length > 0 &&
                                                    inputList.map(
                                                        (customerDetails: any, indexMain: number) =>
                                                            customerDetails?.customerPackage &&
                                                            customerDetails?.customerPackage.length > 0 &&
                                                            customerDetails?.customerPackage.map(
                                                                (packageItem: any, index: any) => {
                                                                    const currentIndex = globalIndex;
                                                                    globalIndex++;
                                                                    return (

                                                                        <tr>
                                                                            <td className="cell" align="center">
                                                                                {currentIndex + 1}
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                {customerDetails?.customerDesignation +
                                                                                    " " +
                                                                                    customerDetails?.customerName +
                                                                                    " " +
                                                                                    `(${customerDetails?.customerAge})`}
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                {packageItem?.code}
                                                                            </td>
                                                                            <td className="cell" align="left">
                                                                                <a
                                                                                    onClick={() => {
                                                                                        setSinglePackage(packageItem);
                                                                                        setPaneOpen(true);
                                                                                    }}
                                                                                    className={classes.packageLink}
                                                                                >
                                                                                    {packageItem?.name}
                                                                                    <br />
                                                                                    Fasting : {packageItem?.fasting_time}
                                                                                </a>
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                {packageItem.tat_time}
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                ₹ {packageItem.package_lab_prices}
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                {campCouponData !== ""
                                                                                    ? campCouponData.packages.map(
                                                                                        (val: any) => {
                                                                                            if (
                                                                                                packageItem.id === val.id &&
                                                                                                coupon !== 0
                                                                                            ) {
                                                                                                return (
                                                                                                    "₹" +
                                                                                                    Math.floor(
                                                                                                        (packageItem.package_lab_prices *
                                                                                                            campCouponData.discount) /
                                                                                                        100
                                                                                                    )
                                                                                                );
                                                                                            } else {
                                                                                                return "";
                                                                                            }
                                                                                        }
                                                                                    )
                                                                                    : ""}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )
                                                    )}
                                                <tr>
                                                    <td colSpan={5}>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td
                                                                    className="cell"
                                                                    align="left"
                                                                    rowSpan={4}
                                                                    colSpan={2}
                                                                    style={{ width: "100%" }}
                                                                    valign="top"
                                                                >
                                                                    <Grid container spacing={1} direction="row">
                                                                        <Grid item xs={12}>
                                                                            <p>Enter Coupon or Scan Loyalty Card</p>
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            {campCouponCode !== "" ? (
                                                                                <TextField
                                                                                    className="input"
                                                                                    placeholder="Enter Coupon"
                                                                                    value={campCouponCode}
                                                                                    variant="outlined"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        margin: "0",
                                                                                        padding: "0",
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <Autocomplete
                                                                                    id="coupon"
                                                                                    onChange={(event, newValue) => {
                                                                                        if (newValue) {
                                                                                            let obj = JSON.parse(
                                                                                                JSON.stringify(
                                                                                                    newValue,
                                                                                                    null,
                                                                                                    " "
                                                                                                )
                                                                                            );
                                                                                            setCoupon(obj?.id as Number);
                                                                                            setCouponCode(
                                                                                                obj?.code as string
                                                                                            );
                                                                                            // setCouponType(obj.is_red_cash);
                                                                                        }
                                                                                    }}
                                                                                    inputValue={couponCode}
                                                                                    options={couponList?.results || []}
                                                                                    freeSolo
                                                                                    blurOnSelect
                                                                                    onInputChange={(
                                                                                        event,
                                                                                        newInputValue
                                                                                    ) => {
                                                                                        clearTimeout(timer.current);
                                                                                        setCouponCode(newInputValue);
                                                                                        timer.current = setTimeout(() => {
                                                                                            getCoupons(
                                                                                                `${newInputValue}&org_type=homedx`
                                                                                            );
                                                                                        }, 1000);
                                                                                        if (newInputValue === "") {
                                                                                            setCoupon(0);
                                                                                            setDiscount(0);
                                                                                            setTncMessage("");
                                                                                            setCouponMessage("");
                                                                                        }
                                                                                    }}
                                                                                    getOptionLabel={(option: any) =>
                                                                                        option?.code
                                                                                    }
                                                                                    getOptionDisabled={(option: any) =>
                                                                                        option?.minimum_price > totalPrice
                                                                                    }
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            className="input"
                                                                                            {...params}
                                                                                            placeholder="Enter Coupon/Loyalty Scan"
                                                                                            variant="outlined"
                                                                                            disabled={
                                                                                                inputList[0]?.customerPackage
                                                                                                    ?.length === 0
                                                                                            }
                                                                                            inputProps={{
                                                                                                ...params.inputProps,
                                                                                                onKeyDown: (e) => {
                                                                                                    if (e.key === "Enter") {
                                                                                                        e.stopPropagation();
                                                                                                    }
                                                                                                },
                                                                                            }}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                margin: "0",
                                                                                                padding: "0",
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            <Button
                                                                                variant="contained"
                                                                                fullWidth
                                                                                color="primary"
                                                                                onClick={applyCoupon}
                                                                                disabled={campCouponCode !== ""}
                                                                            >
                                                                                {campCouponCode !== ""
                                                                                    ? "Camp Coupon Applied"
                                                                                    : "Apply"}
                                                                            </Button>
                                                                        </Grid>
                                                                        <p
                                                                            style={{
                                                                                color: "#8e24aa",
                                                                                fontSize: "14px",
                                                                                fontWeight: "bold",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            {couponMessage} <br />
                                                                            {tncMessage}
                                                                        </p>
                                                                        {providerData?.length === 1 &&
                                                                            providerData[0] === "Astrazeneca" ? (
                                                                            <Grid item xs={12}>
                                                                                <sup
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        marginLeft: "15px",
                                                                                        marginTop: "15px",
                                                                                        background: "#fff",
                                                                                        color: "rgba(0, 0, 0, 0.54)",
                                                                                        letterSpacing: "0.00938em",
                                                                                    }}
                                                                                >
                                                                                    Upload Image/Photograph of Astrazeneca
                                                                                    Coupon
                                                                                </sup>
                                                                                <input
                                                                                    className="input"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        marginTop: "-20px",
                                                                                        height: "45px",
                                                                                        padding: "13.5px 20px",
                                                                                        border:
                                                                                            "1px solid rgba(0, 0, 0, 0.23)",
                                                                                        borderRadius: "5px",
                                                                                    }}
                                                                                    type="file"
                                                                                    name="file"
                                                                                    id="file"
                                                                                    accept=".pdf, .jpeg, .png, .jpg"
                                                                                    multiple
                                                                                    required={
                                                                                        providerData?.length === 1 &&
                                                                                        providerData[0] === "Astrazeneca"
                                                                                    }
                                                                                    onChange={fileSelectedHandler1}
                                                                                />
                                                                            </Grid>
                                                                        ) : null}

                                                                        <Grid item container xs={12}>
                                                                            <Grid item md={2}>
                                                                                {" "}
                                                                                OR{" "}
                                                                            </Grid>
                                                                            <Grid item md={10}>
                                                                                <div
                                                                                    style={{
                                                                                        borderBottom: "1px dashed white",
                                                                                        margin: "10px 0px",
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                select
                                                                                fullWidth
                                                                                size="small"
                                                                                label="Coupon deduct from"
                                                                                variant="outlined"
                                                                                value={couponDeductFrom}
                                                                                disabled
                                                                                onChange={(e) =>
                                                                                    setCouponDeductFrom(e.target.value)
                                                                                }
                                                                            >
                                                                                <MenuItem value="center">
                                                                                    Client Share
                                                                                </MenuItem>
                                                                                <MenuItem value="redcliffe">
                                                                                    RCL Share
                                                                                </MenuItem>
                                                                            </TextField>
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <TextField
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                label="Amount"
                                                                                variant="outlined"
                                                                                value={couponAmount}
                                                                                disabled={discountApplied}
                                                                                onChange={(e) =>
                                                                                    Number(e.target.value) > -1 &&
                                                                                    totalPrice >=
                                                                                    Number(e.target.value) &&
                                                                                    setCouponAmount(e.target.value)
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            <Button
                                                                                variant="contained"
                                                                                fullWidth
                                                                                disabled={couponAmount === ""}
                                                                                color={
                                                                                    discountApplied
                                                                                        ? "warning"
                                                                                        : "success"
                                                                                }
                                                                                onClick={
                                                                                    discountApplied
                                                                                        ? removeCoupon
                                                                                        : applyCouponAmt
                                                                                }
                                                                            >
                                                                                {discountApplied ? "Remove" : "Apply"}
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <tr>
                                                                        <td
                                                                            align="left"
                                                                            rowSpan={5}
                                                                            colSpan={2}
                                                                            style={{ width: "60%", marginTop: "20px" }}
                                                                        // valign="top"
                                                                        >
                                                                            {alreadyARedPro ? (
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        marginBottom: "16px",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                    }}

                                                                                >

                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="secondary"
                                                                                        size="small"
                                                                                        style={{
                                                                                            fontSize: "16px",
                                                                                            backgroundColor: "green",
                                                                                            color: "white",
                                                                                        }}
                                                                                        disabled
                                                                                    >
                                                                                        Already a VIP Member
                                                                                    </Button>
                                                                                    <Tooltip
                                                                                        title={TooltipContent()}
                                                                                        classes={{ tooltip: classes.customTooltip }}
                                                                                    >
                                                                                        <InfoRoundedIcon
                                                                                            style={{
                                                                                                color: "black",
                                                                                                marginTop: "6px",
                                                                                                marginRight: "10px",
                                                                                            }}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            ) : (
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        marginBottom: "16px",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",

                                                                                    }}

                                                                                >

                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="secondary"
                                                                                        size="small"
                                                                                        style={{ fontSize: "16px" }}
                                                                                        onClick={() => setOpenLoyaltyModal(true)}

                                                                                    >
                                                                                        Add VIP Membership
                                                                                    </Button>
                                                                                    <Tooltip
                                                                                        title={TooltipContent()}
                                                                                        classes={{ tooltip: classes.customTooltip }}
                                                                                    >
                                                                                        <InfoRoundedIcon
                                                                                            style={{
                                                                                                color: "black",
                                                                                                marginTop: "6px",
                                                                                                marginRight: "10px",
                                                                                            }}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>


                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="right"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    Gross
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="center"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    ₹ {Math.floor(totalPrice)}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td
                                                                    className="cell"
                                                                    align="right"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    Discount
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="center"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    ₹ {Math.floor(discount)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="cell" align="right">
                                                                    <h4 className="totalPrice">
                                                                        Diagnostic Charge
                                                                    </h4>
                                                                </td>
                                                                <td className="cell" align="center">
                                                                    <h4 className="totalPrice">
                                                                        ₹ {Math.floor(diagnosticFee)}
                                                                    </h4>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td
                                                                    className="cell"
                                                                    align="right"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    VIP Membership Price
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="center"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    ₹ {Math.floor(proMembershipPrice)}
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <tr>
                                                                    <td
                                                                        className="cell"
                                                                        align="right"
                                                                        style={{ width: "20%" }}
                                                                    >
                                                                        VIP Membership Discount
                                                                    </td>
                                                                    <td
                                                                        className="cell"
                                                                        align="center"
                                                                        style={{ width: "20%" }}
                                                                    >
                                                                        ₹{" "}
                                                                        {redProMembershipDiscount > 0
                                                                            ? Math.floor(redProMembershipDiscount)
                                                                            : 0}
                                                                    </td>
                                                                </tr>

                                                                <td className="cell" align="right">
                                                                    <h4 className="totalPrice">Net Amount</h4>
                                                                </td>
                                                                <td className="cell" align="center">
                                                                    <h4 className="totalPrice">
                                                                        ₹ {Math.floor(netPrice)}
                                                                    </h4>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>
                            )}
                            {windowWidth <= 425 && (
                                <Grid item xs={12} md={7}>
                                    <div className="price-details-new-booking-cc-mobile">
                                        <table style={{ width: "100%", margin: "0" }}>
                                            <thead>
                                                <tr>
                                                    <td className="cell" align="center">
                                                        Patient with Age
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Test Name with Code
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Price
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {inputList &&
                                                    inputList.length > 0 &&
                                                    inputList.map(
                                                        (customerDetails: any, index: number) =>
                                                            customerDetails?.customerPackage &&
                                                            customerDetails?.customerPackage.length > 0 &&
                                                            customerDetails?.customerPackage.map(
                                                                (packageItem: any, index: any) => {
                                                                    return (
                                                                        <tr>
                                                                            <td className="cell" align="center">
                                                                                {customerDetails?.customerDesignation +
                                                                                    " " +
                                                                                    customerDetails?.customerName +
                                                                                    " " +
                                                                                    `(${customerDetails?.customerAge})`}
                                                                            </td>
                                                                            <td className="cell" align="left">
                                                                                <a
                                                                                    onClick={() => {
                                                                                        setSinglePackage(packageItem);
                                                                                        setPaneOpen(true);
                                                                                    }}
                                                                                    className={classes.packageLink}
                                                                                >
                                                                                    {packageItem?.name +
                                                                                        " " +
                                                                                        packageItem?.code}
                                                                                    <br />
                                                                                    Fasting : {packageItem?.fasting_time}
                                                                                </a>
                                                                            </td>
                                                                            <td className="cell" align="center">
                                                                                ₹ {packageItem.package_lab_prices}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )
                                                    )}
                                                <tr>
                                                    <td colSpan={5}>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td
                                                                    className="cell"
                                                                    align="left"
                                                                    rowSpan={4}
                                                                    colSpan={2}
                                                                    style={{ width: "100%" }}
                                                                    valign="top"
                                                                >
                                                                    <Grid
                                                                        container
                                                                        spacing={1}
                                                                        direction="column"
                                                                    >

                                                                        <Grid item xs={12}>
                                                                            {campCouponCode !== "" ? (
                                                                                <TextField
                                                                                    className="input"
                                                                                    placeholder="Enter Coupon"
                                                                                    value={campCouponCode}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    size="small"
                                                                                />
                                                                            ) : (
                                                                                <Autocomplete
                                                                                    id="coupon"
                                                                                    onChange={(event, newValue) => {
                                                                                        if (newValue) {
                                                                                            let obj = JSON.parse(
                                                                                                JSON.stringify(
                                                                                                    newValue,
                                                                                                    null,
                                                                                                    " "
                                                                                                )
                                                                                            );
                                                                                            setCoupon(obj?.id as Number);
                                                                                            setCouponCode(
                                                                                                obj?.code as string
                                                                                            );
                                                                                            // setCouponType(obj.is_red_cash);
                                                                                        }
                                                                                    }}
                                                                                    inputValue={couponCode}
                                                                                    options={couponList?.results || []}
                                                                                    freeSolo
                                                                                    blurOnSelect
                                                                                    onInputChange={(
                                                                                        event,
                                                                                        newInputValue
                                                                                    ) => {
                                                                                        clearTimeout(timer.current);
                                                                                        setCouponCode(newInputValue);
                                                                                        timer.current = setTimeout(() => {
                                                                                            getCoupons(
                                                                                                `${newInputValue}&org_type=homedx`
                                                                                            );
                                                                                        }, 1000);
                                                                                        if (newInputValue === "") {
                                                                                            setCoupon(0);
                                                                                            setDiscount(0);
                                                                                            setTncMessage("");
                                                                                            setCouponMessage("");
                                                                                        }
                                                                                    }}
                                                                                    getOptionLabel={(option: any) =>
                                                                                        option?.code
                                                                                    }
                                                                                    getOptionDisabled={(option: any) =>
                                                                                        option?.minimum_price > totalPrice
                                                                                    }
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            // className="input"
                                                                                            {...params}
                                                                                            placeholder="Enter Coupon/Loyalty Scan"
                                                                                            variant="outlined"
                                                                                            disabled={
                                                                                                inputList[0]?.customerPackage
                                                                                                    ?.length === 0
                                                                                            }
                                                                                            inputProps={{
                                                                                                ...params.inputProps,
                                                                                                onKeyDown: (e) => {
                                                                                                    if (e.key === "Enter") {
                                                                                                        e.stopPropagation();
                                                                                                    }
                                                                                                },
                                                                                            }}
                                                                                            fullWidth
                                                                                            size="small"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Button
                                                                                variant="contained"
                                                                                fullWidth
                                                                                color="primary"
                                                                                onClick={applyCoupon}
                                                                                disabled={campCouponCode !== ""}
                                                                            >
                                                                                {campCouponCode !== ""
                                                                                    ? "Camp Coupon Applied"
                                                                                    : "Apply"}
                                                                            </Button>
                                                                        </Grid>
                                                                        <p
                                                                            style={{
                                                                                color: "#8e24aa",
                                                                                fontSize: "14px",
                                                                                fontWeight: "bold",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            {couponMessage} <br />
                                                                            {tncMessage}
                                                                        </p>

                                                                        {providerData?.length === 1 &&
                                                                            providerData[0] === "Astrazeneca" ? (
                                                                            <Grid item xs={12}>
                                                                                <sup
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        marginLeft: "15px",
                                                                                        marginTop: "15px",
                                                                                        background: "#fff",
                                                                                        color: "rgba(0, 0, 0, 0.54)",
                                                                                        letterSpacing: "0.00938em",
                                                                                    }}
                                                                                >
                                                                                    Upload Image/Photograph of Astrazeneca
                                                                                    Coupon
                                                                                </sup>
                                                                                <input
                                                                                    className="input"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        marginTop: "-20px",
                                                                                        height: "45px",
                                                                                        padding: "13.5px 20px",
                                                                                        border:
                                                                                            "1px solid rgba(0, 0, 0, 0.23)",
                                                                                        borderRadius: "5px",
                                                                                    }}
                                                                                    type="file"
                                                                                    name="file"
                                                                                    id="file"
                                                                                    accept=".pdf, .jpeg, .png, .jpg"
                                                                                    multiple
                                                                                    required={
                                                                                        providerData?.length === 1 &&
                                                                                        providerData[0] === "Astrazeneca"
                                                                                    }
                                                                                    onChange={fileSelectedHandler1}
                                                                                />
                                                                            </Grid>
                                                                        ) : null}

                                                                        <Grid item container xs={12}>
                                                                            <Grid item md={12}>
                                                                                <div
                                                                                    style={{
                                                                                        borderBottom: "1px dashed white",
                                                                                        margin: "10px 0px",
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                select
                                                                                fullWidth
                                                                                size="small"
                                                                                label="Coupon deduct from"
                                                                                variant="outlined"
                                                                                value={couponDeductFrom}
                                                                                disabled
                                                                                onChange={(e) =>
                                                                                    setCouponDeductFrom(e.target.value)
                                                                                }
                                                                            >
                                                                                <MenuItem value="center">
                                                                                    Client Share
                                                                                </MenuItem>
                                                                                <MenuItem value="redcliffe">
                                                                                    RCL Share
                                                                                </MenuItem>
                                                                            </TextField>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                label="Amount"
                                                                                variant="outlined"
                                                                                value={couponAmount}
                                                                                disabled={discountApplied}
                                                                                onChange={(e) =>
                                                                                    Number(e.target.value) > -1 &&
                                                                                    totalPrice >=
                                                                                    Number(e.target.value) &&
                                                                                    setCouponAmount(e.target.value)
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Button
                                                                                variant="contained"
                                                                                fullWidth
                                                                                disabled={couponAmount === ""}
                                                                                color={
                                                                                    discountApplied
                                                                                        ? "warning"
                                                                                        : "success"
                                                                                }
                                                                                onClick={
                                                                                    discountApplied
                                                                                        ? removeCoupon
                                                                                        : applyCouponAmt
                                                                                }
                                                                            >
                                                                                {discountApplied ? "Remove" : "Apply"}
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="right"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    Gross
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="center"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    ₹ {Math.floor(totalPrice)}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td
                                                                    className="cell"
                                                                    align="right"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    Discount
                                                                </td>
                                                                <td
                                                                    className="cell"
                                                                    align="center"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    ₹ {Math.floor(discount)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="cell" align="right">
                                                                    <h4 className="totalPrice">
                                                                        Diagnostic Charge
                                                                    </h4>
                                                                </td>
                                                                <td className="cell" align="center">
                                                                    <h4 className="totalPrice">
                                                                        ₹ {Math.floor(diagnosticFee)}
                                                                    </h4>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="cell" align="right">
                                                                    <h4 className="totalPrice">Net Amount</h4>
                                                                </td>
                                                                <td className="cell" align="center">
                                                                    <h4 className="totalPrice">
                                                                        ₹ {Math.floor(netPrice)}
                                                                    </h4>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>
                            )}


                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                label="Booking Remarks"
                                variant="outlined"
                                className={"input"}
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </Grid>
                        <div className={classes.buttonContainer}>
                            <FormControlLabel
                                className="agreed"
                                control={<Checkbox name="agree" checked={agree} />}
                                onChange={() => setAgree(!agree)}
                                label="You hereby affirm & authorize Redcliffe Labs to process the personal data as per the Privacy Policy."
                            />
                        </div>
                        {validateNbsStatus && dataNbs.history === "" ? (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                <p>Please fill all mandatory fields of NBS Form to continue.</p>
                            </div>
                        ) : (
                            ""
                        )}
                        {validateHistoStatus && relevantClinicalHistory === "" ? (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                <p>
                                    Please fill all mandatory fields of HistoPathology Form to
                                    continue.
                                </p>
                            </div>
                        ) : (
                            ""
                        )}
                        {validateHistoStatus || !!relevantClinicalHistory ? (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                <p>
                                    Note - Final test of histopathology samples (Small, Medium,
                                    Large, & Extra Large) would be decided by NRL Noida post
                                    sample receiving. Intact samples shall not be returned back
                                    once processed.
                                </p>
                            </div>
                        ) : (
                            ""
                        )}

                        {/* {checkGenomic && !isGenomicFilled ? (
              <p style={{ color: "red", textAlign: "center" }}>
                Please fill and submit genomic form
              </p>
            ) : (
              ""
            )} */}
                        {
                            (validateBiomarkerLatestStatus && (
                                inputList.some((item: any) => item?.isEnableBiomarker && !item?.bioMarkerFormData)
                                // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.nature_of_conception &&
                                // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.lmp_date &&
                                // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.previous_history &&
                                // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.present_pregnacy &&
                                // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.other_history &&
                                // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.date_of_usg &&
                                // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.crl &&
                                // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.attachment_one
                            )
                                ? true
                                : false) ? (
                                <p
                                    style={{
                                        textAlign: "center",
                                        color: "red",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Please fill all mandatory fields of Bio Marker form to continue.
                                </p>
                            ) : (
                                ""
                            )}
                        {(validateQuadrupleForm && (
                            // !inputList[0]?.quadrupleFormData?.weight||
                            // !inputList[0]?.quadrupleFormData?.lmp_date ||
                            // !inputList[0]?.quadrupleFormData?.date_of_usg ||
                            // !(inputList[0]?.quadrupleFormData?.nature_of_conception)||
                            // !inputList[0]?.quadrupleFormData?.previous_history||
                            //  !inputList[0]?.quadrupleFormData?.present_pregnacy||
                            // !inputList[0]?.quadrupleFormData?.crl||
                            // !inputList[0]?.quadrupleFormData?.attachment_one
                            inputList.some((item: any) => item?.isEnableQuadruple && !item?.quadrupleFormData)
                        )
                            ? true
                            : false) ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                Please fill all mandatory fields of Quadruple Marker form to continue.
                            </p>
                        ) : (
                            ""
                        )}
                        {/* <div className={classes.buttonContainer}>
              {notificationData.centreType === "direct_client" ||
              notificationData   inputList.some((item: any) => item?.isEnableQuadruple &&                 
                  // !item?.quadrupleFormData?.weight||
                  // !item?.quadrupleFormData?.lmp_date ||
                  // !item?.quadrupleFormData?.date_of_usg ||
                  // !item?.quadrupleFormData?.nature_of_conception||
                  // !item?.quadrupleFormData?.previous_history||
                  // !item?.quadrupleFormData?.present_pregnacy||
                  // !item?.quadrupleFormData?.crl ||
                  // !item.centreType === "GE Lab" ? (
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  style={{ marginLeft: "1rem", marginBottom: "20px" }}
                  disabled={loading || disableBooking || isDuplicateTube}
                >
                  Proceed for booking
                </Button>
              ) : (
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  style={{ marginLeft: "1rem", marginBottom: "20px" }}
                  disabled={
                    loading ||
                    disableBooking ||
                    due < 0 ||
                    !(
                      paymentInfo.length !== 0 &&
                      paymentInfo.filter((val: any) => val.isChecked === true)
                        .length > 0
                    ) ||
                    (validateHistoStatus && !biospyPackageName
                      ? true
                      : false) ||
                    (validateHistoStatus && !biospySampleName ? true : false) ||
                    (validateHistoStatus && !relevantClinicalHistory
                      ? true
                      : false) ||
                    isDuplicateTube
                  }
                >
                  Proceed for booking
                </Button>
                // add condition for tube err
              )}
            </div> */}
                        {coupleBookingAlert && !disableCoupleBookingTest ? (
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                <p>To book, add two members of opposite gender with the same package.</p>
                            </div>
                        ) : (
                            ""
                        )}
                        {barcodeLength.length > 0 ? (<div style={{ textAlign: "center", color: "red", fontWeight: "bold", fontSize: "large" }}>
                            <p> Barcode Minimum length must be 7!</p>
                        </div>) : ""}
                        <div className={classes.buttonContainer}>
                            {notificationData.centreType === "direct_client" ||
                                notificationData.centreType === "GE Lab" ? (
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    style={{ marginLeft: "1rem", marginBottom: "20px" }}
                                    disabled={loading || disableBooking || showBloodRelationError || barcodeLength.length > 0
                                        ||
                                        inputList.some((item: any) => item?.isEnableGenomicsFormButton && !item?.genomicsForm?.id) ||
                                        coupleBookingAlert && !disableCoupleBookingTest ||

                                        (validateBiomarkerLatestStatus && (
                                            inputList.some((item: any) => item?.isEnableBiomarker && !item?.bioMarkerFormData)
                                            // !inputList[0]?.bioMarkerFormData?.patient_details?.customer_dob ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.nature_of_conception ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.lmp_date ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.previous_history ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.present_pregnacy ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.other_history ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.date_of_usg ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.crl ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.attachment_one
                                        )) ||
                                        (validateQuadrupleForm &&
                                            (
                                                inputList.some((item: any) => item?.isEnableQuadruple && !item?.quadrupleFormData
                                                    //    inputList.some((item: any) => item?.isEnableQuadruple &&                 
                                                    // !item?.quadrupleFormData?.weight||
                                                    // !item?.quadrupleFormData?.lmp_date ||
                                                    // !item?.quadrupleFormData?.date_of_usg ||
                                                    // !item?.quadrupleFormData?.nature_of_conception||
                                                    // !item?.quadrupleFormData?.previous_history||
                                                    // !item?.quadrupleFormData?.present_pregnacy||
                                                    // !item?.quadrupleFormData?.crl ||
                                                    // !item?.quadrupleFormData?.attachment_one
                                                ))
                                        )
                                    }
                                >
                                    Proceed for booking
                                </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    style={{ marginLeft: "1rem", marginBottom: "20px" }}
                                    disabled={loading ||

                                        disableBooking || barcodeLength.length > 0 ||
                                        showBloodRelationError ||
                                        inputList.some((item: any) => item?.isEnableGenomicsFormButton && !item?.genomicsForm?.id) ||
                                        (validateHistoStatus && !biospyPackageName ? true : false) ||
                                        coupleBookingAlert && !disableCoupleBookingTest ||
                                        // (validateMaternalStatus === true && !dataMaternal.date_of_usg
                                        //   ? true
                                        //   : false) ||
                                        (validateHistoStatus && !relevantClinicalHistory
                                            ? true
                                            : false) ||
                                        (validateNbsStatus === true &&
                                            perPackNbs !== perPackArr?.length) ||
                                        (validateBiomarkerLatestStatus && (
                                            inputList.some((item: any) => item?.isEnableBiomarker && !item?.bioMarkerFormData)
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.nature_of_conception ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.lmp_date ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.previous_history ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.present_pregnacy ||
                                            // !inputList[0]?.bioMarkerFormData?.pregnancy_history_details?.other_history ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.date_of_usg ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.crl ||
                                            // !inputList[0]?.bioMarkerFormData?.ultrasound_details?.attachment_one
                                        )) ||
                                        (validateQuadrupleForm &&
                                            (
                                                // !inputList[0]?.quadrupleFormData?.weight||
                                                // !inputList[0]?.quadrupleFormData?.lmp_date ||
                                                // !inputList[0]?.quadrupleFormData?.date_of_usg ||
                                                // !(inputList[0]?.quadrupleFormData?.nature_of_conception)||
                                                // !inputList[0]?.quadrupleFormData?.previous_history||
                                                //  !inputList[0]?.quadrupleFormData?.present_pregnacy||
                                                // !inputList[0]?.quadrupleFormData?.crl ||
                                                // !inputList[0]?.quadrupleFormData?.attachment_one
                                                inputList.some((item: any) => item?.isEnableQuadruple && !item?.quadrupleFormData)
                                            )
                                        ) ||
                                        (validateNbsStatus === true &&
                                            perPackNbs !== perPackArr?.length) ||
                                        due < 0 ||
                                        !(
                                            paymentInfo.length !== 0 &&
                                            paymentInfo.filter((val: any) => val.isChecked === true)
                                                .length > 0
                                        )}
                                >
                                    Proceed for booking
                                </Button>

                            )}
                        </div>
                        {/* Location Map Modal  */}
                        <Dialog
                            open={openLocationModal}
                            onClose={() => setOpenLocationModal(false)}
                            aria-labelledby="form-dialog-title"
                            className={classes.dialog}
                        >
                            <DialogTitle id="form-dialog-title">Add New Address</DialogTitle>
                            <DialogContent>
                                <Grid
                                    container
                                    spacing={2}
                                    style={{
                                        margin: "0px 10px 10px 10px",
                                        minWidth: "500px",
                                        width: "70%",
                                    }}
                                >
                                    <Grid item xs={12} md={12}>
                                        <p>Locality</p>
                                        <Autocomplete
                                            id="colony-area-sector"
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    let obj = JSON.parse(
                                                        JSON.stringify(newValue, null, " ")
                                                    );
                                                    setMapAddressObject(obj);
                                                }
                                            }}
                                            options={suggestedAddress ? suggestedAddress : []}
                                            freeSolo
                                            blurOnSelect
                                            aria-required
                                            getOptionLabel={(option: any) =>
                                                `${option?.placeName}, ${option?.placeAddress}`
                                            }
                                            onInputChange={(event, newInputValue) => {
                                                locationAutoCompleteSearch(newInputValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    className="input"
                                                    {...params}
                                                    placeholder="Search Address"
                                                    variant="outlined"
                                                    style={{
                                                        width: "100%",
                                                        margin: "0",
                                                        padding: "0",
                                                        height: "40px",
                                                    }}
                                                    // disabled={collection_date === ""}
                                                    required
                                                />
                                            )}
                                        />
                                        <p style={{ color: "red" }}>{errorMessage}</p>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <p>Pin Code</p>
                                        <TextField
                                            className="input"
                                            name="zone"
                                            type="text"
                                            value={pincode || 0}
                                            disabled
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0", background: "#ccc" }}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <p>Area</p>
                                        <TextField
                                            className="input"
                                            name="zone"
                                            type="text"
                                            value={zoneName || ""}
                                            disabled
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0", background: "#ccc" }}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <p>House No./Plot No./Flat No./Door No./Shop/ c/o</p>
                                        <TextField
                                            className="input"
                                            name="zone"
                                            type="text"
                                            value={customer_address}
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0" }}
                                            required
                                            onChange={(e) =>
                                                setCustomer_address(e.target.value as string)
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <p>
                                            Apartment/Building /Colony/ Block/Sector/
                                            Street/Gali/Road/Chawl
                                        </p>
                                        <TextField
                                            className="input"
                                            name="zone"
                                            type="text"
                                            value={addressLine2 || ""}
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0" }}
                                            required
                                            onChange={(e) =>
                                                setAddressLine2(e.target.value as string)
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <p>Landmark/Sublocality</p>
                                        <TextField
                                            className="input"
                                            placeholder="Ex: School/College/Restaurant/Shop/Bank/Government Office"
                                            name="zone"
                                            type="text"
                                            value={favoritePlace || ""}
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0" }}
                                            required
                                            onChange={(e) =>
                                                setFavoritePlace(e.target.value as string)
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <p>City</p>
                                        <TextField
                                            className="input"
                                            name="city"
                                            type="text"
                                            value={customer_city}
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0", background: "#ccc" }}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={() => setOpenLocationModal(false)}
                                    color="primary"
                                    disabled={
                                        addressLine2 === "" ||
                                        customer_address === "" ||
                                        favoritePlace === ""
                                    }
                                >
                                    Select
                                </Button>
                                <Button
                                    onClick={() => setOpenLocationModal(false)}
                                    color="primary"
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openLoyaltyModal}
                            onClose={() => setOpenLoyaltyModal(false)}
                            aria-labelledby="form-dialog-title"
                            className={classes.dialog}
                        >
                            <DialogTitle id="form-dialog-title">
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div>Add VIP Membership</div>
                                    <div>
                                        <CloseIcon
                                            onClick={() => {
                                                setCheckedWay("");
                                                setRedProMembershipDiscountPercentage(0);
                                                setProMembershipPrice(0);
                                                setOpenLoyaltyModal(false);
                                            }}
                                        />
                                    </div>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <div className="checkList" style={{ display: "flex" }}>
                                            <div style={{}}>
                                                {leadSubscriptionsData?.count > 0 ? (
                                                    leadSubscriptionsData?.results.map((row: any) => (
                                                        <div style={{ paddingLeft: "20px" }}>
                                                            <input
                                                                value={row?.id}
                                                                type="checkbox"
                                                                checked={checkedWay == row?.id ? true : false}
                                                                onChange={(e) => {
                                                                    if (!e.target.checked) {
                                                                        setCheckedWay("");
                                                                        setRedProMembershipDiscountPercentage(0);
                                                                        setProMembershipPrice(0);
                                                                    } else {
                                                                        setCheckedWay(e.target.value);
                                                                        setRedProMembershipDiscountPercentage(10);
                                                                        setProMembershipPrice(
                                                                            row?.subscription_amount
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                            <span style={{ paddingLeft: "10px" }}>
                                                                <span
                                                                    style={{
                                                                        textDecoration: "line-through",
                                                                        fontSize: "20px",
                                                                    }}
                                                                >
                                                                    {row?.name?.slice(0, 6)}
                                                                </span>
                                                                <span style={{ color: "gray" }}>
                                                                    {row?.name?.slice(6, 17)}
                                                                </span>
                                                                <span style={{ fontSize: "20px" }}>
                                                                    {row?.name?.slice(17, 35)}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p
                                                        style={{
                                                            fontSize: "16px",
                                                            fontWeight: "700",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        Oops! As of now no subscriptions available.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </Grid>
                                    <DialogContentText id="alert-dialog-slide-description">
                                        <div style={{ margin: "1rem" }}>
                                            <div
                                                style={{
                                                    alignItems: "left",
                                                    display: "inline-block",
                                                    marginLeft: "1rem",
                                                    marginRight: "1rem",
                                                    marginBottom: "1rem",
                                                }}
                                            >
                                                <span>Benefits:</span>
                                                <small>
                                                    <ul style={{ paddingLeft: "15px" }}>
                                                        <li>
                                                            Users will get an additional 10% off on all
                                                            bookings.
                                                        </li>
                                                        <li>No convenience fee for Premium slots.</li>
                                                        <li>
                                                            Free report consultation from our doctors on
                                                            Priority.
                                                        </li>
                                                        <li>
                                                            100% cash back as Red cash on 1st booking and 5%
                                                            cashback on all subsequent bookings. (Which can be
                                                            used on all future bookings)
                                                        </li>
                                                        <li>24/7 Priority customer support.</li>
                                                        {/* <li>Free personalised Diet chart - over WhatsApp</li> */}
                                                    </ul>
                                                </small>
                                            </div>
                                        </div>
                                    </DialogContentText>
                                </Grid>
                            </DialogContent>
                            <DialogActions style={{ margin: "0px 10px 10px 0px" }}>
                                <Button
                                    variant="contained"
                                    style={{
                                        marginTop: "20px",
                                    }}
                                    color="primary"
                                    onClick={handleAddLoyalty}
                                    disabled={checkedWay === ""}
                                >
                                    ADD Membership
                                </Button>
                                <Button
                                    variant="contained"
                                    style={{
                                        marginTop: "20px",
                                        marginLeft: "10px",
                                    }}
                                    color="secondary"
                                    onClick={handleCanel}
                                    disabled={checkedWay === ""}
                                >
                                    Cancel Membership
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </form>
                </div>
                <SlidingPane
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={isPaneOpen}
                    title={singlePackage?.name}
                    width="80%"
                    from="right"
                    onRequestClose={() => {
                        setPaneOpen(false);
                    }}
                >
                    <div>
                        <iframe
                            src={singlePackage?.web_link}
                            style={{ width: "100%", height: "700px" }}
                            title="Iframe Example"
                        ></iframe>
                    </div>
                </SlidingPane>

                <Dialog
                    open={openMaternalForm}
                    onClose={() => setOpenMaternalForm(false)}
                    fullWidth
                    maxWidth="md"
                    disableEnforceFocus
                >



                </Dialog>



                <Dialog
                    open={openHistoryForm}
                    onClose={() => SetOpenHistoryForm(false)}
                    fullWidth
                    maxWidth="md"
                >


                </Dialog>
                <EstimateTestModel
                    openTestModal={openTestModal}
                    setopenTestModal={setopenTestModal}
                />

                <Dialog
                    open={openNbsModal}
                    onClose={() => setOpenNbsModal(false)}
                    fullWidth
                    maxWidth="xl"
                >

                </Dialog>
                <Dialog
                    open={openGutForm}
                    onClose={() => { setOpenGutForm(false) }}
                >
                    <div
                        style={{
                            padding: "20px 40px",
                            maxWidth: "600px",
                            background: "rgb(241, 241, 241)",
                            borderRadius: "20px"
                        }}>
                        <div>
                            <div style={{ display: "contents" }}>
                                <Typography variant="h6" style={{ fontSize: "2rem", marginBottom: "20px", marginTop: '20px', textAlign: 'center', width: "100%" }}>Gut MicroBiome Form </Typography>
                            </div>
                            <div>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }} id="demo-row-radio-buttons-group-label">1. Major Diet Type:</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={(e: any) => setDietType(e.target.value)}
                                            >
                                                <FormControlLabel value="vegetarian" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} name="vegetarian" checked={dietType === "vegetarian"} />}
                                                    label="Vegetarian" />
                                                <FormControlLabel value="vegetarian_egg" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} name="vegetarian_egg" checked={dietType === "vegetarian_egg"} />}
                                                    label="Vegetarian + Egg" />
                                                <FormControlLabel value="vegetarian_fish" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} name="vegetarian_fish" checked={dietType === "vegetarian_fish"} />}
                                                    label="Vegetarian + Fish" />
                                                <FormControlLabel value="non-vegetarian" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} name="non-vegetarian" checked={dietType === "non-vegetarian"} />}
                                                    label="Non-Vegetarian" />
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-row-radio-buttons-group-label">2. Do You Drink Alcohol ?</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={isDrinkAlcohol}
                                                onChange={(e) => setIsDrinkAlcohol(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} />} label="Yes" />
                                                <FormControlLabel value="no" style={{ marginLeft: "8%" }} control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)', } }} />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-row-radio-buttons-group-label">3. Do You Smoke ?</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={isSmoke}
                                                onChange={(e) => setIsSmoke(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} />} label="Yes" />
                                                <FormControlLabel value="no" style={{ marginLeft: "8%" }} control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)', } }} />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-row-radio-buttons-group-label">4. Do You Work-Out ?</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={isWorkout}
                                                onChange={(e) => setIsWorkout(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} />} label="Yes" />
                                                <FormControlLabel value="no" style={{ marginLeft: "8%" }} control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)', } }} />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>

                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-checkbox-group-label">
                                                5. Do You Have Any Diagnosed Illness?
                                            </FormLabel>
                                            {/* <FormGroup row
                      onChange={handleCheckboxChange}> */}
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={handleCheckboxChangeForm}
                                            >
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="anxiety"
                                                        checked={diagnosedIllness === "anxiety"} />}
                                                    value="anxiety"
                                                    label="Anxiety"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="arthritis"
                                                        checked={diagnosedIllness === "arthritis"} />} label="Arthritis"
                                                    value="arthritis"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="constipation"
                                                        checked={diagnosedIllness === "constipation"} />} label="Constipation"
                                                    value="constipation"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="diabetes"
                                                        checked={diagnosedIllness === "diabetes"} />} label="Diabetes"
                                                    value="diabetes"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="depression"
                                                        checked={diagnosedIllness === "depression"} />} label="Depression"
                                                    value="depression"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="heart_diseases"
                                                        checked={diagnosedIllness === "heart_diseases"} />} label="Heart Diseases"
                                                    value="heart_diseases"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="hypertension"
                                                        checked={diagnosedIllness === "hypertension"} />} label="Hypertension"
                                                    value="hypertension"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="inflammatory_bowel_disease"
                                                        checked={diagnosedIllness === "inflammatory_bowel_disease"} />} label="Inflammatory Bowel Disease"
                                                    value="inflammatory_bowel_disease"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="irritable_bowel_syndrome"
                                                        checked={diagnosedIllness === "irritable_bowel_syndrome"} />} label="Irritable Bowel Syndrome"
                                                    value="irritable_bowel_syndrome"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleCheckboxChange}
                                                        name="any_other_diseases"
                                                        checked={diagnosedIllness === "any_other_diseases"} />} label="Any Other Disease"
                                                    value="any_other_diseases"
                                                />
                                                {/* </FormGroup> */}
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>

                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>

                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-row-radio-buttons-group-label">6. Are you taking any medicines/drugs?
                                                (Kindly mention if you wish)</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                value={isMedicine}
                                                onChange={(e) => setIsMedicine(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)' } }} />} label="Yes" />
                                                <FormControlLabel value="no" style={{ marginLeft: "8%" }} control={<Radio sx={{ '&.Mui-checked': { color: 'rgb(146, 74, 145)', } }} />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                        <hr />
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto" }}>
                                        <FormControl style={{ width: "100%" }}>
                                            <FormLabel style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", }}
                                                id="demo-row-radio-buttons-group-label" >7. Please let us know your preferred meal type?</FormLabel>

                                            {/* <FormGroup row
                      onChange={handleMealType}
                    > */}
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={handleMealType}
                                            >
                                                {/* <FormControlLabel
                        control={<Checkbox
                          inputProps={{ 'aria-label': 'controlled' }}
                          icon={<RadioButtonUncheckedIcon />}
                          checkedIcon={<RadioButtonCheckedIcon />}
                          sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                          onChange={handleMealType}
                          name="none" />}
                        label="None"
                      /> */}
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleMealType}
                                                        name="continental"
                                                        checked={mealTypeData === "continental"} />}
                                                    value="continental"
                                                    label="Continental"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleMealType}
                                                        name="north_indian"
                                                        checked={mealTypeData === "north_indian"} />}
                                                    value="north_indian"
                                                    label="North Indian"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleMealType}
                                                        name="south_indian"
                                                        checked={mealTypeData === "south_indian"} />}
                                                    value="south_indian"
                                                    label="South Indian"
                                                />
                                                <FormControlLabel
                                                    control={<Radio
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        // icon={<RadioButtonUncheckedIcon />}
                                                        // checkedIcon={<RadioButtonCheckedIcon />}
                                                        sx={{ '& .MuiSvgIcon-root': { color: 'rgb(146, 74, 145)', borderRadius: "50%" } }}
                                                        // onChange={handleMealType}
                                                        name="south_east_asian"
                                                        checked={mealTypeData === "south_east_asian"} />}
                                                    value="south_east_asian"
                                                    label="South East Asian"
                                                />
                                            </RadioGroup>
                                            {/* </FormGroup> */}
                                        </FormControl>
                                        <hr />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: "10px auto", display: "flex" }}>
                                        <div style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", fontWeight: "700", width: "50%", }}>
                                            <p>8. Height (In feet) </p></div>
                                        <div style={{ width: "50%", height: "40px" }}>
                                            <TextField
                                                size="small"
                                                variant="outlined"
                                                value={height}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const numericRegex = /^([+-]?(\d+(\.\d*)?|\.\d+))$/
                                                    if (numericRegex.test(value) || value === "") {
                                                        setHeight(value);
                                                    }
                                                }}
                                                style={{ marginLeft: "10px", width: "100%", height: "100%" }}
                                            />

                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <div style={{ margin: " 10px auto", display: "flex" }}>

                                        <div style={{ color: "rgb(97 40 96)", fontSize: "1.1rem", letterSpacing: "1px", fontWeight: "700", width: "50%", }}>
                                            <p>9. Weight (In Kg.)</p> </div>
                                        <div style={{ width: "50%", height: "40px" }}>
                                            <TextField
                                                size="small"
                                                variant="outlined"
                                                value={weight}
                                                type="text"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const numericRegex = /^([+-]?(\d+(\.\d*)?|\.\d+))$/
                                                    if (numericRegex.test(value) || value === "") {
                                                        setWeight(value);
                                                    }
                                                }}
                                                style={{ marginLeft: "10px", width: "100%", height: "100%" }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </div>

                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                style={{ marginLeft: "auto", display: "bloAdd Reffering Doctorck", marginTop: "1rem" }}
                                disabled={dietType === "" || isDrinkAlcohol === "" || isSmoke === "" || isWorkout === "" ||
                                    isMedicine === "" || height === "" || weight === "" || diagnosedIllness === "" || mealTypeData === ""}
                                onClick={() => setOpenGutForm(false)}
                            >
                                Proceed For Booking
                            </Button>
                        </div>
                    </div >
                </Dialog >
            </main>

        </div>
    );
};
const mapStateToProps = (state: any) => ({
    campCoupon: state.OffLineSupporteReducer.campCoupon,
    refDoctor: state.OffLineSupporteReducer.refDoctor,
    centerInfo: state.OffLineSupporteReducer.centerInfo,
    pin_code: state.OffLineSupporteReducer.pin_code,
    packageList: state.OffLineSupporteReducer.packageList,
    couponList: state.OffLineSupporteReducer.couponList,
    createBooking: state.OffLineSupporteReducer.createBooking,
    get_leads_new: state.OffLineSupporteReducer.get_leads_new,
    lead_details: state.OffLineSupporteReducer.lead_details,
    loading: state.OffLineSupporteReducer.loading,
    checkGeoFenceStatus: state.OffLineSupporteReducer.checkGeoFenceStatus,
    redCoin: state.OffLineSupporteReducer.redCoin,
    geoFencesMapMyIndia: state.OffLineSupporteReducer.geoFencesMapMyIndia,
    mapmyindiaAccessToken: state.OffLineSupporteReducer.mapmyindiaAccessToken,
    getGeCode: state.OffLineSupporteReducer.getGeCode,
    clientLedgerBalance: state.OffLineSupporteReducer.clientLedgerBalance,
    packagesById: state.OffLineSupporteReducer.packagesById,
    userDetails: state.OffLineSupporteReducer.userDetails,
    tubePackageData: state.OffLineSupporteReducer.tubePackageData,
    validBarcode: state.OffLineSupporteReducer.validBarcode,
    add_unique_customer: state.OffLineSupporteReducer.add_unique_customer,
    familyMemberUpdateData: state.OffLineSupporteReducer.familyMemberUpdateData,
    crete_booking_new_flow: state.OffLineSupporteReducer.crete_booking_new_flow,
    validateBooking: state.OffLineSupporteReducer.validateBooking,
    packageQuestion: state.OffLineSupporteReducer.packageQuestion,
    leadSubscriptionsData: state.OffLineSupporteReducer.leadSubscriptionsData,
    checkSubscription: state.OffLineSupporteReducer.checkSubscription,
    validationResult: state.OffLineSupporteReducer.validationResult,
});

export default connect(mapStateToProps, {
    getPinCode,
    getPackage,
    getCoupons,
    createNewBooking,
    getLeadsNew,
    getLeadDetails,
    resetLeadDetails,
    checkGeoFenceArea,
    getRedCoing,
    getCenterInfo,
    checkGeoFenchMapMyIndia,
    getMapMyIndiaAccessToken,
    addUniqueCustomer,
    getUserDetails,

})(CCBookingIndexFour);